import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @description: CustonTrazabilidad
 * @author: Patricia Lopez Sanchez
 * @version: jdesk_1.01.0002
 **/
class CustomTrazabilidad extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                                               = this.initForm.bind(this);
        this.traerinformacion                                       = this.traerinformacion.bind(this);
        this.success_traerinformacion                               = this.success_traerinformacion.bind(this);
        this.pendientescartera                                      = this.pendientescartera.bind(this);
        this.success_pendientescartera                              = this.success_pendientescartera.bind(this);
        this.funcionQueSeEjecutaAlClick                             = this.funcionQueSeEjecutaAlClick.bind(this);
        this.gridOptionsComponentes1                                = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes3                                = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes2                                = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes4                                = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes5                                = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes6                                = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes7                                = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes8                                = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes9                                = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes10                               = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes11                               = Object.assign({}, this.gridOptions);//editar pedido
        this.onSelectionEditarPedido                                = this.onSelectionEditarPedido.bind(this);
        this.gridOptionsComponentes11["onSelectionChanged"]         = this.onSelectionEditarPedido;
        
        this.gridOptionsComponentesTrazReserva                               = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentesNovedades                               = Object.assign({}, this.gridOptions);
        this.gridOptionsItemsReservados                              = Object.assign({}, this.gridOptions);
        this.gridOptionsPedidosItemsReservados                              = Object.assign({}, this.gridOptions);
        this.gridOptionsWmsContados                               = Object.assign({}, this.gridOptions);
        this.gridOptionsWmsConteo                               = Object.assign({}, this.gridOptions);
        this.gridOptionsWms02                               = Object.assign({}, this.gridOptions);
        this.gridOptionsPendientes                              = Object.assign({}, this.gridOptions);
        this.gridOptionsAutorizadosInventario                              = Object.assign({}, this.gridOptions);
        this.gridOptionsItemsDigitar                              = Object.assign({}, this.gridOptions);
        this.cargarbodegas                                          = this.cargarbodegas.bind(this);
        this.success_cargarbodegas                                  = this.success_cargarbodegas.bind(this);
        this.AutorizadosCartera                                     = this.AutorizadosCartera.bind(this);
        this.success_AutorizadosCartera                             = this.success_AutorizadosCartera.bind(this);
        this.Consulta                                               = this.Consulta.bind(this);
        this.success_Consulta                                       = this.success_Consulta.bind(this);
        this.bodega                                                 = "";
        this.mensajepedido                                          = this.mensajepedido.bind(this);
        this.success_mensajepedido                                  = this.success_mensajepedido.bind(this);
        this.verItems                                               = this.verItems.bind(this);
        this.success_verItems                                       = this.success_verItems.bind(this);
        this.selectedRows                                           = [];
        this.selectedRows1                                          = [];
        this.selectedRows3                                          = [];
        this.selectedRows2                                          = [];
        this.currencyFormatterGeneral                               = this.currencyFormatterGeneral.bind(this);
        this.currencyFormatterGeneral4Decimales                     = this.currencyFormatterGeneral4Decimales.bind(this);
        this.currencyFormatterGeneral3Decimales                     = this.currencyFormatterGeneral3Decimales.bind(this);
        this.formatNumberSaldo                                      = this.formatNumberSaldo.bind(this);
        this.estadocuenta                                           = this.estadocuenta.bind(this);
        this.success_estadocuenta                                   = this.success_estadocuenta.bind(this);
        this.modificardetalle                                       = this.modificardetalle.bind(this);
        this.success_modificardetalle                               = this.success_modificardetalle.bind(this);
        this.modificardetalleCartera                                = this.modificardetalleCartera.bind(this);
        this.success_modificardetalleCartera                        = this.success_modificardetalleCartera.bind(this);
        this.modificadetalleitem                                    = this.modificadetalleitem.bind(this);
        this.success_modificardetalleitem                           = this.success_modificardetalleitem.bind(this);
        this.modificadetalleitemCartera                             = this.modificadetalleitemCartera.bind(this);
        this.success_modificardetalleitemCartera                    = this.success_modificardetalleitemCartera.bind(this);
        this.Items                                                  = this.Items.bind(this);
        this.success_Items                                          = this.success_Items.bind(this);
        this.Items1                                                 = this.Items1.bind(this);
        this.success_Items1                                         = this.success_Items1.bind(this);
        this.autorizar                                              = this.autorizar.bind(this);
        this.success_autorizar                                      = this.success_autorizar.bind(this);
        this.modificadetalle                                        = "";
        this.verpedidos                                             = this.verpedidos.bind(this);
        this.success_verpedidos                                     = this.success_verpedidos.bind(this);
        this.verpedidoAutorizar                                     = this.verpedidoAutorizar.bind(this);
        this.successpedidoAutorizar                                 = this.successpedidoAutorizar.bind(this);
        this.direccioncliente                                       = this.direccioncliente.bind(this);
        this.successdireccioncliente                                = this.successdireccioncliente.bind(this);
        this.traerciudad                                            = this.traerciudad.bind(this);
        this.successtraerciudad                                     = this.successtraerciudad.bind(this);
        this.modificadireccion                                      = this.modificadireccion.bind(this);
        this.success_modificadireccion                              = this.success_modificadireccion.bind(this);
        this.pendiente                                              = this.pendiente.bind(this);
        this.successPendiente                                       = this.successPendiente.bind(this);
        this.autorizarpedido                                        = this.autorizarpedido.bind(this);
        this.successAutorizarPedido                                 = this.successAutorizarPedido.bind(this);
        this.seleccionartodo                                        = this.seleccionartodo.bind(this);
        this.consultarpedido                                        = this.consultarpedido.bind(this);
        this.successconsultarpedido                                 = this.successconsultarpedido.bind(this);
        this.cantidadopcionesChange                                 = this.cantidadopcionesChange.bind(this);
        this.cambiarCantidad                                        = this.cambiarCantidad.bind(this);
        this.successCambiarCantidad                                 = this.successCambiarCantidad.bind(this);
        this.preciosinivaopcionesChange                             = this.preciosinivaopcionesChange.bind(this);
        this.successCambiarPrecioSinIva                             = this.successCambiarPrecioSinIva.bind(this);
        this.limpiarTablas                                          = this.limpiarTablas.bind(this);
        this.numeropedido                                           = 0;
        this.devolvercambiopedido                                   = this.devolvercambiopedido.bind(this);
        this.successdevolvercambio                                  = this.successdevolvercambio.bind(this);
        this.datosAntiguos                                          = [];
        this.SaldoCantidad                                          = this.SaldoCantidad.bind(this);
        this.successSaldoCantidad                                   = this.successSaldoCantidad.bind(this);
        this.successValidarCantidad                                 = this.successValidarCantidad.bind(this);
        this.grabareditarpedido                                     = this.grabareditarpedido.bind(this);
        this.successgrabareditarpedido                              = this.successgrabareditarpedido.bind(this);
        this.llenartipopicking                                      = this.llenartipopicking.bind(this);
        this.llevarApicking                                         = this.llevarApicking.bind(this);
        this.successLlevarAPicking                                  = this.successLlevarAPicking.bind(this);

        this.validarPermiso                                         = this.validarPermiso.bind(this);

        //asentados-contados son lo mismo
        this.ItemsContados                                         = this.ItemsContados.bind(this);
        this.successItemsContados                                  = this.successItemsContados.bind(this);
        this.modificardetalleitemsContados                          = this.modificardetalleitemsContados.bind(this);
        this.successModificarDetalleiIemsContados                   = this.successModificarDetalleiIemsContados.bind(this);
        this.successModificarDetalleContados                       = this.successModificarDetalleContados.bind(this);
        this.modificarDetalleContado                               = this.modificarDetalleContado.bind(this);
        this.traerAsentados                                             = this.traerAsentados.bind(this);
        this.successAsentados                                      = this.successAsentados.bind(this);
        this.mostrarMensajeGuardando                                      = this.mostrarMensajeGuardando.bind(this);
        this.mostrarMensajeAdicional                                      = this.mostrarMensajeAdicional.bind(this);

        this.gridOptionsAsentados                                  = Object.assign({}, this.gridOptions);
        this.gridOptionsResultPicking                                  = Object.assign({}, this.gridOptions);
        this.gridOptionsVerPicking                                 = Object.assign({}, this.gridOptions);
        this.gridOptionsItems                                 = Object.assign({}, this.gridOptions);
        this.gridOptionsConsultarModal                                 = Object.assign({}, this.gridOptions);
        this.gridOptionsRemision                                 = Object.assign({}, this.gridOptions);
        this.gridOptionsEnPicking                                 = Object.assign({}, this.gridOptions);
        this.gridOptionsModCantidadCombos                                 = Object.assign({}, this.gridOptions);

        this.onSelectionChangedVerPicking                                      = this.onSelectionChangedVerPicking.bind(this);
        this.gridOptionsResultPicking["onSelectionChanged"]            = this.onSelectionChangedVerPicking;
        this.mostrarPicking           = this.mostrarPicking.bind(this);
        this.successMostrarPicking           = this.successMostrarPicking.bind(this);
        this.successModificarOperario           = this.successModificarOperario.bind(this);
        this.modificarOperario           = this.modificarOperario.bind(this);
        this.mostrarMensajeGenerando                                      = this.mostrarMensajeGenerando.bind(this);
        this.mostrarMensajeNoHayDatos                                      = this.mostrarMensajeNoHayDatos.bind(this);

        //remisionar
        this.successDevolverPedido                                      = this.successDevolverPedido.bind(this);
        this.devolverPedido                                      = this.devolverPedido.bind(this);
        this.preguntarDevolver                                      = this.preguntarDevolver.bind(this);
        this.preguntarAnexos                                      = this.preguntarAnexos.bind(this);
        this.successRemisionar                                      = this.successRemisionar.bind(this);
        this.remisionar                                      = this.remisionar.bind(this);

        //facturar
        this.pendienteContados                                      = this.pendienteContados.bind(this);
        this.successPendienteContados                                      = this.successPendienteContados.bind(this);

        this.guardarExportacion                                      = this.guardarExportacion.bind(this);
        this.successGuardarExportacion                                      = this.successGuardarExportacion.bind(this);
        this.calcularCambio                                      = this.calcularCambio.bind(this);
        this.successGuardarPago                                      = this.successGuardarPago.bind(this);
        this.guardarPago                                      = this.guardarPago.bind(this);
        this.pedirPago                                      = this.pedirPago.bind(this);
        this.successpedirPago                                      = this.successpedirPago.bind(this);
        this.successGuardarPuntos                                      = this.successGuardarPuntos.bind(this);
        this.guardarPuntos                                      = this.guardarPuntos.bind(this);

        this.successTraerInfoPuntos                                      = this.successTraerInfoPuntos.bind(this);
        this.traerInfoPuntos                                      = this.traerInfoPuntos.bind(this);
        this.preguntarImprimirDescuentos                                      = this.preguntarImprimirDescuentos.bind(this);
        this.successFacturar                                      = this.successFacturar.bind(this);
        this.facturar                                      = this.facturar.bind(this);
        this.traerTrmCostaRica                                      = this.traerTrmCostaRica.bind(this);
        this.traerTrmCop                                      = this.traerTrmCop.bind(this);
        this.successTraerTrm                                      = this.successTraerTrm.bind(this);
        
        //trazabilidad reservado
        this.trazabiliaReserva                                      = this.trazabiliaReserva.bind(this);
        this.success_TrazabilidadReserva                                      = this.success_TrazabilidadReserva.bind(this);
        this.ver_detalle                                      = this.ver_detalle.bind(this);

        //novedades
        this.successTraernovedades                                      = this.successTraernovedades.bind(this);
        this.Traernovedades                                      = this.Traernovedades.bind(this);
        this.mostrarTrazabilidadReserva                                      = this.mostrarTrazabilidadReserva.bind(this);
        this.ocultarContados                                      = this.ocultarContados.bind(this);
        this.ocultarConsulta                                      = this.ocultarConsulta.bind(this);
        this.ocultarWmsContados                                      = this.ocultarWmsContados.bind(this);
        this.ocultarWms02                                      = this.ocultarWms02.bind(this);
        this.ocultarTrazabilidadReserva                                      = this.ocultarTrazabilidadReserva.bind(this);
        this.mostrarNovedades                                      = this.mostrarNovedades.bind(this);
        this.ocultarNovedades                                      = this.ocultarNovedades.bind(this);
        this.validarfechasNovedades                                      = this.validarfechasNovedades.bind(this);
        this.successItemsNovedades                                      = this.successItemsNovedades.bind(this);
        this.ItemsNovedadesPedido                                      = this.ItemsNovedadesPedido.bind(this);
        this.ItemsNovedades                                      = this.ItemsNovedades.bind(this);
        
        //apartado wmscontados
        this.consultarPedidosWms02                                      = this.consultarPedidosWms02.bind(this);
        this.successConsultarPedidosWms02                                      = this.successConsultarPedidosWms02.bind(this);
        this.successActualizarConteo                                      = this.successActualizarConteo.bind(this);
        this.actualizarConteo                                      = this.actualizarConteo.bind(this);
        this.successWMSContados                                      = this.successWMSContados.bind(this);
        this.consultarContadosWMS                                      = this.consultarContadosWMS.bind(this);
        this.successConsultarContadosWMS                                      = this.successConsultarContadosWMS.bind(this);
        this.wmsContados                                      = this.wmsContados.bind(this);
        
        //apartado en picking
        this.traerPendientes                                      = this.traerPendientes.bind(this);
        this.successTraerPendientes                                      = this.successTraerPendientes.bind(this);
        this.successVerPicking                                      = this.successVerPicking.bind(this);
        this.verPicking                                      = this.verPicking.bind(this); 

        this.ItemsEnPicking                                      = this.ItemsEnPicking.bind(this);
        this.successItemsEnPicking                                      = this.successItemsEnPicking.bind(this);
        this.modificardetalleitemsEnPicking                                      = this.modificardetalleitemsEnPicking.bind(this);
        this.successModificardetalleitemsEnPicking                                      = this.successModificardetalleitemsEnPicking.bind(this); 
        this.prepararReimprimir                                      = this.prepararReimprimir.bind(this);
        this.successPrepararEnPicking                                      = this.successPrepararEnPicking.bind(this); 
        this.enviarNovedad                                      = this.enviarNovedad.bind(this); 
        this.successEnviarNovedad                                      = this.successEnviarNovedad.bind(this); 

        this.successCerrarPicking                                      = this.successCerrarPicking.bind(this);
        this.cerrarPicking                                      = this.cerrarPicking.bind(this); 
        this.successSacarPedido                                      = this.successSacarPedido.bind(this); 
        this.sacarPedido                                      = this.sacarPedido.bind(this); 



        this.successmodificarBodega                                      = this.successmodificarBodega.bind(this);
        this.modificarBodega                                      = this.modificarBodega.bind(this); 
        this.successTraerItemsCombos                                      = this.successTraerItemsCombos.bind(this); 
        this.traerItemsCombos                                      = this.traerItemsCombos.bind(this); 
        this.successModificarCantidadConteo                                      = this.successModificarCantidadConteo.bind(this);
        this.modificarCantidadConteo                                      = this.modificarCantidadConteo.bind(this); 
        this.successModificarDetalleDigitar                                      = this.successModificarDetalleDigitar.bind(this); 
        this.modificarDetalleDigitar                                      = this.modificarDetalleDigitar.bind(this); 

        this.successAsentarCantidadess                                      = this.successAsentarCantidadess.bind(this); 
        this.asentarCantidades                                      = this.asentarCantidades.bind(this);
        this.asentarCantidadesPag                                      = this.asentarCantidadesPag.bind(this);
        this.validarRangos                                      = this.validarRangos.bind(this);
        this.validarPedidoRangos                                      = this.validarPedidoRangos.bind(this);
        this.successCerrarUno                                      = this.successCerrarUno.bind(this); 
        this.cerrarUno                                      = this.cerrarUno.bind(this); 

        this.funcionesTablaMultiCheck                                      = this.funcionesTablaMultiCheck.bind(this); 

        this.row_en_picking= [];
        this.row_ver_picking= [];
        this.row_asentados= [];
        this.row_items = [];
        this.wms_nuevo='';
        this.sucursal_ingreso='';
        this.xestado=''; //tabla del visor
        this.encargado='';
        this.sede_encargado='';
        this.nombre_encargado='';
        this.pide_encargado=false;
        this.consecutivo_picking='';
        this.operacion_actual='';
        this.nombre_archivo='';
        this.boton='';
        this.tipo_picking='';
        this.arrayDataCheckBox=[];
        this.titulo='';
        this.turnos='';
        this.picking_reserva='';
        this.estado_pedido='';
        this.estado_pedido_2='';

        this.vendedor='';
        this.fecha_corte='';
        this.hora_corte='';
        this.turno='';
        this.abre_modal_picking=true;
        //permisos
        this.TRAZTRA='';
        this.TRAZREM='';
        this.TRAZFACT='';
        //permisos
        this.TRAZDEVOL='';
        this.TRAZLLPICK='';
        this.TRAZRETORNRES='';
        this.TRAZCONSURESE='';
        this.TRAZITEMS='';
        this.TRAZMODDET='';
        this.TRAZCANTPT='';
        this.TRAZCANTPP='';
        this.TRAZCERUNO='';
        this.TRAZREIMP='';
        this.TRAZCMDIR='';
        this.TRAZNOVEDAD='';
        this.smartvv='';
        this.TRAZRECONTAR='';
        this.TRAZ001='';
        this.TRAZ002='';
        this.TRAZ003='';
        this.TRAZ004='';



        this.para_despachar_automatico='';
        this.prop_para_despachar='';
        this.para_despachar='';
        this.fecha_trasladar='';
        this.consecutivo_trasladar='';
        this.codigo_sucursal_trasladar='';
        this.tasa_de_cambio='';
        this.moneda_estandar='';//para mantener este valor
        this.moneda_estandar_aux='';
        this.moneda='';
        this.enviar_anexos=false;
        this.nueva_orden='';
        this.factor=0;
        this.tipo_moneda='';
        this.pedir_flete='';//remisionar
        this.pedir_flete_facturar='';
        this.aviso_de_recibo='';
        this.xfletes='';
        this.boton_seleccionado='';
        this.numero_de_recibo='';
        this.numero_de_factura='';
        this.observacion_factura='';
        this.fecha_vencimiento_picking='';

        this.imprimir_descuento_en_observacion='';


        this.modal_exportacion=false
        this.articulo_anexo='';
        this.sucursal='';
        this.fecha='';
        this.consecutivo='';
        this.codigo_facturacion='';
        this.trm_final='';
        this.npedido='';

        ///imprimir
        this.sucessTraerDatos                                             = this.sucessTraerDatos.bind(this);
        this.sucessTraerDatosTraslado                                             = this.sucessTraerDatosTraslado.bind(this);
        this.generarModalLista                                      = this.generarModalLista.bind(this);
        this.mostrarMensajeEmailFallo                                      = this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                                      = this.mostrarMensajeEmailEnviado.bind(this);
        this.successEnviarCorreo                                             = this.successEnviarCorreo.bind(this);
        this.enviarCorreoTerceros                                      = this.enviarCorreoTerceros.bind(this);
        this.isJson                                      = this.isJson.bind(this);
        this.generarPdfTabla3                                      = this.generarPdfTabla3.bind(this);
        this.abrirImprimir                                      = this.abrirImprimir.bind(this);
        this.generarExcelTabla3                                      = this.generarExcelTabla3.bind(this);
        this.habilitarCorreo = this.habilitarCorreo.bind(this);
        this.deshabilitarCorreo = this.deshabilitarCorreo.bind(this);

        this.llevarARePiking                                      = this.llevarARePiking.bind(this);
        this.validarfechas                                      = this.validarfechas.bind(this);
        this.sucessTraerDatosRemision                                      = this.sucessTraerDatosRemision.bind(this);
        this.sucessTraerDatosFactura                                      = this.sucessTraerDatosFactura.bind(this);
        this.recargarInfo                                      = this.recargarInfo.bind(this);
        this.ocultarEnPicking                                      = this.ocultarEnPicking.bind(this);
        this.mostrarEnPicking                                      = this.mostrarEnPicking.bind(this);

        

        this.successTraerDatosBodegas                                      = this.successTraerDatosBodegas.bind(this);
        this.traerDatosBodegas                                      = this.traerDatosBodegas.bind(this);
        this.traerDatosFletes                                      = this.traerDatosFletes.bind(this);
        this.successTraerDatosFletes                                      = this.successTraerDatosFletes.bind(this);
        this.trasladar                                      = this.trasladar.bind(this);
        this.successTrasladar                                      = this.successTrasladar.bind(this);
        this.procesarImprimir                                      = this.procesarImprimir.bind(this);

        //apartado autorizados inventario
        this.traerAutorizadosInventario                                      = this.traerAutorizadosInventario.bind(this);
        this.successTraerAutorizadosInventario                                      = this.successTraerAutorizadosInventario.bind(this);
        this.mostrarAutorizadosInventario                                      = this.mostrarAutorizadosInventario.bind(this);
        this.ocultarAutorizadosInventario                                      = this.ocultarAutorizadosInventario.bind(this);
        this.modificarDetalleAutorizadosInventario                                      = this.modificarDetalleAutorizadosInventario.bind(this);
        this.successModificarDetalleAutorizadosInventario                                      = this.successModificarDetalleAutorizadosInventario.bind(this);
        this.pendienteAutorizadosInventario                                      = this.pendienteAutorizadosInventario.bind(this);
        this.successPendienteAutorizadosInventario                                      = this.successPendienteAutorizadosInventario.bind(this);
        this.ItemsAutorizadosInventario                                      = this.ItemsAutorizadosInventario.bind(this);
        this.successItemsAutorizadosInventario                                      = this.successItemsAutorizadosInventario.bind(this);
        this.modificarDetalleAutorizadosInventarioItems                                      = this.modificarDetalleAutorizadosInventarioItems.bind(this);
        this.successModificarDetalleAutorizadosInventarioItems                                      = this.successModificarDetalleAutorizadosInventarioItems.bind(this);

        this.successAutorizarInventario                                      = this.successAutorizarInventario.bind(this);
        this.autorizarInventario                                      = this.autorizarInventario.bind(this);
        this.habilitarBotonesAdicionales                                      = this.habilitarBotonesAdicionales.bind(this);
        
        
        this.successReasignar                                      = this.successReasignar.bind(this);
        this.reasignar                                      = this.reasignar.bind(this);
        this.successRetornarReservaPedido                                      = this.successRetornarReservaPedido.bind(this);
        this.retornarReservaPedido                                      = this.retornarReservaPedido.bind(this);
        this.successVerPedidoReservado                                      = this.successVerPedidoReservado.bind(this);
        this.verPedidoReservado                                      = this.verPedidoReservado.bind(this);
        this.successRetornarItem                                      = this.successRetornarItem.bind(this);
        this.retornarItem                                      = this.retornarItem.bind(this);
        this.successTraerItemsReserva                                      = this.successTraerItemsReserva.bind(this);
        this.traerItemsReserva                                      = this.traerItemsReserva.bind(this);
        this.successRetornarReservao                                      = this.successRetornarReservao.bind(this);
        this.retornarReserva                                      = this.retornarReserva.bind(this);
        this.validarfechasEditarPedido                                      = this.validarfechasEditarPedido.bind(this);
        this.successTraerInfoSucursal                                      = this.successTraerInfoSucursal.bind(this);
        this.traerInfoSucursal                                      = this.traerInfoSucursal.bind(this);



        this.validarCliente                                      = this.validarCliente.bind(this);
        this.successValidarCliente                                      = this.successValidarCliente.bind(this);
        this.autorizarModulo                                      = this.autorizarModulo.bind(this);
        this.successAutorizarModulo                                      = this.successAutorizarModulo.bind(this);

        //variables  axuliares a la hora de imprimir
        //remisiones
        this.articulo_anexo='';
        this.sucursal='';
        this.fecha='';
        this.consecutivo='';
        this.codigo_facturacion='';
        this.repiking=false;
        

        //apartado de trabibilidad reserva
        this.pedido_consulta='';
        this.row_trazabilidadReserva = []
        this.bt_consulta='';
        
        //apartado de novedades
        this.row_novedades = []
        this.fecha_hoy='';

        //apartadowms contados
        this.row_wms_contados = []

        //apartado en picking
        this.traer_bodegas_opcion='';
        this.row_pendientes = []
        this.row_items_digitar = [];
        this.reimprimir=false;
        this.tipo_picking='';
        this.numero_picking='';
        this.repiking=false;
        this.sacar_pedido=false;
        this.bodega_aux='';
        this.poner_bodega_actual=false;

        //apartado AUTORIZADOS INVENTARIO
        this.row_autorizados_inventario = []
        // Array para almacenar los registros seleccionados
        this.selectedRowsArray = [];
        this.selectedRowsArrayAux = [];
        this.selectedRows2=[];
        this.accion_panel='';
        this.accion_detalle=''
        this.row_items_reservados=[];
        this.autorizados_inventario=false;

        //adicionales pendientes cartera
        this.autoriza_descuento=false;
        this.autoriza_costo=false;
        this.props={};
        this.props_principales={};

        this.modulo='FACTURACION';
        this.tipo='';

        this.tasa_cambio='';
        this.elvalor='';
        this.precio_inicial='';
        this.fecha_hora=new Date();
    }

    initForm() {
        console.log("Formulario CustomTrazabilidad,  @version: jdesk_1.01.0009.4, @author: Anderson Acevedo, Fecha de Modificación: 08/07/2025");
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.getField("sucursal").setValue(this.sucursal_ingreso);
        this.traerInfoSucursal();
        this.codigo_usuario = JSON.parse(localStorage.getItem('res')).codigo;

        let hoy = new Date();
        let dia = hoy.getDate();
        let mes = hoy.getMonth() + 1;
        let año = hoy.getFullYear();
        if (mes < 10) {
            mes = '0' + mes;
        }
        if (dia < 10) {
            dia = '0' + dia;
        }
        this.fecha_hoy = año + '-' + mes + '-' + dia;

        this.traerinformacion();

        this.getField("TabJaivana_" +265).setClickTab(this.funcionQueSeEjecutaAlClick);
        

        //modal autoriza
        this.getField("aceptar4").setClick(()=>{
            if(this.getField("numero_autorizacion").valid())
                this.autorizarModulo();
        });

        this.getField("cancelar7").setClick(()=>{
            this.getField("modal_pedir_autorizacion").handleClose();
        });

        this.getField('modal_pedir_autorizacion').setCloseButton(()=>{
            if(!this.va_a_autorizar)//si se cerro la modal sin autorizar refresca la tabla
                this.consultarpedido();
        });

        this.getField("texto_detalle").setOnBlur(()=>{
            if(this.getField("texto_detalle").getValue()===''){
                this.getField("texto_detalle").setValue('.');
                this.getField("texto_detalle").setError(false,'');
            }
        });

        this.getField("aceptar").setClick(()=>{
            if(this.getField("bodegas").valid()){
                if(this.traer_bodegas_opcion==='cartera'){
                    this.bodega = this.getField("bodegas").getValue()
                    this.AutorizadosCartera();
                }else if(this.traer_bodegas_opcion==='picking'){
                    this.bodega = this.getField("bodegas").getValue()
                    this.traerPendientes();
                }else if(this.traer_bodegas_opcion==='digitar'){
                    //esto solo para no modificar la bodega general
                    this.bodega_aux=this.getField("bodegas").getValue();
                    this.modificarBodega();
                }else if(this.traer_bodegas_opcion==='autorizados_inventario'){
                    this.bodega = this.getField("bodegas").getValue()
                    this.traerAutorizadosInventario();
                }
            }
        });

        this.getField("cancelar").setClick(()=>{
            this.getField("modal_elegir_bodega").handleClose();
        });

        this.getField("modal_elegir_bodega").setCloseButton(()=>{
            //this.bodega = "";
        });

        this.getField("modal_editar_pedido").setCloseButton(()=>{
            if(this.salir === false){
                this.devolvercambiopedido();
            }
        });

        this.getField("aceptar1").setClick(()=>{
            if(this.getField("pedido_consulta").valid()){
                if(this.bt_consulta==='consulta'){
                    this.pedido_consulta = this.getField("pedido_consulta").getValue();
                    this.Consulta();
                }else{
                    this.pedido_consulta = this.getField("pedido_consulta").getValue();
                    this.trazabiliaReserva();
                }
            }
        });

        this.getField("cancelar1").setClick(()=>{
            this.getField("modal_pedido_consulta").handleClose();
        });
        
        this.getField("ver_items").setClick(()=>{
            if(this.selectedRows.length > 0){
                this.getField("modal_ver_items").handleClickOpen();
                this.getField('modal_ver_items').setLabel("Pedido No. "+this.selectedRows[0].pedido)
                this.verItems();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("autorizar").setClick(()=>{
            if(this.selectedRows1.length > 0){
                this.autorizar();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });
        
        this.getField("items").setClick(()=>{
            if(this.selectedRows1.length > 0){
                this.getField('modal_ver_items').setLabel("Pedido No. "+this.selectedRows1[0].numero + " Cliente: " + this.selectedRows1[0].nit + " Sede " + this.selectedRows1[0].sede + " " + this.selectedRows1[0].nombre + " Valor: $"+this.currencyFormatterGeneral(this.selectedRows1[0].valor))
                this.Items();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("items1").setClick(()=>{
            if(this.selectedRows2.length > 0){
                this.getField('modal_ver_items').setLabel("Pedido No. "+this.selectedRows2[0].numero + " Cliente: " + this.selectedRows2[0].nit + " Sede " + this.selectedRows2[0].sede + " " + this.selectedRows2[0].nombre + " Valor: $"+this.currencyFormatterGeneral(this.selectedRows2[0].valor))
                this.Items1();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_asentado_items").setClick(()=>{
            if(this.row_asentados.length > 0){
                this.getField('modal_ver_items').setLabel("Pedido No. "+this.row_asentados[0].numero + " Cliente: " + this.row_asentados[0].nit + " Sede " + this.row_asentados[0].sede + " " + this.row_asentados[0].nombre + " Valor: $"+this.currencyFormatterGeneral(this.row_asentados[0].valor))
                this.ItemsContados();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });
        
        this.getField("ver_pedidos").setClick(()=>{
            if(this.selectedRows1.length > 0){
                this.getField('modal_ver_items').setLabel("Pedido No. "+this.selectedRows1[0].numero + " Cliente: " + this.selectedRows1[0].nit + " Sede " + this.selectedRows1[0].sede + " " + this.selectedRows1[0].nombre + " Valor: $"+this.currencyFormatterGeneral(this.selectedRows1[0].valor))
                this.verpedidoAutorizar();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("cliente").setClick(()=>{
            if(this.selectedRows1.length > 0){
                this.getField("modal_clientes").handleClickOpen();
                this.getField('modal_clientes').setLabel("Cartera y Pedidos Pendientes - "+this.selectedRows1[0].nit +" "+this.selectedRows1[0].sede +" "+ this.selectedRows1[0].nombre)
                this.estadocuenta();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("detalle").setClick(()=>{
            if(this.selectedRows1.length > 0){
                this.modificadetalle="DP";
                this.getField("modal_detalle").handleClickOpen();
                this.getField('modal_detalle').setLabel("Pedido No. "+this.selectedRows1[0].numero +" Fecha: "+this.selectedRows1[0].fecha)
                this.getField("fdespacho").setValue(this.selectedRows1[0].fecha_entrega);
                this.getField("texto_detalle").setValue(this.selectedRows1[0].detalle);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("detalle1").setClick(()=>{
            if(this.selectedRows2.length > 0){
                this.modificadetalle="DA";
                this.getField("modal_detalle").handleClickOpen();
                this.getField('modal_detalle').setLabel("Pedido No. "+this.selectedRows2[0].numero +" Fecha: "+this.selectedRows2[0].fecha)
                this.getField("fdespacho").setValue(this.selectedRows2[0].fecha_entrega);
                this.getField("texto_detalle").setValue(this.selectedRows2[0].detalle);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_asentado_detalle").setClick(()=>{
            if(this.row_asentados.length > 0){
                this.modificadetalle="DCONTADOS";
                this.getField("modal_detalle").handleClickOpen();
                this.getField('modal_detalle').setLabel("Pedido No. "+this.row_asentados[0].numero +" Fecha: "+this.row_asentados[0].fecha)
                this.getField("fdespacho").setValue(this.row_asentados[0].fecha_entrega);
                this.getField("texto_detalle").setValue(this.row_asentados[0].detalle);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("cancelar4").setClick(()=>{
            this.getField("modal_detalle").handleClose();
        });

        this.getField("cancelar5").setClick(()=>{
            this.getField("detalle_autorizar").handleClose();
        });

        this.getField("modificar").setClick(()=>{
            if(this.getField('texto_detalle').valid()){
                if(this.modificadetalle === "DIP"){
                    this.modificadetalleitem();
                }else if(this.modificadetalle === "DP"){
                    this.modificardetalle();
                }else if(this.modificadetalle === "DIA"){
                    this.modificadetalleitemCartera();
                }else if(this.modificadetalle === "DA"){
                    this.modificardetalleCartera();
                }else if(this.modificadetalle === "DCONTADOS"){
                    this.modificarDetalleContado();
                }else if(this.modificadetalle === "DICONTADOS"){
                    this.modificardetalleitemsContados();
                }else if(this.modificadetalle === "DIENPICKING"){
                    this.modificardetalleitemsEnPicking();
                }else if(this.modificadetalle === "DIDIGITAR"){
                    this.modificarDetalleDigitar();
                }else if(this.modificadetalle === "DAINVENTARIO"){
                    this.modificarDetalleAutorizadosInventario();
                }else if(this.modificadetalle === "DIAINVENTARIO"){
                    this.modificarDetalleAutorizadosInventarioItems();
                }
            }
        });

        this.getField("modificar_detalle").setClick(()=>{
            if(this.selectedRows.length > 0){
                this.getField("modal_detalle").handleClickOpen();
                this.getField('modal_detalle').setLabel("TRAZABILIDAD DE PEDIDOS")
                this.getField("texto_detalle").setValue(this.selectedRows[0].detalle)
                this.getField("fdespacho").setValue(this.selectedRows[0].fdespacho)
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("direccion").setClick(()=>{
            if(this.selectedRows1.length > 0){
                this.direccioncliente();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("salir").setClick(()=>{
            if(this.selectedRows3.length>0){
                this.getField('confirmModalCustom').setTitleAndContent('Trazabilidad', "No se han guardado los cambios. ¿Desea salir?");
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); this.getField("modal_direccion").handleClose(); });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.getField("modal_direccion").handleClose()
            }
        });

        this.getField("cambiar_direccion").setClick(()=>{
            if(this.selectedRows3.length > 0){
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', "Este proceso modificará el pedido original, desea continuar?");
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    this.modificadireccion();
                 });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);
               
            }else{
                this.alertGeneral.toggle(true, 'Seleccione un registro de la rejilla para cargar la dirección.', 'error');
            }
        });

        this.getField("pendiente").setClick(()=>{ //autorizados cartera
            if(this.selectedRows2.length > 0){
                this.getField('confirmModalCustom').setTitleAndContent('Pedidos', "¿Confirma que desea devolver el pedido "+this.selectedRows2[0].numero+" al estado pendiente?");
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    this.pendiente(); });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_asentado_pendiente").setClick(()=>{
            if(this.row_asentados.length > 0){
                this.getField('confirmModalCustom').setTitleAndContent('Pedidos', "¿Confirma que desea devolver el pedido "+this.row_asentados[0].numero+" al estado pendiente?");
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    this.pendienteContados(); });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("autorizar1").setClick(()=>{
            if(this.getField("detalle_autorizado").valid()){
                if(this.accion_detalle==='autorizar_inventario')
                    this.autorizarInventario();
                else
                    this.autorizarpedido();
            }
        });

        this.getField("aceptar5").setClick(()=>{
            if(this.getField("fentrega").getValue() !== "" && this.getField("fvalidez").getValue() !== "" &&
            this.getField("tipopedido").valid() && this.getField("orden").valid()){
                if(this.validarfechasEditarPedido())
                    this.grabareditarpedido();
            }
        });
        

        this.getField("fentrega").setOnChange(()=>{
            this.validarfechasEditarPedido();
        });

        this.getField("fvalidez").setOnChange(()=>{
            this.validarfechasEditarPedido();
        });

        this.getField("codigo_sucursal").setOnChange(()=>{
            this.getField('nombre_sucursal').setError(false,'');
            if(!this.getField("nombre_sucursal").valid())
                this.getField('TabJaivana_265').setTabNumber(1);
                this.getField('titulo').setValue('')
        });


        this.getField("editar_pedido").setClick(()=>{
            if(this.selectedRows1.length > 0){
                this.consultarpedido();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("seleccionar_registro").setClick(this.seleccionartodo);
        
        this.getField("llevar_picking").setClick(()=>{
            if(this.selectedRowsArray.length > 0){
                this.estado_pedido='01'; //autorizado
                this.abre_modal_picking=true;
                this.repiking=false;
                this.sacar_pedido=false;
                this.llenartipopicking();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("vendedor_nombre").setDisabled(true);
        this.getField("nombre_turno").setDisabled(true);


        this.getField('tipo_picking').setOnChange(()=>{
            if(this.getField('tipo_picking').getValue() === 'P' || this.getField('tipo_picking').getValue() === ''){
                this.getField("vendedor").setDisabled(true);
                this.getField("fecha_corte").setDisabled(true);
                this.getField("hora_corte").setDisabled(true);
                this.getField("turno").setDisabled(true);
            }else{
                this.getField("vendedor").setDisabled(false);
                this.getField("fecha_corte").setDisabled(false);
                this.getField("hora_corte").setDisabled(false);
                this.getField("turno").setDisabled(false);
            }
            this.getField("vendedor").setValue('');
            this.getField("fecha_corte").setValue('');
            //hora--->
            this.fecha_hora=new Date();
            this.getField("hora_corte").setValue(this.fecha_hora.getHours()+':'+this.fecha_hora.getMinutes()+' '+(this.fecha_hora.getHours() >= 12 ? 'pm' : 'am'));
            this.getField("turno").setValue('');
            this.getField("vendedor_nombre").setValue('');
            this.getField("nombre_turno").setValue('');

            this.getField("vendedor").setError(false,'');
            this.getField("fecha_corte").setError(false,'');
            this.getField("hora_corte").setError(false,'');
            this.getField("turno").setError(false,'');
            this.getField("vendedor_nombre").setError(false,'');
            this.getField("nombre_turno").setError(false,'');


        });

        this.getField("cancelar6").setClick(()=>{
            this.getField("modal_picking").handleClose();
        });

        this.getField("aceptar3").setClick(()=>{
            this.llevarApicking();
        });

        //encargado
        this.getField("cancelar_encargado").setClick(()=>{
            this.getField("modal_encargado").handleClose();
        });

        this.getField('sede_encargado').setOnChange(()=>{
            this.getField('sede_encargado').setError(false,'');
            this.getField('encargado').setError(false,'');
            this.getField('nombre_encargado').setError(false,'');
        });

        this.getField("aceptar_encargado").setClick(()=>{
                if(this.getField('encargado').valid() && this.getField('sede_encargado').valid() 
                    && this.getField('nombre_encargado').valid()){
                this.encargado=this.getField('encargado').getValue();
                this.sede_encargado=this.getField('sede_encargado').getValue();
                this.nombre_encargado=this.getField('nombre_encargado').getValue();
                this.getField("modal_encargado").handleClose();
                if(this.reimprimir){
                    this.prepararReimprimir();
                }else{
                    //asentados  -- opcion por pedido
                    this.mostrarMensajeGuardando();
                    let datos = { datos: {
                        tipo_picking:this.tipo_picking,
                        items: this.selectedRowsArray,
                        sucursal_ingreso:this.sucursal_ingreso,
                        sucursal:this.getField('sucursal').getValue(),
                        conservar_conteo:this.conservar_conteo,
                        xestado:this.xestado,
                        bodegas:this.bodega,
                        repiking :this.repiking,
                    }};
                    if(this.pide_encargado){
                        datos.datos.encargado=this.encargado;
                        datos.datos.sede_encargado=this.sede_encargado;
                        datos.datos.nombre_encargado=this.nombre_encargado;
                    }
                    if(this.abre_modal_picking){//cuando es repiking no pide estos datos
                        datos.datos.vendedor=this.vendedor;
                        datos.datos.fecha_corte=this.fecha_corte;
                        datos.datos.hora_corte=this.hora_corte;
                        datos.datos.turno=this.turno;
                    }
                    this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadoscartera', operacion: 'llevarpicking', operacion_tipo: 'crear' };
                    this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method:'POST',
                        body: datos,
                        success: this.successLlevarAPicking,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                    });
                }
            }
        });

        //imprimir --->

        this.getField('generar_archivo').setClick(()=>{
            this.procesarImprimir();
        });


        this.getField('ch_excel').setOnChange((props)=>{
            if(this.getField('ch_excel').getValue()==='false'){
                this.getField('ch_pdf').setValueSwitch (false);
                this.getField('ch_pantalla').setValueSwitch (false);
                this.operacion_actual='excel';
                this.habilitarCorreo();
            }
        });

        this.getField('ch_pdf').setOnChange((props)=>{
            if(this.getField('ch_pdf').getValue()==='false'){
                this.getField('ch_excel').setValueSwitch (false);
                this.getField('ch_pantalla').setValueSwitch (false);
                this.operacion_actual='pdf';
                this.habilitarCorreo();
            }
        });

        this.getField('ch_pantalla').setOnChange((props)=>{
            if(this.getField('ch_pantalla').getValue()==='false'){
                this.getField('ch_excel').setValueSwitch (false);
                this.getField('ch_pdf').setValueSwitch (false);
                this.operacion_actual='pantalla';
                this.deshabilitarCorreo();
            }else{
                this.habilitarCorreo();
            }
        });

        //ver picking --> modificar encargado

        this.getField('bt_modificar_encargado').setClick(()=>{
            if(this.arrayDataCheckBox>0){
               this.getField('modal_operario').handleClickOpen();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });
    
        this.getField('bt_modificar_encargado').setClick(()=>{
            if(this.arrayDataCheckBox>0){
               this.getField('modal_operario').handleClickOpen();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField('cancelar_operario').setClick(()=>{
               this.getField('modal_operario').handleClose();
        });

        this.getField('aceptar_operario').setClick(()=>{
            this.modificarOperario();
        });


        //modal turno-->

        this.getField("cancelar_turno").setClick(()=>{
            this.getField("modal_turnos").handleClose();
        });

        this.getField('sede_encargado').setOnChange(()=>{
            this.getField('sede_encargado').setError(false,'');
            this.getField('encargado').setError(false,'');
            this.getField('nombre_encargado').setError(false,'');
        });

        this.getField("aceptar_turno").setClick(()=>{
                if(this.getField('turnos').valid()){
                    this.turnos=this.getField('turnos').getValue();
                    this.getField("modal_turnos").handleClose();
                    
                    this.mostrarMensajeGuardando();
                    let datos = { datos: {
                        tipo_picking:this.tipo_picking,
                        vendedor:this.vendedor,
                        fecha_corte:this.fecha_corte,
                        hora_corte:this.hora_corte,
                        turno:this.turno,
                        items: this.selectedRowsArray,
                        sucursal_ingreso:this.sucursal_ingreso,
                        sucursal:this.getField('sucursal').getValue(),
                        conservar_conteo:this.conservar_conteo,
                        xestado:this.xestado,
                        bodegas:this.bodega,
                        turnos:this.turnos,
                    }};
                    this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadoscartera', operacion: 'llevarpicking', operacion_tipo: 'crear' };
                    this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method:'POST',
                        body: datos,
                        success: this.successLlevarAPicking,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                    });
            }
        });

        //asentados recontar 
        this.getField("bt_asentado_recontar").setClick(()=>{
            if(this.row_asentados.length > 0){
                this.estado_pedido='03';//asentado
                this.getField('confirmModalCustom').setTitleAndContent('Pedidos', "¿Confirma que desea recontar el pedido: "+this.row_asentados[0].numero+'?');
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    if(this.picking_reserva==='S'){//envia a picking varios asentados
                        this.tipo_picking='V';//POR VARIOS
                    }else{//envia a  picking por pedido asentado
                        this.tipo_picking='P';//PEDIDO
                    }
                    this.abre_modal_picking=false;
                    this.selectedRowsArray=this.row_asentados; // para que envie la de asentados a piking
                    this.repiking=true;
                    this.sacar_pedido=false;//esto en para el apartado EN PICKING
                    this.llevarARePiking();
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_asentado_trasladar").setClick(()=>{
            if(this.row_asentados.length > 0){
                this.boton_seleccionado='trasladar';
                if(this.TRAZTRA){
                    this.getField('modal_bodegas').handleClickOpen();
                    this.traerDatosBodegas();
                }else{
                    this.mostrarMensajeAdicional('NO TIENE PERMSIO PARA FACTURAR (TRAZTRA)');
                }
                
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("select_bodegas").setOnChange(()=>{
            if( this.getField("select_bodegas").valid()){
                this.traerDatosFletes();
            }else{
                this.getField('flete').setValue('0');
                this.getField('flete').setError(false,'');
                this.getField('flete').setDisabled(true);
            }
        });

        this.getField("transportadora").setOnChange(()=>{
            this.getField('nombre_transportadora').setError(false,'');
        });

        this.getField("cancelar_bodegas").setClick(()=>{
            this.getField("modal_bodegas").handleClose();
        });

        this.getField("aceptar_bodegas").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.prop_para_despachar==='S' && this.para_despachar_automatico==='N'){
                this.fecha_despacho='';
                this.para_despachar=false;
                this.getField('ch_para_despachar').setValue("false");
                this.getField('modal_para_despachar').handleClickOpen();
            }else{//automatico
                this.fecha_despacho='';
                this.para_despachar=false;
                if(this.boton_seleccionado==='facturar'){
                    this.facturar();
                }else if(this.boton_seleccionado==='remisionar'){  
                    this.remisionar();
                }else{
                    this.trasladar();
                }
            }
            
        });

        //modal despachar

        this.getField("cancelar_despacho").setClick(()=>{
            this.getField("modal_para_despachar").handleClose();
        });

        this.getField("aceptar_despacho").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.getField('fecha_despacho').valid()){
                this.fecha_despacho=this.getField('fecha_despacho').getValue();
                this.para_despachar=this.getField('ch_para_despachar').getValue()==='true'?true:false;
                this.getField("modal_para_despachar").handleClose();
                if(this.boton_seleccionado==='facturar'){
                    this.facturar();
                }else if(this.boton_seleccionado==='remisionar'){  
                    this.remisionar();
                }else{
                    this.trasladar();
                }
            }
        });

        //remisionar----------------->
        this.getField("bt_asentado_remisionar").setClick(()=>{
            if(this.row_asentados.length > 0){
                this.boton_seleccionado='remisionar';
                if(this.TRAZREM){
                    this.nueva_orden='';
                    this.tasa_de_cambio='';
                    this.moneda='';
                    this.enviar_anexos=false;
                    this.xfletes='';
                    if(this.pedir_flete==='S'){
                        this.getField('modal_fletes').handleClickOpen();
                    }else{
                        //pasa a preguntar por la fecha despacho
                        if(this.prop_para_despachar==='S' && this.para_despachar_automatico==='N'){
                            this.fecha_despacho='';
                            this.para_despachar=false;
                            this.getField('ch_para_despachar').setValue("false");
                            this.getField('modal_para_despachar').handleClickOpen();
                        }else{//automatico
                            this.fecha_despacho='';
                            this.para_despachar=false;
                            this.remisionar();
                        }
                    }
                }else{
                    this.mostrarMensajeAdicional('NO TIENE PERMSIO PARA FACTURAR (TRAZREM)');
                }
                
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        //modal fletes

        this.getField("cancelar_flete").setClick(()=>{
            this.getField("modal_fletes").handleClose();
        });

        this.getField("aceptar_flete").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.getField('xfletes').valid()){
                this.xfletes=this.getField('xfletes').getValue();
                this.getField('modal_fletes').handleClose();
                //pasa a preguntar si es para despahcar sino  pasa directamente a remisionar-->
                if(this.prop_para_despachar==='S' && this.para_despachar_automatico==='N'){
                    this.fecha_despacho='';
                    this.para_despachar=false;
                    this.getField('ch_para_despachar').setValue("false");
                    this.getField('modal_para_despachar').handleClickOpen();
                }else{//automatico
                    this.fecha_despacho='';
                    this.para_despachar=false;
                    if(this.boton_seleccionado==='facturar'){
                        this.facturar();
                    }else{  
                        this.remisionar();
                    }
                }
            }
        });

        //modal tasa de cambio

        this.getField("cancelar_tasa").setClick(()=>{
            this.getField("modal_tasa_de_cambio").handleClose();
        });

        this.getField("aceptar_tasa").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.getField('tasa_de_cambio').valid() && this.getField('select_monedas').valid()){
                if(this.boton_seleccionado==='remisionar'){
                    this.tasa_de_cambio=this.getField('tasa_de_cambio').getValue();
                    this.moneda=this.getField('select_monedas').getValue();
                    this.getField('modal_tasa_de_cambio').handleClose();
                    this.remisionar();
                }else if(this.boton_seleccionado==='facturar'){
                    this.tasa_de_cambio=this.getField('tasa_de_cambio').getValue();
                    this.moneda=this.getField('select_monedas').getValue();
                    this.getField('modal_tasa_de_cambio').handleClose();
                    if(this.aviso_de_recibo==='S'){
                        this.getField('modal_recibo').handleClickOpen();
                        this.getField('numero_de_recibo').setValue('000');
                    }else{
                        this.facturar();
                    }
                }
                
            }
        });

        this.getField("select_monedas").setOnChange(()=>{
            if (this.getField("select_monedas").getValue()==='USD') {
                this.getField('tasa_de_cambio').setDisabled(false);
                if (this.factor > 1) {
                    this.getField('tasa_anterior').setVisible(true);
                    this.getField('tasa_anterior').setValue('Se tenia una tasa de: ' + this.factor);
                }else{
                    this.getField('tasa_anterior').setVisible(false);
                }
                if (this.moneda_estandar_aux==='COP') {
                    this.traerTrmCop(); //esta aprte falta
                } else {
                    this.traerTrmCostaRica();
                }
            } else {
                this.getField('tasa_de_cambio').setValue('1');
                this.getField('tasa_de_cambio').setDisabled(true);
            }
        });

        //modal nueva orden

        this.getField("cancelar_orden").setClick(()=>{
            this.getField("modal_orden_de_compra").handleClose();
        });

        this.getField("aceptar_orden").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.getField('nueva_orden').valid() && this.getField('nueva_orden').valid()){
                this.nueva_orden=this.getField('nueva_orden').getValue();
                this.getField('confirmModalCustom').setTitleAndContent('Atención', "Oprima Sí para confirmar la orden "+this.nueva_orden+"");
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    this.getField('modal_orden_de_compra').handleClose();
                    this.remisionar();
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);
            }
        });

        //facturar----------------->
        this.getField("bt_asentado_facturar").setClick(()=>{
            if(this.row_asentados.length > 0){
                this.boton_seleccionado='facturar';
                if(this.TRAZFACT){
                    this.tasa_de_cambio='';
                    this.moneda='';
                    this.numero_de_recibo='';
                    this.observacion_factura='';
                    this.numero_de_factura='';
                    this.enviar_anexos=false;
                    this.xfletes='';
                    this.getField('modal_tasa_de_cambio').handleClose();
                    //this.facturar();
                    if(this.imprimir_descuento_en_observacion){
                        this.preguntarImprimirDescuentos();
                    }else{
                        if(this.pedir_flete_facturar==='S'){
                            this.getField('modal_fletes').handleClickOpen();
                        }else{
                            //pasa a preguntar por la fecha despacho
                            if(this.prop_para_despachar==='S' && this.para_despachar_automatico==='N'){
                                this.fecha_despacho='';
                                this.para_despachar=false;
                                this.getField('ch_para_despachar').setValue("false");
                                this.getField('modal_para_despachar').handleClickOpen();
                            }else{//automatico
                                this.fecha_despacho='';
                                this.para_despachar=false;
                                this.facturar();
                            }
                        }
                    }
                    
                }else{
                    this.mostrarMensajeAdicional('NO TIENE PERMSIO PARA FACTURAR (TRAZFACT)');
                }
                
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });
        
        //modal número de recibo

        this.getField("cancelar_recibo").setClick(()=>{
            this.getField("modal_recibo").handleClose();
        });

        this.getField("aceptar_recibo").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.getField('numero_de_recibo').valid()){
                this.numero_de_recibo=this.getField('numero_de_recibo').getValue();
                this.getField('modal_recibo').handleClose();
                this.facturar();
            } 
        });

        //modal número de factura

        this.getField("cancelar_factura").setClick(()=>{
            this.getField("modal_factura").handleClose();
        });

        this.getField("aceptar_factura").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.getField('numero_de_factura').valid()){
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Atebción','Desea continuar con el número de factura '+this.getField('numero_de_factura').getValue+'?');
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.numero_de_factura=this.getField('numero_de_factura').getValue();
                    this.getField("modal_factura").handleClose();
                    this.facturar();
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm('SI'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
                    this.getField('confirmModalCustom').toggle(false);
                });
                this.getField('confirmModalCustom').toggle(true);
                
            } 
        });

        //modal observaciones

        this.getField("cancelar_observaciones").setClick(()=>{
            this.getField("modal_observaciones").handleClose();
        });

        this.getField("aceptar_observaciones").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.getField('observacion_factura').valid()){
                this.observacion_factura=this.getField('observacion_factura').getValue();
                this.getField("modal_observaciones").handleClose();
                this.facturar();
            } 
        });

        //modal observaciones

        this.getField("cancelar_fvencimiento").setClick(()=>{
            this.getField("modal_fecha_vencimiento").handleClose();
        });

        this.getField("aceptar_fvencimiento").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.getField('fecha_vencimiento_picking').valid()){
                if(this.validarfechas()){
                    this.fecha_vencimiento_picking=this.getField('fecha_vencimiento_picking').getValue();
                    this.getField("modal_fecha_vencimiento").handleClose();
                    this.facturar();
                }
            } 
        });

        this.getField("fecha_vencimiento_picking").setOnChange(()=>{
            this.validarfechas();
        });

        //modal puntos

        /*this.getField("cancelar_puntos").setClick(()=>{
            this.getField("modal_puntos").handleClose();
        });*/

        this.getField("aceptar_puntos").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.getField('nit_puntos').valid() && this.getField('sede_puntos').valid() && this.getField('nombre_puntos').valid()){
                this.guardarPuntos(this.getField('nit_puntos').getValue(),this.getField('sede_puntos').getValue(),this.getField('nombre_puntos').getValue());
            } 
        });

        this.getField("nit_puntos").setOnChange(()=>{
            this.getField("sede_puntos").setError(false,'');
            this.getField("nombre_puntos").setError(false,'');
        });

        //modal pagar

        this.getField("cancelar_pago").setClick(()=>{
            this.getField("modal_pedir_pago").handleClose();
        });

        this.getField("aceptar_pago").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.getField('valor_efectivo').valid() 
                && this.getField('valor_cheques').valid() 
                && this.getField('valor_tarjeta_debito').valid()
                && this.getField('valor_tarjeta_credito').valid()
                && this.getField('valor_otros').valid()
                && this.getField('vendedor_pago').valid()
                && this.getField('vendedor_nombre_pago').valid()){
                    //validar valor
                    if(Number(this.getField('valor_total_factura').getValue())>0){

                        try {
                            let total_pago = Number(this.getField('valor_efectivo').getValue())+Number(this.getField('valor_cheques').getValue());
                            total_pago += Number(this.getField('valor_tarjeta_debito').getValue())+Number(this.getField('valor_tarjeta_credito').getValue());
                            total_pago += Number(this.getField('valor_otros').getValue());
                            
                            //let valor_factura = Double.parseDouble(df.format(valor_factura));
                            if (total_pago < Number(this.getField('valor_total_factura').getValue())) {
                                this.mostrarMensajeAdicional("El valor del pago es menor que valor de la factura. Valor Factura: "+this.currencyFormatterGeneral(this.getField('valor_total_factura').getValue())+". Valor Pago: $ "+this.currencyFormatterGeneral(total_pago));
                            }else{
                                this.guardarPago();
                            }
                        } catch (err) {
                            this.mostrarMensajeAdicional("Fallo al calcular el total.");
                        }
                    }else{
                        //this.getField("modal_pedir_pago").handleClose();
                        this.mostrarMensajeAdicional("El valor de la factura es cero.")
                    }
            } 
        });

        this.getField("nit_puntos").setOnChange(()=>{
            this.getField("sede_puntos").setError(false,'');
            this.getField("nombre_puntos").setError(false,'');
        });

        this.getField("vendedor_pago").setOnChange(()=>{
            this.getField("vendedor_nombre_pago").setError(false,'');
        });
        this.getField("vendedor").setOnChange(()=>{
            this.getField("vendedor_nombre").setError(false,'');
        });

        this.getField("valor_efectivo").setOnChange(()=>{
            this.calcularCambio();
        });

        this.getField("valor_cheques").setOnChange(()=>{
            this.calcularCambio();
        });

        this.getField("valor_tarjeta_debito").setOnChange(()=>{
            this.calcularCambio();
        });

        this.getField("valor_tarjeta_credito").setOnChange(()=>{
            this.calcularCambio();
        });

        this.getField("valor_otros").setOnChange(()=>{
            this.calcularCambio();
        });

        //modal exportaciones
        /*this.getField("cancelar_exp").setClick(()=>{
            this.getField("modal_exportaciones").handleClose();
        });*/

        this.getField("aceptar_exp").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.getField('trm').valid() 
                && this.getField('termino').valid() 
                && this.getField('puerto').valid()
                && this.getField('terminop').valid()
                && this.getField('bultos').valid()
                && this.getField('flete_exp').valid()
                && this.getField('seguro').valid()){
                    this.guardarExportacion();
            } 
        });

        //PANEL TRAZABILIDAD RESERVA

        this.getField("ver_detalle").setClick(()=>{
            if(this.row_trazabilidadReserva.length > 0){
                this.ver_detalle(this.row_trazabilidadReserva[0]);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        //PABEL DE NOVEDADES

        this.getField('cancelar_novedades').setClick(()=>{
            this.getField('modal_novedades_fechas').handleClose();
        });

        this.getField('aceptar_novedades').setClick(()=>{
            if(this.getField('radio_novedades').valid()){
                if(this.getField('radio_novedades').getValue()==='T'){
                    if(this.validarfechasNovedades()){
                        this.Traernovedades();
                    }
                }else{
                    this.Traernovedades();
                }
            }
        });

        this.getField('novedades_desde').setOnChange(()=>{
            this.validarfechasNovedades()
        });

        this.getField('novedades_hasta').setOnChange(()=>{
            this.validarfechasNovedades()
        });

        this.getField('radio_novedades').setOnChange(()=>{
            if(this.getField('radio_novedades').getValue()==='P'){
                this.getField('novedades_desde').setDisabled(true);
                this.getField('novedades_hasta').setDisabled(true);
            }else{
                this.getField('novedades_desde').setDisabled(false);
                this.getField('novedades_hasta').setDisabled(false);
            }
        });

        this.getField('items_novedades').setClick(()=>{
            if(this.row_novedades.length > 0){
                this.ItemsNovedades();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField('items_pedidos').setClick(()=>{
            if(this.row_novedades.length > 0){
                this.ItemsNovedadesPedido();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        //PANEL DE WMS CONTADOS

        this.getField('ver_pedido_wms').setClick(()=>{
            if(this.row_wms_contados.length > 0){
                this.consultarContadosWMS();//conteo
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("cerrar_conteo").setClick(()=>{
            this.getField("modal_conteo_wms").handleClose();
        });

        this.getField("bt_modificar_conteo").setClick(()=>{
            //pasa a preguntar por la fecha despacho
            if(this.row_wms_contados.length > 0){
                this.actualizarConteo();//conteo
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro de la tabla principal.', 'error');
            }
        });

        //PANEL DE EN PICKING

        this.getField('bt_aceptar_pendiente').setClick(()=>{
            if(this.row_pendientes.length > 0){
                this.verPicking();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_cancelar_pendiente").setClick(()=>{
            this.getField("modal_pendientes").handleClose();
        });

        this.getField("bt_items").setClick(()=>{
            if(this.row_en_picking.length > 0){
                this.getField('modal_ver_items').setLabel("Pedido No. "+this.row_en_picking[0].numero + " Cliente: " + this.row_en_picking[0].nit + " Sede " + this.row_en_picking[0].sede + " " + this.row_en_picking[0].nombre + " Valor: $"+this.currencyFormatterGeneral(this.row_en_picking[0].valor))
                this.ItemsEnPicking();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_reimprimir").setClick(()=>{
            if(this.row_en_picking.length > 0){
                this.reimprimir=true;
                this.estado_pedido=this.xestado; //02
                if ( this.tipo_picking==='P') {//P de pedido
                    //pedir encargado
                    this.pide_encargado=true;
                    this.getField('modal_encargado').setLabel('Pedido No. ' + this.row_en_picking[0].numero + ' Fecha: ' + this.row_en_picking[0].fecha);
                    this.getField('modal_encargado').handleClickOpen();
                } else if (this.tipo_picking==='R') {//R de referencia
                    this.prepararReimprimir();
                } else if (this.tipo_picking==='G') {//G de grupos
                    this.prepararReimprimir();
                } else if (this.tipo_picking==='U') {//U de ubicacion
                    this.prepararReimprimir();
                } else if (this.tipo_picking==='V') {//U de ubicacion
                    //pedir encargado
                    this.pide_encargado=true;
                    this.getField('modal_encargado').setLabel('Pedido No. ' + this.row_en_picking[0].numero + ' Fecha: ' + this.row_en_picking[0].fecha);
                    this.getField('modal_encargado').handleClickOpen();
                }
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_novedad").setClick(()=>{
            if(this.row_en_picking.length > 0){
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje',"¿Confirma que desea generar la novedad en el pedido " + this.row_en_picking[0].numero + " del picking " + this.row_en_picking[0].num_picking + "?");
                this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); 
                    this.conservar_conteo=true;
                    //pedir encargado
                    this.getField('modal_tipos_novedades').handleClickOpen();
                });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });


        this.getField('aceptar_novedad').setClick(()=>{
            if(this.getField('select_novedades').valid()){
                this.enviarNovedad();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField('cancelar_novedad').setClick(()=>{
            this.getField('modal_tipos_novedades').handleClose();
        });

        this.getField("bt_repicking").setClick(()=>{
            if(this.row_en_picking.length > 0){
                //this.sacarPedido();
                //primero hace la parte de REPICKING, usamos la de asentados
                this.getField('confirmModalCustom').setTitleAndContent('Pedidos', "¿Confirma que desea recontar el pedido: "+this.row_en_picking[0].numero+'?');
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    if(this.picking_reserva==='S'){//envia a picking varios asentados
                        this.tipo_picking='V';//POR VARIOS
                    }else{//envia a  picking por pedido asentado
                        this.tipo_picking='P';//PEDIDO
                    }
                    this.abre_modal_picking=false;
                    this.selectedRowsArray=this.row_en_picking; // para que envie la de asentados a piking
                    this.repiking=true;
                    this.sacar_pedido=true;
                    this.llevarARePiking();
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);

            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });
        
        this.getField('modal_imprimir').setCloseButton(() => {
            this.repiking=false;
        });



        this.getField("bt_cerrar").setClick(()=>{
                //this.sacarPedido();
                //primero hace la parte de REPICKING, usamos la de asentados
                this.getField('confirmModalCustom').setTitleAndContent('Pedidos', "¿Confirma que desea cerrar el picking "+this.numero_picking+' con todos sus pedidos?');
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.cerrarPicking();
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);
        });


        this.getField("bt_cerrar_uno").setClick(()=>{
            if(this.row_en_picking.length > 0){
                //this.sacarPedido();
                //primero hace la parte de REPICKING, usamos la de asentados
                this.getField('confirmModalCustom').setTitleAndContent('Pedidos', "¿Confirma que desea cerrar el pedido " + this.row_en_picking[0].numero + " del picking " + this.numero_picking + "?");
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.cerrarUno();
                });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);

            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        

        this.getField("bt_digitar").setClick(()=>{
            this.getField('modal_rangos').handleClickOpen();
        });

        this.getField('cancelar_rangos').setClick(()=>{
            this.getField('modal_rangos').handleClose();
        });

        this.getField('aceptar_rangos').setClick(()=>{
            if(this.validarRangos()){
                if(this.getField('pedido_rangos').getValue().toString().trim()!==''){
                    if(this.validarPedidoRangos())
                        this.asentarCantidades();
                }else
                    this.asentarCantidades();
            }
        });

        this.getField('desde_item').setKeyUp(()=>{
            this.validarRangos();
        });

        this.getField('hasta_item').setKeyUp(()=>{
            this.validarRangos();
        });

        this.getField('pedido_rangos').setKeyUp(()=>{
            this.validarPedidoRangos();
        });

        
        this.getField("modificar_detalle_digitar").setClick(()=>{
            if(this.row_items_digitar.length > 0){
                this.getField("modal_detalle").handleClickOpen();
                this.getField('modal_detalle').setLabel("TRAZABILIDAD DE PEDIDOS")
                this.getField("texto_detalle").setValue(this.row_items_digitar[0].detalle)
                this.getField("fdespacho").setValue(this.row_items_digitar[0].fdespacho)
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });



        this.getField("modificar_cantidad").setClick(()=>{
            if(this.row_items_digitar.length > 0){
                this.modificarCantidadConteo();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("modificar_bodega").setClick(()=>{
            if(this.row_items_digitar.length > 0){
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', "Ingrese la nueva bodega para\n" + this.row_items_digitar[0].codigo + "-" + this.row_items_digitar[0].nombre, "Pedido No. " + this.row_items_digitar.numero);
                this.getField('confirmModalCustom').setClickDialog(() => { 
                    this.getField('confirmModalCustom').toggle(false); 
                    this.traer_bodegas_opcion='digitar';
                    this.cargarbodegas();
                    this.poner_bodega_actual=true;
                });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("Aceptar"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        //modales de modificar cantidad y para cantidad combos 

        this.getField('bt_cancelar_cantidad').setClick(()=>{
            this.getField('modal_modificar_cantidad').handleClose();
        });

        this.getField('bt_modificar_cantidad').setClick(()=>{
            if(this.getField('nueva_cantidad').valid()){
                this.mostrarMensajeGuardando();
                let datos={ datos: {
                    sucursal_ingreso : this.sucursal_ingreso,
                    items: this.row_items_digitar,
                    nueva_cantidad:this.getField('nueva_cantidad').getValue(),
                    consecutivo_picking:this.numero_picking,
                    xbodega: this.row_items_digitar[0].bodega,
                }};
                this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'modificarcantidadconteo', operacion_tipo: 'modificar' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method:'PUT',
                    body: datos,
                    success: this.successModificarCantidadConteo,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false,
                });
            }
        });

        this.getField('bt_cancelar_cantidad_combo').setClick(()=>{
            this.getField('modal_modificar_cantidad_combos').handleClose();
        });

        this.getField('bt_modificar_cantidad_combo').setClick(()=>{
            if(this.getField('nueva_cantidad_combos').valid()){
                this.mostrarMensajeGuardando();
                let datos={ datos: {
                    sucursal_ingreso : this.sucursal_ingreso,
                    items: this.row_items_digitar,
                    nueva_cantidad:this.getField('nueva_cantidad_combos').getValue(),
                    consecutivo_picking:this.numero_picking,
                    xbodega: this.row_en_picking[0].bodega,
                }};
                this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'modificarcantidadconteo', operacion_tipo: 'modificar' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method:'PUT',
                    body: datos,
                    success: this.successModificarCantidadConteo,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false,
                });
            }
        });


        this.getField("modal_digitar_items").setCloseButton(()=>{
            this.getField("modal_rangos").handleClose();
            this.verPicking();
        });

        //panel autorizados inventario

        this.getField('bt_detalle_inventario').setClick(()=>{
            if(this.selectedRows2.length > 0){
                this.modificadetalle="DAINVENTARIO";
                this.getField("modal_detalle").handleClickOpen();
                this.getField('modal_detalle').setLabel("Pedido No. "+this.selectedRows2[0].numero +" Fecha: "+this.selectedRows2[0].fecha)
                this.getField("fdespacho").setValue(this.selectedRows2[0].fecha_entrega);
                this.getField("texto_detalle").setValue(this.selectedRows2[0].detalle);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField('bt_pendiente_inventario').setClick(()=>{
            //devolverPedido
            if(this.selectedRows2.length > 0){
                this.getField('confirmModalCustom').setTitleAndContent('Pedidos', "¿Confirma que desea devolver el pedido "+this.selectedRows2[0].numero+" al estado pendiente?");
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    this.pendienteAutorizadosInventario(); });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField('bt_items_inventario').setClick(()=>{
            //devolverPedido
            if(this.selectedRows2.length > 0){
                this.ItemsAutorizadosInventario();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_llevar_picking").setClick(()=>{//autorizados inventario
            if(this.selectedRowsArray.length > 0){
                this.estado_pedido='01'; //autorizado
                this.abre_modal_picking=true;
                this.repiking=false;
                this.sacar_pedido=false;
                this.llenartipopicking();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_autorizar_inventario").setClick(()=>{ //autorizados cartera
            if(this.selectedRows2.length > 0){
                this.accion_detalle='autorizar_inventario';
                this.getField('detalle_autorizar').handleClickOpen();
                this.getField('detalle_autorizar').setLabel("Pedido No. "+this.selectedRows2[0].numero +" Fecha: "+this.selectedRows2[0].fecha)
                //this.getField("texto_detalle1").setValue(this.selectedRows2[0].detalle);
                this.getField("texto_detalle1").setValue('');
                this.getField('ver_pedidos').setDisabled(true);
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_retornar_reserva").setClick(()=>{ //autorizados cartera
            if(this.selectedRows2.length > 0){
                this.getField('confirmModalCustom').setTitleAndContent('Atención', "¿Esta seguro de retornar la reserva?");
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    this.retornarReserva(); });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);

            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_consultar_reserva").setClick(()=>{ //autorizados cartera
            if(this.selectedRows2.length > 0){
                this.traerItemsReserva();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_retornar_item").setClick(()=>{ //autorizados cartera
            if(this.row_items_reservados.length > 0){
                this.getField('confirmModalCustom').setTitleAndContent('Atención', "Esta seguro de devolver la reserva del producto:" + this.row_items_reservados[0].codigo_articulo);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    this.retornarItem(); });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);

            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_ver_pedido").setClick(()=>{ //autorizados cartera
            if(this.row_items_reservados.length > 0){
                this.verPedidoReservado();

            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_retornar_reserva_pedido").setClick(()=>{ //autorizados cartera
            if(this.row_pedido_reservado.length > 0){
                this.getField('confirmModalCustom').setTitleAndContent('Reserva', "¿Está seguro de retornar la reserva del item " + this.row_items_reservados[0].codigo_real + " del pedido " + this.row_pedido_reservado[0].numero + " ?");
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    this.retornarReservaPedido(); });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);

            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });

        this.getField("bt_reasignar_reserva").setClick(()=>{ //autorizados cartera
            if(this.row_pedido_reservado.length > 0){
                this.getField('confirmModalCustom').setTitleAndContent('Reserva', "¿Está seguro de reasignar la reserva del item " + this.row_items_reservados[0].codigo_real + " del pedido " + this.row_pedido_reservado[0].numero + " ?");
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false); 
                    this.reasignar(); });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField('confirmModalCustom').toggle(true);

            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un registro.', 'error');
            }
        });
        
    }



    validarfechas(){
        let fecha_actual = new Date().toISOString().split('T')[0];
        let fecha_desde = new Date(this.getField("fecha_vencimiento_picking").getValue()).toISOString().split('T')[0];

        this.getField("fecha_vencimiento_picking").setError(false,"");

        if(fecha_desde < fecha_actual){
            this.getField("fecha_vencimiento_picking").setError(true,"Debe ser mayor a la fecha actual.");
            return false;
        }
        return true;

    }

    traerInfoSucursal(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            value : this.getField('sucursal').getValue(),
        }};
        this.generalFormatPmv = { tipo_servicio: '43', operacion: '42_2', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerInfoSucursal,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successTraerInfoSucursal(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField('codigo_sucursal').setValue(data.data[0].codigo_sucursal);
            this.getField('nombre_sucursal').setValue(data.data[0].nombre_sucursal);

        }else {
            if(data.estado_p===404) {
                //this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    traerAsentados(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            sucursal : this.getField('sucursal').getValue(),
            xestado:'03',
        }};
        this.getField("rejilla7").setTipoServicioOperacion('traz-trazcontados-asentados');
        this.getField("rejilla7").sendRequest(this.successAsentados, datos);
    }

    successAsentados(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField("bt_asentado_facturar").setVisible(true);
            this.getField("bt_asentado_remisionar").setVisible(true);
            this.getField("bt_asentado_trasladar").setVisible(true);
            this.getField("bt_asentado_recontar").setVisible(true);
            this.getField("bt_asentado_items").setVisible(true);
            this.getField("bt_asentado_pendiente").setVisible(true);
            this.getField("bt_asentado_detalle").setVisible(true);
                
            let configCell = new Map();


            configCell.set('factor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.factor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('sede', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.sede) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('items', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.items) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('numero', {cellRenderer:(props) => {return ""+props.data.numero}, cellStyle: {textAlign:"right"},width: 110});

            configCell.set('nombre', {maxWidth: 1980 });
            configCell.set('direccion_entrega', {maxWidth: 1980 });
            configCell.set('detalle', {maxWidth: 1980 });
            configCell.set('estado_credito', {maxWidth: 1980 });

            
            // Configura el evento de selección de filas
            this.gridOptionsAsentados['onSelectionChanged'] = () => {
                this.row_asentados= [];
                this.row_asentados = this.gridOptionsAsentados.api.getSelectedRows();
            };
            
            // Inicializa la tabla con los datos
            this.gridOptionsAsentados['rowData'] = data.data;
            this.xestado='03'; //asentados
            
            // Inicializa la rejilla con la configuración
            this.getField('rejilla7').initData(this.gridOptionsAsentados, configCell);

            this.habilitarBotonesAdicionales('');

        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    procesarImprimir(){
        let errores =0;
        if(this.getField('radio_correo').getValue()==='S'  || this.operacion_actual!=='pantalla' ){// Se comenta la validación de que sea diferente a pantalla, ya que en la tarea de corrección "JQJD-1480" pidieron que si en "radio_correo" está seleccionado la opción de "NO", no fuera requerido digitar el correo, ya que en la tabla siempre va a ir 2 ítems, lo que significa que el pdf sólo va a tener una página.
            if(this.getField('email').valid()===false)
                errores++;
        }
        if(this.getField('ch_excel').getValue()==='false' && this.getField('ch_pdf').getValue()==='false' && this.getField('ch_pantalla').getValue()==='false'){
            errores++;
            this.operacion_actual='';
            this.alertGeneral.toggle(true, 'Es necesario seleccionar una opción: Pdf,Excel o Pantalla.', 'error');
        }
        if(errores===0){
            if(this.operacion_actual!==''){
                let  datos ={}
                if(this.boton==='trasladar'){
                    datos.numero=this.consecutivo_trasladar;
                    datos.codigo_sucursal=this.codigo_sucursal_trasladar;
                    datos.fecha=this.fecha_trasladar;
                    datos.sucursal_ingreso=this.sucursal_ingreso;
                    datos.operacion=this.operacion_actual;
                    datos.email=this.getField('email').getValue();
                    datos.radio_correo=this.getField('radio_correo').getValue();

                }else if(this.boton==='remisionar'){
                    datos.sucursal_ingreso=this.sucursal_ingreso;
                    datos.email= this.getField('email').getValue();
                    datos.radio_correo=this.getField('radio_correo').getValue();
                    datos.operacion= this.operacion_actual;
                    datos.articulo_anexo= this.articulo_anexo;
                    datos.sucursal=this.sucursal;
                    datos.fecha=this.fecha;
                    datos.consecutivo=this.consecutivo;
                    datos.codigo_facturacion=this.codigo_facturacion;
                }else if(this.boton==='factura'){
                    datos.sucursal_ingreso=this.sucursal_ingreso;
                    datos.email= this.getField('email').getValue();
                    datos.radio_correo=this.getField('radio_correo').getValue();
                    datos.operacion= this.operacion_actual;
                    datos.articulo_anexo= this.articulo_anexo;
                    datos.sucursal=this.sucursal;
                    datos.fecha=this.fecha;
                    datos.consecutivo=this.consecutivo;
                    datos.codigo_facturacion=this.codigo_facturacion;
                    datos.npedido=this.npedido;
                }else if(this.boton==='editarpedido'){
                    datos.sucursal_ingreso=this.sucursal_ingreso;
                    datos.email= this.getField('email').getValue();
                    datos.radio_correo=this.getField('radio_correo').getValue();
                    datos.operacion= this.operacion_actual;
                    datos.npedido=this.npedido+'';
                    datos.estado_pedido=this.estado_pedido_2;
                }else if(this.boton==='en_picking'){
                    datos.sucursal_ingreso=this.sucursal_ingreso;
                    datos.email= this.getField('email').getValue();
                    datos.radio_correo=this.getField('radio_correo').getValue();
                    datos.operacion= this.operacion_actual;
                    datos.items= this.row_en_picking;
                    datos.tipo_picking=this.tipo_picking;
                    datos.consecutivo_picking=this.numero_picking;

                    if(this.pide_encargado){
                        datos.encargado=this.encargado;
                        datos.sede_encargado=this.sede_encargado;
                        datos.nombre_encargado=this.nombre_encargado;
                    }
                }else{ //picking pedido
                    datos.sucursal_ingreso=this.sucursal_ingreso;
                    datos.email= this.getField('email').getValue();
                    datos.radio_correo=this.getField('radio_correo').getValue();
                    datos.operacion= this.operacion_actual;
                    datos.items= this.selectedRowsArrayAux;
                    datos.tipo_picking=this.tipo_picking;
                    datos.consecutivo_picking=this.consecutivo_picking;
                    if(this.repiking){ //si es repicking enviamos otro tipo_picking para poder imprimir
                        if(this.picking_reserva==='S'){//envia a picking varios asentados
                            datos.tipo_picking='V';//POR VARIOS
                        }else{//envia a  picking por pedido asentado
                            datos.tipo_picking='P';//PEDIDO
                        }
                    }

                    if(this.pide_encargado){
                        datos.encargado=this.encargado;
                        datos.sede_encargado=this.sede_encargado;
                        datos.nombre_encargado=this.nombre_encargado;
                    }
                }

                if(this.getField('radio_correo').getValue()==='S'){
                    this.enviarCorreoTerceros(datos);
                }else{
                    if(this.operacion_actual==='pdf'){
                        this.generarPdfTabla3(datos);
                    }else if(this.operacion_actual==='pantalla'){
                        //delete datos['email'];
                        this.generarModalLista(datos);
                    }else if(this.operacion_actual==='excel'){
                        this.generarExcelTabla3(datos);
                    } 
                }
            }else{
                this.alertGeneral.toggle(true, 'Error al validar la operación.', 'error');
                this.getField('confirmModalCustom').toggle(false);
            } 
        }
    }

    abrirImprimir(){
        this.getField('modal_imprimir').handleClickOpen();
        this.getField('email').setValue('');
        this.getField('email').setError(false,'');
        this.getField('radio_correo').setValue("N");
        this.getField('ch_excel').setValueSwitch(false);
        this.getField('ch_pdf').setValueSwitch(false);
        this.getField('ch_pantalla').setValueSwitch(false);
        this.getField('email').setDisabled(false);

        this.getField('ch_excel').setVisible(true);
        this.getField('ch_pantalla').setVisible(true);
    }

    traerinformacion(){
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            codigo_usuario:this.codigo_usuario
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_traerinformacion,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }
    //funcion para validar si en los usuarios autorizados para el boton
    //se encuentra el usuario de la sesión activa
    validarPermiso(boton,usuario){
        let arr_ususuarios=boton.split(',');
        for (var i = 0; i < arr_ususuarios.length; i++) {
            if(arr_ususuarios[i]===usuario)
                return true;
        }
        return false;
    }

    success_traerinformacion(data){
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        let opcionesm = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        let opcionesnovedades = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        if (data.estado_p === 200)
        {
            this.wms_nuevo=data.data.wms_nuevo;
            this.maneja_wms_externo=data.data.maneja_wms_externo;
            this.picking_reserva=data.data.picking_reserva;
            this.TRAZTRA=data.data.TRAZTRA;
            this.TRAZREM=data.data.TRAZREM;
            this.TRAZFACT=data.data.TRAZFACT;
            this.para_despachar_automatico=data.data.para_despachar_automatico;
            this.prop_para_despachar=data.data.para_despachar;
            this.pedir_flete=data.data.pedir_flete;
            this.pedir_flete_facturar=data.data.pedir_flete_facturar;
            this.aviso_de_recibo=data.data.aviso_de_recibo;
            this.imprimir_descuento_en_observacion=data.data.imprimir_descuento_en_observacion;


            //permisos
            this.TRAZDEVOL=data.data.TRAZDEVOL;
            this.TRAZLLPICK=data.data.TRAZLLPICK;
            this.TRAZRETORNRES=data.data.TRAZRETORNRES;
            this.TRAZCONSURESE=data.data.TRAZCONSURESE;
            this.TRAZITEMS=data.data.TRAZITEMS;
            this.TRAZMODDET=data.data.TRAZMODDET;
            this.TRAZCANTPT=data.data.TRAZCANTPT;
            this.TRAZCANTPP=data.data.TRAZCANTPP;
            this.TRAZCERUNO=data.data.TRAZCERUNO;
            this.TRAZREIMP=data.data.TRAZREIMP;
            this.TRAZCMDIR=data.data.TRAZCMDIR;
            this.TRAZNOVEDAD=data.data.TRAZNOVEDAD;
            this.smartvv=data.data.smartvv;
            this.TRAZRECONTAR=data.data.TRAZRECONTAR;
            this.TRAZ001=data.data.TRAZ001;
            this.TRAZ002=data.data.TRAZ002;
            this.TRAZ003=data.data.TRAZ003;
            this.TRAZ004=data.data.TRAZ004;


            this.TRAUTO=data.data.TRAUTO;
            this.TRCERRARP=data.data.TRCERRARP;
            this.TRASLADAR=data.data.TRASLADAR;
            
            
            if(!this.validarPermiso(data.data.pendientes_cartera,this.codigo_usuario)){
                this.getField('tab_contenedorDatosCuenta0').setDisabled(true);
            }
            if(!this.validarPermiso(data.data.pendientes_inventario,this.codigo_usuario)){
                this.getField('tab_contenedorDatosCuenta2').setDisabled(true);
            }
            if(!this.validarPermiso(data.data.autorizados_cartera,this.codigo_usuario)){
                this.getField('tab_contenedorDatosCuenta3').setDisabled(true);
            }
            if(!this.validarPermiso(data.data.autorizados_inventario,this.codigo_usuario)){
                this.getField('tab_contenedorDatosCuenta4').setDisabled(true);
            }
            if(!this.validarPermiso(data.data.picking,this.codigo_usuario)){
                this.getField('tab_contenedorDatosCuenta5').setDisabled(true);
            }
            if(!this.validarPermiso(data.data.wms_contados2,this.codigo_usuario)){
                this.getField('tab_contenedorDatosCuenta6').setDisabled(true);
            }
            if(!this.validarPermiso(data.data.wms_contados,this.codigo_usuario)){
                this.getField('tab_contenedorDatosCuenta7').setDisabled(true);
            }
            if(!this.validarPermiso(data.data.contados, this.codigo_usuario)){
                this.getField('tab_contenedorDatosCuenta8').setDisabled(true);
            }
            if(!this.validarPermiso(data.data.consulta, this.codigo_usuario)){
                this.getField('tab_contenedorDatosCuenta9').setDisabled(true);
            }
            if(!this.validarPermiso(data.data.trazabilidad_reserva, this.codigo_usuario)){
                this.getField('tab_contenedorDatosCuenta10').setDisabled(true);
            }
            if(!this.validarPermiso(data.data.novedades,this.codigo_usuario)){
                this.getField('tab_contenedorDatosCuenta11').setDisabled(true);
            }


            data.data.turnos.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.turno;
                dataOp['text'] = item.turno+'-'+item.detalle;
                dataOp['campos_cambian'] = {};
                opciones.push(dataOp);
            });

            data.data.monedas.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.abreviatura;
                dataOp['text'] = item.abreviatura;
                dataOp['campos_cambian'] = {};
                opcionesm.push(dataOp);
                if (item.abreviatura!=='USD') 
                    this.moneda_estandar = item.abreviatura;
            });

            data.data.tipos_novedades.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = item.codigo+' - '+item.descripcion;
                dataOp['campos_cambian'] = {};
                opcionesnovedades.push(dataOp);
            });

            //habilitar deshabilitar botones SECundarios


        
            this.getField('bt_asentado_pendiente').setDisabled(!this.TRAZDEVOL);
            this.getField('pendiente').setDisabled(!this.TRAZDEVOL);
            this.getField('bt_pendiente_inventario').setDisabled(!this.TRAZDEVOL);
        
    
            this.getField('llevar_picking').setDisabled(!this.TRAZLLPICK);
            this.getField('bt_llevar_picking').setDisabled(!this.TRAZLLPICK);
            this.getField('bt_autorizar_inventario').setDisabled(!this.TRAZLLPICK);
            this.getField('bt_detalle_pedido_reservado').setDisabled(!this.TRAZLLPICK);

            //TRAZRETORNRES
            this.getField('bt_retornar_reserva').setDisabled(!this.TRAZRETORNRES);

            //TRAZCONSURESE
            this.getField('bt_consultar_reserva').setDisabled(!this.TRAZCONSURESE);

            //TRAZITEMS
            this.getField('items').setDisabled(!this.TRAZITEMS);

            //TRAZMODDET
            this.getField('detalle').setDisabled(!this.TRAZMODDET);
            this.getField('detalle1').setDisabled(!this.TRAZMODDET);
            this.getField('bt_detalle_inventario').setDisabled(!this.TRAZMODDET);


            //TRAZCANTPT
            this.getField('bt_digitar').setDisabled(!this.TRAZCANTPT);

            //TRAZCANTPT
            this.getField('bt_digitar').setDisabled(!this.TRAZCANTPT);
            this.getField('bt_cerrar').setDisabled(!this.TRAZCANTPT);

            //TRAZCANTPP
            this.getField('bt_repicking').setDisabled(!this.TRAZCANTPP);

            //TRAZCERUNO
            this.getField('bt_cerrar_uno').setDisabled(!this.TRAZCERUNO);

            //TRAZREIMP
            this.getField('bt_reimprimir').setDisabled(!this.TRAZREIMP);

            //TRAZRECONTAR
            this.getField('bt_asentado_recontar').setDisabled(!this.TRAZRECONTAR);
            
          
            /*//ESTOS SON PARA CONTROLAR LOS PANELES DE MOMENTO SE DEJAN COMENTADOS , YA QUE SE PLANTEO
            //HABILITARLOS DESDE APPLICATION.PROPERTIES
            btnPendientes.setEnabled(Usuario.getUsuarioActivo().esPantallaAutorizada("TRAZ001"));
            btnAutorizados.setEnabled(Usuario.getUsuarioActivo().esPantallaAutorizada("TRAZ002"));
            btnEnPicking.setEnabled(Usuario.getUsuarioActivo().esPantallaAutorizada("TRAZ003"));
            btnAsentados.setEnabled(Usuario.getUsuarioActivo().esPantallaAutorizada("TRAZ004"));*/


            //TRAZCMDIR
            this.getField('direccion').setDisabled(!this.TRAZCMDIR);


            //TRAZNOVEDAD
            this.getField('bt_novedad').setDisabled(!this.TRAZRECONTAR);

            //smartvv
            this.getField('enviar_wms').setDisabled(!this.smartvv==='S');

            //PONER VISIBLES LOS TABS
            this.getField('tab_contenedorDatosCuenta2').setVisible(false)//ya que en escritorio no se muestra
            
            if (this.wms_nuevo!=='S') {
                //autorizados inventario
                this.getField('tab_contenedorDatosCuenta4').setVisible(false);

                //trazabilidad reserva
                this.getField('tab_contenedorDatosCuenta10').setVisible(false);

                //NOVEDADES
                this.getField('tab_contenedorDatosCuenta11').setVisible(false);
            }
            
            ///despues de init objetos
            if (this.maneja_wms_externo==='S') {
                //WMS CONTADOS
                this.getField('tab_contenedorDatosCuenta7').setVisible(true);
                //WMS 02
                this.getField('tab_contenedorDatosCuenta6').setVisible(true);
            } else {
                //WMS CONTADOS
                this.getField('tab_contenedorDatosCuenta7').setVisible(false);
                //WMS 02
                this.getField('tab_contenedorDatosCuenta6').setVisible(false);
            }

            if (this.wms_nuevo==='S') {
                if (this.picking_reserva==='S') {
                    this.getField('tab_contenedorDatosCuenta5').setVisible(true);
                } else {
                    this.getField('tab_contenedorDatosCuenta5').setVisible(false);
                }
            } else {
                this.getField('tab_contenedorDatosCuenta5').setVisible(true);
            }
            

        }else 
        {
            let respuesta=Object.values(data.data.errores);
            let keys=Object.keys(data.data.errores);
            this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
        }
        this.getField('turnos').setOptions(opciones);
        this.getField('select_monedas').setOptions(opcionesm);
        this.getField('select_novedades').setOptions(opcionesnovedades);

    }

    funcionQueSeEjecutaAlClick(event,newValue){
        this.limpiarTablas();
        this.reimprimir=false;
        this.poner_bodega_actual=false;
        this.getField('titulo').setValue('');
        this.selectedRows2=[];
        this.selectedRowsArray=[];
        if(this.getField('codigo_sucursal').valid() && this.getField('nombre_sucursal').valid()){
            this.accion_panel='';
            if(newValue === 1){
                this.getField('titulo').setValue('Pedidos con estado pendiente');
                this.numeropedido=0;
                this.xestado='00'; //PENDIENTE
                this.pendientescartera("00");

            }
            else if(newValue === 2){
                //pendientes inventario
                this.xestado='01'; //AUTORIZADO
                this.getField('titulo').setValue('Pedidos con estado pendiente');
            }
            else if(newValue === 3){
                this.autorizados_inventario=false;
                //autorizados cartera
                this.getField('titulo').setValue('Pedidos con estado autorizado');
                this.traer_bodegas_opcion='cartera';
                this.xestado='01'; //AUTORIZADO
                this.accion_panel='ACARTERA';
                this.cargarbodegas();
            }
            else if(newValue === 4){
                this.autorizados_inventario=true;
                //autorizados inventario
                this.getField('titulo').setValue('Pedidos con estado autorizado');
                this.ocultarAutorizadosInventario();
                this.xestado='01'; //AUTORIZADO
                this.accion_panel='AINVENTARIO';
                this.traer_bodegas_opcion='autorizados_inventario';
                this.cargarbodegas();
            }
            else if(newValue === 5){
                //en picking
                this.xestado='02';//en picking
                this.traer_bodegas_opcion='picking';
                this.ocultarEnPicking();
                this.cargarbodegas();
            }
            else if(newValue === 6){
                //wms 02
                this.ocultarWms02();
                this.getField('titulo').setValue('Pedidos WMS Externo estado 02');
                this.consultarPedidosWms02();
            }
            else if(newValue === 7){
                //wms contados
                this.ocultarWmsContados();
                this.getField('titulo').setValue('Trazabilidad');
                this.wmsContados();
            }
            else if(newValue === 8){
                this.ocultarContados();
                this.xestado='03';
                this.getField('titulo').setValue('Pedidos con estado asentado');
                this.traerAsentados();
            }
            else if(newValue === 9){
                this.ocultarConsulta();
                this.bt_consulta='consulta';
                this.getField("modal_pedido_consulta").handleClickOpen();
                
            }
            else if(newValue === 10){
                this.ocultarTrazabilidadReserva();
                this.bt_consulta='trazabilidad_reserva';
                this.getField("modal_pedido_consulta").handleClickOpen();
            }else if(newValue === 11){
                this.ocultarNovedades();
                this.getField('titulo').setValue('Pedidos con estado novedades');
                this.getField("modal_novedades_fechas").handleClickOpen();
                this.getField('radio_novedades').setValue('P');
            }
        }else{
            this.getField('TabJaivana_265').setTabNumber(1);
            this.getField('titulo').setValue('')
        }
    }

    pendientescartera(){
        //this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            sucursal : this.getField("sucursal").getValue(),
            xestado:"00"
        }};
        this.getField("rejilla").setTipoServicioOperacion('traz-trazpendientescartera-pendientescartera');
        this.getField("rejilla").sendRequest(this.success_pendientescartera, datos);
    }


    success_pendientescartera(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
    
            this.getField("editar_pedido").setVisible(true);
            this.getField("autorizar").setVisible(true);
            this.getField("items").setVisible(true);
            this.getField("cliente").setVisible(true);
            this.getField("detalle").setVisible(true);
            this.getField("direccion").setVisible(true);
    
            let configCell = new Map();
    
            data.data.forEach(item => {            
                // Obtener las claves del objeto `item`
                const keys = Object.keys(item);
            
                // Iterar sobre cada clave del objeto `item`
                keys.forEach(key => {            
                    if (key === 'estado') {
                        configCell.set('estado', {
                            cellRenderer: function (props) {
                                // Definir los estilos para cada caso
                                const estiloH = { backgroundColor: "rgb(235,75,75)", textAlign: "left", color: 'rgb(15, 15, 12)' };
                                const estiloDefault = { backgroundColor: "rgb(255,255,255)", textAlign: "left", color: 'rgb(15, 15, 12)' };
                    
                                // Seleccionar el estilo basado en el valor de estado
                                const estilo = props.data.estado === 'H' ? estiloH : estiloDefault;
                    
                                // Aplicar el estilo y devolver el contenido con el estilo aplicado
                                return (
                                    <div style={estilo}>
                                        {props.data.estado}
                                    </div>
                                );
                            },
                            width: 100,
                        });
                    } else {
                       
                    }
                });
            });

            configCell.set('factor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.factor) }, cellStyle: {textAlign:"right"},width: 120});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"},width: 120});
            configCell.set('sede', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.sede) }, cellStyle: {textAlign:"right"},width: 120});
            configCell.set('items', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.items) }, cellStyle: {textAlign:"right"},width: 120});
            configCell.set('numero', {cellRenderer:(props) => {return ""+props.data.numero }, cellStyle: {textAlign:"right"}});

            configCell.set('nombre', {maxWidth: 1980 });
            configCell.set('direccion_entrega', {maxWidth: 1980 });
            configCell.set('detalle', {maxWidth: 1980 });
            configCell.set('estado_credito', {maxWidth: 1980 });


            this.gridOptionsComponentes1['rowData'] = data.data;
    
            // Configura el evento de selección de filas
            this.gridOptionsComponentes1['onSelectionChanged'] = () => {
                this.selectedRows1 = [];
                this.selectedRows1 = this.gridOptionsComponentes1.api.getSelectedRows();
            };
    
            // Inicializa los datos de la rejilla
            this.getField('rejilla').initData(this.gridOptionsComponentes1, configCell);

            this.habilitarBotonesAdicionales('');
    
        } else {
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            } else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    cargarbodegas(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadoscartera', operacion: 'cargarbodegas', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_cargarbodegas,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_cargarbodegas(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            if (data.data.total >= 1) {
                this.getField("modal_elegir_bodega").handleClickOpen();

                let opciones = [{'text':'Ninguno','value':'','campos_cambian':{}}];
                data.data.bodegas.forEach(item => {
                    let dataOp = {}
                    dataOp['value'] = item.codigo_bodega;
                    dataOp['text'] = item.nombre_bodega;
                    dataOp['campos_cambian'] = { };
                    opciones.push(dataOp);
                });
                this.getField('bodegas').setOptions(opciones);
            } else {
                if(this.traer_bodegas_opcion==='cartera'){
                    this.bodega = this.getField("bodegas").getValue()
                    this.AutorizadosCartera();
                }else if(this.traer_bodegas_opcion==='picking'){
                    this.bodega = this.getField("bodegas").getValue()
                    this.traerPendientes();
                }else if(this.traer_bodegas_opcion==='digitar'){
                    //esto solo para no modificar la bodega general
                    this.bodega_aux=this.getField("bodegas").getValue();
                    this.modificarBodega();
                }else if(this.traer_bodegas_opcion==='autorizados_inventario'){
                    this.bodega = this.getField("bodegas").getValue()
                    this.traerAutorizadosInventario();
                }
                this.getField("modal_elegir_bodega").handleClose();

                
            }
            if(this.poner_bodega_actual){
                //miro si la bodega existe 
                let existe=false;
                data.data.bodegas.forEach(item => {
                    if(item.codigo_bodega===this.bodega){
                        existe=true;
                        return;
                    }
                });
                if(existe)
                    this.getField('bodegas').setValue(this.bodega);
            }
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }


    AutorizadosCartera(){
        this.xestado='01';// autorizados
        //this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            sucursal : this.getField("sucursal").getValue(),
            xestado:"01",
            bodega:this.bodega
        }};
        this.getField("rejilla2").setTipoServicioOperacion('traz-trazautorizadoscartera-autorizarcartera');
        this.getField("rejilla2").sendRequest(this.success_AutorizadosCartera, datos);
    }

    success_AutorizadosCartera(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField("modal_elegir_bodega").handleClose();
            this.getField("llevar_picking").setVisible(true);
            this.getField("items1").setVisible(true);
            this.getField("pendiente").setVisible(true);
            this.getField("detalle1").setVisible(true);
            this.getField("seleccionar_registro").setVisible(true);
                
            let configCell = new Map();

            data.data.items.forEach(item => {            
                // Obtener las claves del objeto `item`
                const keys = Object.keys(item);
            
                // Iterar sobre cada clave del objeto `item`
                keys.forEach(key => {            
                    configCell.set(key, {
                        Width: 120
                    });
                });
            });

            configCell.set('nombre', {maxWidth: 1980 });
            configCell.set('detalle', {maxWidth: 1980 });
            configCell.set('direccion_entrega', {maxWidth: 1980 });
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('peso', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.peso) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('factor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.factor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('sede', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.sede) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('items', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.items) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('numero', {cellRenderer:(props) => {return ""+props.data.numero }, cellStyle: {textAlign:"right"}});


            this.arrayseleccion = data.data.items;

            this.funcionesTablaMultiCheck();
            
            // Inicializa la tabla con los datos
            this.gridOptionsComponentes2['rowData'] = data.data.items;
            
            // Inicializa la rejilla con la configuración
            this.getField('rejilla2').initData(this.gridOptionsComponentes2, configCell);

            if (this.wms_nuevo==='S' && data.data!==undefined && data.data.bodega_wms==='S') {
                this.getField('llevar_picking').setVisible(true);
                if (this.autorizados_inventario) {
                    this.getField('bt_autorizar_inventario').setVisible(false);
                    this.getField('bt_retornar_reserva').setVisible(true);
                    this.getField('bt_consultar_reserva').setVisible(true);
                    if (this.picking_reserva==='S') 
                        this.getField('llevar_picking').setVisible(false);
                } else {
                    this.getField('llevar_picking').setVisible(false);
                    this.getField('bt_autorizar_inventario').setVisible(true);
                    this.getField('bt_retornar_reserva').setVisible(false);
                    this.getField('bt_consultar_reserva').setVisible(false);
                }
            }
            this.habilitarBotonesAdicionales(data.data.bodega_wms);
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    funcionesTablaMultiCheck(){
        // Array para almacenar los registros seleccionados
        this.selectedRowsArray = [];
            
        // Configura la función para alternar el valor de la celda y gestionar el array
        this.toggleCellValueInRow = (rowNode, columnName) => {
            const currentValue = rowNode.data[columnName];
            const newValue = currentValue === true ? false : true; // Alterna entre true y false
        
            // Actualiza el valor de la columna en la fila
            rowNode.setDataValue(columnName, newValue);
        
            // Actualiza la fila en la tabla
            this.gridOptionsComponentes2.api.applyTransaction({ update: [rowNode.data] });
        
            // Maneja el array de filas seleccionadas
            if (newValue === false) {
                // Elimina la fila del array si el valor se convierte en false
                this.selectedRowsArray = this.selectedRowsArray.filter(row => row.numero !== rowNode.data.numero);
            } else if (!this.selectedRowsArray.some(row => row.numero === rowNode.data.numero)) {
                // Añade la fila al array si el valor es true y no está ya en el array
                this.selectedRowsArray.push(rowNode.data);
            }
        };
        
        // Configura el evento de selección de filas
        this.gridOptionsComponentes2['onSelectionChanged'] = () => {
            this.selectedRows2= [];
            // Actualiza selectedRows2 con las filas actualmente seleccionadas
            this.selectedRows2 = this.gridOptionsComponentes2.api.getSelectedRows();
            
            // Actualiza el array de registros seleccionados basado en la selección actual
            this.selectedRowsArray = [];
            this.selectedRows2.forEach(row => {
                const isSelected = row['x'] === true;
                if (isSelected) {
                    // Añade la fila al array si está seleccionada y no está ya en el array
                    if (!this.selectedRowsArray.some(selected => selected.numero === row.numero)) {
                        this.selectedRowsArray.push(row);
                    }
                }
            });
        };
        
        // Configura el evento de clic en cualquier celda
        this.gridOptionsComponentes2['onCellClicked'] = (event) => {
            const columnName = 'x'; // Reemplaza 'x' con el ID de la columna que deseas actualizar
        
            // Obtiene el nodo de fila correspondiente
            const rowNode = event.node;
        
            // Alterna el valor en la columna específica de la fila clicada
            this.toggleCellValueInRow(rowNode, columnName);
        
            // Actualiza selectedRowsArray si se ha cambiado el valor de la celda
            this.selectedRows2 = this.gridOptionsComponentes2.api.getSelectedRows();
            this.selectedRowsArray = this.selectedRows2.filter(row => row[columnName] === true);
        };
    }
    
    Items1(){
        let datos={ datos: {
            sucursal:this.selectedRows2[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            pedido:this.selectedRows2[0].numero,
            factor:this.selectedRows2[0].factor,
            boton:"01"
        }};

        this.getField("rejilla11").setTipoServicioOperacion('traz-trazpendientescartera-items');
        this.getField("rejilla11").sendRequest(this.success_Items1, datos);
    }

    success_Items1(data){
        if (data.estado_p === 200 ){ 

            this.getField("modal_ver_items").handleClickOpen();
            let configCell = new Map();
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('precio', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.precio) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: {textAlign:"right"}});
            configCell.set('valor_conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor_conteo) }, cellStyle: {textAlign:"right"}});
            configCell.set('cant_pedida', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_pedida) }, cellStyle: {textAlign:"right"}});
            configCell.set('detalle', {maxWidth: 1980 });

            this.gridOptionsComponentes3['onSelectionChanged'] = ()=>{
                this.selectedRows = [];
                this.selectedRows = this.gridOptionsComponentes3.api.getSelectedRows();
            };
            this.gridOptionsComponentes3['rowData'] = data.data;
            this.getField('rejilla11').initData(this.gridOptionsComponentes3, configCell);
            this.getField("modificar_detalle").setVisible(true);
            this.modificadetalle="DIA";
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    ItemsContados(){
        let datos={ datos: {
            sucursal:this.row_asentados[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            pedido:this.row_asentados[0].numero,
            factor:this.row_asentados[0].factor,
            boton:"03"
        }};

        this.getField("rejilla11").setTipoServicioOperacion('traz-trazpendientescartera-items');
        this.getField("rejilla11").sendRequest(this.successItemsContados, datos);
    }

    successItemsContados(data){
        if (data.estado_p === 200 ){ 

            this.getField("modal_ver_items").handleClickOpen();

            let configCell = new Map();
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('precio', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.precio) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: {textAlign:"right"}});
            configCell.set('valor_conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor_conteo) }, cellStyle: {textAlign:"right"}});
            configCell.set('cant_pedida', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_pedida) }, cellStyle: {textAlign:"right"}});
            configCell.set('detalle', {maxWidth: 1980 });






            

            this.gridOptionsComponentes3['onSelectionChanged'] = ()=>{
                this.row_items = [];
                this.selectedRows = this.gridOptionsComponentes3.api.getSelectedRows();
            };
            this.gridOptionsComponentes3['rowData'] = data.data;
            this.getField('rejilla11').initData(this.gridOptionsComponentes3, configCell);
            this.getField("modificar_detalle").setVisible(true);
            this.modificadetalle="DICONTADOS";
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    Consulta(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            sucursal : this.getField("sucursal").getValue(),
            codigo_usuario:this.codigo_usuario,
            pedido:this.pedido_consulta
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazconsulta', operacion: 'consulta', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_Consulta,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_Consulta(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField("modal_pedido_consulta").handleClose();
            this.getField("ver_items").setVisible(true);
            this.getField('titulo').setValue('Pedido No. '+this.pedido_consulta);
                
            let configCell = new Map();
            this.gridOptionsComponentes4['rowData'] = data.data;
            this.gridOptionsComponentes4['onSelectionChanged'] = ()=>{
                this.selectedRows = [];
                this.selectedRows = this.gridOptionsComponentes4.api.getSelectedRows();
            };

            configCell.set('sede_encargado', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.sede_encargado) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('sede', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.sede) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('picking', {cellRenderer:(props) => {return ""+props.data.picking }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('pedido', {cellRenderer:(props) => {return ""+props.data.pedido }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('detalle', {maxWidth: 1980 });

            this.getField('rejilla8').initData(this.gridOptionsComponentes4, configCell);

            this.mensajepedido();
            this.habilitarBotonesAdicionales('');
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    mensajepedido(){
        let datos={ datos: {
            sucursal:this.getField('sucursal').getValue(),
            pedido:this.pedido_consulta
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazconsulta', operacion: 'retornarestado', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_mensajepedido,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_mensajepedido(data){
        if (data.estado_p === 200 ){

            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.estado);
            this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm("ACEPTAR"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    verItems(){
        let datos={ datos: {
            sucursal:this.getField("sucursal").getValue(),
            pedido:this.selectedRows[0].pedido
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazconsulta', operacion: 'veritems', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_verItems,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_verItems(data){
        if (data.estado_p === 200 ){

            let configCell = new Map();
            configCell.set('cant_pedida', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_pedida) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('valor_conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor_conteo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('cant_pedida', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_pedida) }, cellStyle: {textAlign:"right"}});
            configCell.set('diferencia', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.diferencia) }, cellStyle: {textAlign:"right"}});

            this.gridOptionsComponentes3['rowData'] = data.data;
            this.getField('rejilla11').initData(this.gridOptionsComponentes3, configCell);
            this.getField("modificar_detalle").setVisible(false);
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    Items(){
        let datos={ datos: {
            sucursal:this.selectedRows1[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            pedido:this.selectedRows1[0].numero,
            factor:this.selectedRows1[0].factor,
            boton:"00"
        }};

        this.getField("rejilla11").setTipoServicioOperacion('traz-trazpendientescartera-items');
        this.getField("rejilla11").sendRequest(this.success_Items, datos);
    }

    success_Items(data){
        if (data.estado_p === 200 ){

            this.getField("modal_ver_items").handleClickOpen();
            let configCell = new Map();
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('precio', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.precio) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: {textAlign:"right"}});
            configCell.set('valor_conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor_conteo) }, cellStyle: {textAlign:"right"}});
            configCell.set('cant_pedida', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_pedida) }, cellStyle: {textAlign:"right"}});
            configCell.set('detalle', {maxWidth: 1980 });
            
            this.gridOptionsComponentes5['onSelectionChanged'] = ()=>{
                this.selectedRows = this.gridOptionsComponentes5.api.getSelectedRows();
            };
            this.gridOptionsComponentes5['rowData'] = data.data;
            this.getField('rejilla11').initData(this.gridOptionsComponentes5, configCell);
            this.getField("modificar_detalle").setVisible(true);
            this.modificadetalle="DIP";
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    autorizar(){
        let datos={ datos: {
            sucursal:this.getField("sucursal").getValue(),
            sucursal_ingreso:this.sucursal_ingreso,
            codigo_usuario:this.codigo_usuario,
            npedido:this.selectedRows1[0].numero,
            fecha_pedido:this.selectedRows1[0].fecha,
            nit:this.selectedRows1[0].nit,
            sede:this.selectedRows1[0].sede,
            estado_credito:this.selectedRows1[0].estado_credito,
            boton:this.selectedRows1[0].bodega,
            sucursal_cartera:this.selectedRows1[0].sucursal_cartera
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'autorizarpedido', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_autorizar,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_autorizar(data){
        if (data.estado_p === 200 ){

            if("detalle0" in data.data){
                this.getField('confirmModalCustom').setTitleAndContent('PEDIDOS', data.data.detalle0);
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("ACEPTAR"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else if ("detalle2" in data.data){
                this.getField('confirmModalCustom').setTitleAndContent('BLOQUEADO POR CUPO', data.data.detalle2);
                this.getField('confirmModalCustom').setClickDialog(() => { this.verpedidos(); });
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("VER PEDIDOS"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('CERRAR');
                this.getField('confirmModalCustom').toggle(true);
            }else if("detalle3" in data.data){
                this.getField('confirmModalCustom').setTitleAndContent('BLOQUEADO POR DÍAS', data.data.detalle3);
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("ACEPTAR"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else if("detalle4" in data.data){
                this.getField('confirmModalCustom').setTitleAndContent('PEDIDOS', data.data.detalle4);
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("ACEPTAR"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else if("detalle1" in data.data){
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.detalle1);
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("ACEPTAR"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else {
                this.accion_detalle='autorizar';
                this.getField("detalle_autorizar").handleClickOpen();
                this.getField('detalle_autorizar').setLabel("Pedido No. "+this.selectedRows1[0].numero +" Fecha: "+this.selectedRows1[0].fecha)
                this.getField("texto_detalle1").setValue(data.data.estado);
                this.getField('ver_pedidos').setDisabled(false);
            } 
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    estadocuenta(){
        let datos={ datos: {
            nit:this.selectedRows1[0].nit,
            sede:this.selectedRows1[0].sede
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'estadocuenta', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_estadocuenta,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_estadocuenta(data){
        if (data.estado_p === 200 ){

            let configCell = new Map();
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('texto', {maxWidth: 1980 });
            
            this.gridOptionsComponentes6['rowData'] = data.data;
            this.getField('rejilla12').initData(this.gridOptionsComponentes6, configCell);

            let configCell2 = new Map();
            configCell2.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell2.set('detalle', {maxWidth: 1980 });
            this.gridOptionsComponentes7['rowData'] = data.data1;
            this.getField('rejilla13').initData(this.gridOptionsComponentes7, configCell2);
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    modificardetalle(){
        let datos={ datos: {
            detalle:this.getField("texto_detalle").getValue(),
            fdespacho:this.getField("fdespacho").getValue(),
            sucursal: this.selectedRows1[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            estado:this.selectedRows1[0].estado,
            npedido:this.selectedRows1[0].numero
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificadetalle', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_modificardetalle,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_modificardetalle(data){
        if (data.estado_p === 200 ){

            this.getField("modal_detalle").handleClose();
            this.pendientescartera();
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    modificarDetalleContado(){
        let datos={ datos: {
            detalle:this.getField("texto_detalle").getValue(),
            fdespacho:this.getField("fdespacho").getValue(),
            sucursal: this.row_asentados[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            estado:this.row_asentados[0].estado,
            npedido:this.row_asentados[0].numero
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificadetalle', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successModificarDetalleContados,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successModificarDetalleContados(data){
        if (data.estado_p === 200 ){

            this.getField("modal_detalle").handleClose();
            this.traerAsentados();
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    modificardetalleitemsContados(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            detalle:this.getField("texto_detalle").getValue(),
            fdespacho:this.getField("fdespacho").getValue(),
            sucursal:this.getField("sucursal").getValue(),
            codigo_usuario:this.codigo_usuario,
            codigo:this.selectedRows[0].codigo,
            bodega:this.selectedRows[0].bodega,
            npedido:this.row_asentados[0].numero
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificadetalleitem', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successModificarDetalleiIemsContados,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successModificarDetalleiIemsContados(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){

            this.getField("modal_detalle").handleClose();
            this.ItemsContados();
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    modificardetalleCartera(){
        let datos={ datos: {
            detalle:this.getField("texto_detalle").getValue(),
            fdespacho:this.getField("fdespacho").getValue(),
            sucursal: this.selectedRows2[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            estado:this.selectedRows2[0].estado,
            npedido:this.selectedRows2[0].numero
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificadetalle', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_modificardetalleCartera,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_modificardetalleCartera(data){
        if (data.estado_p === 200 ){

            this.getField("modal_detalle").handleClose();
            this.AutorizadosCartera();
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    modificadetalleitem(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            detalle:this.getField("texto_detalle").getValue(),
            fdespacho:this.getField("fdespacho").getValue(),
            sucursal:this.selectedRows1[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            codigo:this.selectedRows[0].codigo,
            bodega:this.selectedRows[0].bodega,
            npedido:this.selectedRows1[0].numero
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificadetalleitem', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.success_modificardetalleitem,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_modificardetalleitem(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){

            this.getField("modal_detalle").handleClose();
            this.Items();
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    modificadetalleitemCartera(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            detalle:this.getField("texto_detalle").getValue(),
            fdespacho:this.getField("fdespacho").getValue(),
            sucursal:this.selectedRows2[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            codigo:this.selectedRows[0].codigo,
            bodega:this.selectedRows[0].bodega,
            npedido:this.selectedRows2[0].numero
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificadetalleitem', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.success_modificardetalleitemCartera,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_modificardetalleitemCartera(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){

            this.getField("modal_detalle").handleClose();
            this.Items1();
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    verpedidos(){
        let datos={ datos: {
            sucursal:this.getField("sucursal").getValue(),
            npedido:this.selectedRows1[0].numero,
            cliente:this.selectedRows1[0].nit,
            sede:this.selectedRows1[0].sede
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadoscartera', operacion: 'verpedidos', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_verpedidos,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_verpedidos(data){
        if (data.estado_p === 200 ){

            this.getField('confirmModalCustom').toggle(false);
            this.getField("modal_ver_items").handleClickOpen();
            this.getField('modal_ver_items').setLabel('Pedidos');
            this.getField("modificar_detalle").setVisible(false);

            let configCell = new Map();
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"}});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor) }, cellStyle: {textAlign:"right"}});
            configCell.set('precio', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.precio) }, cellStyle: {textAlign:"right"}});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"}});
            configCell.set('items', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.items) }, cellStyle: {textAlign:"right"}});

            configCell.set('detalle', {maxWidth: 1980 });

            this.gridOptionsComponentes8['rowData'] = data.data;
            this.getField('rejilla11').initData(this.gridOptionsComponentes8, configCell);
            
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    verpedidoAutorizar(){
        let datos={ datos: {
            sucursal:this.getField("sucursal").getValue(),
            pedido:this.selectedRows1[0].numero,
            cliente:this.selectedRows1[0].nit,
            sede:this.selectedRows1[0].sede
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'verpedidoatorizar', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successpedidoAutorizar,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successpedidoAutorizar(data){
        if (data.estado_p === 200 ){
            this.getField('modal_ver_items').setLabel('Pedidos');
            this.getField("modal_ver_items").handleClickOpen();
            let configCell = new Map();
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('precio', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.precio) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('detalle', {maxWidth: 1980 });

            this.gridOptionsComponentes9['onSelectionChanged'] = ()=>{
                this.selectedRows = [];
                this.selectedRows = this.gridOptionsComponentes9.api.getSelectedRows();
            };
            this.gridOptionsComponentes9['rowData'] = data.data;
            this.getField('rejilla11').initData(this.gridOptionsComponentes9, configCell);
            this.getField("modificar_detalle").setVisible(false);
            configCell.set('detalle', { hide: true });

        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    direccioncliente(){
        let datos={ datos: {
            cliente:this.selectedRows1[0].nit,
            sede:this.selectedRows1[0].sede
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'direccioncliente', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successdireccioncliente,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successdireccioncliente(data){
        if (data.estado_p === 200 ){

            this.traerciudad();        
        }else {
            if(data.estado_p===404) {
                this.getField('confirmModalCustom').setTitleAndContent('MENSAJE', "No existen direcciones alternas para este cliente.");
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("ACEPTAR"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    traerciudad(){
        let datos={ datos: {
            cliente:this.selectedRows1[0].nit,
            pedido:this.selectedRows1[0].numero,
            sede:this.selectedRows1[0].sede
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'traerciudad', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successtraerciudad,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successtraerciudad(data){
        if (data.estado_p === 200 ){

            this.getField("modal_direccion").handleClickOpen();
            
            this.getField("nit").setValue(this.selectedRows1[0].nit);
            this.getField("sede").setValue(this.selectedRows1[0].sede);
            this.getField("nombre").setValue(this.selectedRows1[0].nombre);
            this.getField("direccion1").setValue(this.selectedRows1[0].direccion_entrega);
            this.getField("pedido").setValue(this.selectedRows1[0].numero);
            this.getField("nombre_ciudad").setValue(this.selectedRows1[0].nciudad);
            this.getField("ciudad").setValue(data.data.data[0].ciudad);

            let configCell = new Map();
            configCell.set('direccion', {maxWidth: 1980 });
            configCell.set('ncliente', {maxWidth: 1980 });
            configCell.set('nombre', {maxWidth: 1980 });
            configCell.set('detalle', {maxWidth: 1980 });

            this.gridOptionsComponentes10['onSelectionChanged'] = ()=>{
                this.selectedRows3 = [];
                this.selectedRows3 = this.gridOptionsComponentes10.api.getSelectedRows();
                if(this.selectedRows3.length>0){
                    this.getField("direccion1").setValue(this.selectedRows3[0].direccion);
                    this.getField("nombre_ciudad").setValue(this.selectedRows3[0].nciudad);
                    this.getField("ciudad").setValue(this.selectedRows3[0].ciudad);
                }
            };
            this.gridOptionsComponentes10['rowData'] = data.data.datos;
            this.getField('rejilla14').initData(this.gridOptionsComponentes10, configCell);
        
        }else {
            if(data.estado_p===404) {
                this.getField('confirmModalCustom').setTitleAndContent('MENSAJE', "No existen direcciones alternas para este cliente.");
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("ACEPTAR"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    modificadireccion(){
        let datos={ datos: {
            direccion:this.getField("direccion1").getValue(),
            nit:this.getField("nit").getValue(),
            sede:this.getField("sede").getValue(),
            npedido:this.selectedRows1[0].numero,
            fecha:this.selectedRows1[0].fecha,
            estado:this.selectedRows1[0].estado,
            codigo_usuario:this.codigo_usuario,
            ciudad:this.getField("ciudad").getValue()
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificadireccion', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_modificadireccion,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_modificadireccion(data){
        if (data.estado_p === 200 ){

            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', "Datos modificados con éxito!");
            this.getField('confirmModalCustom').setClickDialog(() => {
                this.getField('confirmModalCustom').toggle(false);
                this.getField("modal_direccion").handleClose();
                this.pendientescartera();
            });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm("ACEPTAR"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField("confirmModalCustom").setButtonCancel('NO');
            this.getField('confirmModalCustom').toggle(true);

           
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    pendienteContados(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            bodega:this.row_asentados[0].bodega,
            pedido:this.row_asentados[0].numero,
            sucursal:this.row_asentados[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            sede:this.row_asentados[0].sede,
            nit:this.row_asentados[0].nit,
            detalle:this.row_asentados[0].detalle,
            fecha:this.row_asentados[0].fecha,
            estado:this.xestado,
            estado_pedido:this.row_asentados[0].estado,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadoscartera', operacion: 'devolverpendiente', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successPendienteContados,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successPendienteContados(data){
        if (data.estado_p === 200 ){
            if(data.data.mensaje!==undefined){
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje);
                this.getField('confirmModalCustom').setClickDialog(() => { 
                    this.getField('confirmModalCustom').toggle(false);
                    this.traerAsentados();  
                 });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.traerAsentados();  
            }
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    pendiente(){
        let datos={ datos: {
            bodega:this.selectedRows2[0].bodega,
            pedido:this.selectedRows2[0].numero,
            sucursal:this.selectedRows2[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            sede:this.selectedRows2[0].sede,
            nit:this.selectedRows2[0].nit,
            detalle:this.selectedRows2[0].detalle,
            fecha:this.selectedRows2[0].fecha,
            estado:this.xestado,
            estado_pedido:this.selectedRows2[0].estado,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadoscartera', operacion: 'devolverpendiente', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successPendiente,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successPendiente(data){
        this.getField('confirmModalCustom').toggle(true);
        if (data.estado_p === 200 ){
            if(data.data.mensaje!==undefined){
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje);
                this.getField('confirmModalCustom').setClickDialog(() => { 
                    this.getField('confirmModalCustom').toggle(false);
                    this.AutorizadosCartera();
                 });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.AutorizadosCartera();
            }
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    autorizarpedido(){
        let datos={ datos: {
            nit:this.selectedRows1[0].nit,
            sede:this.selectedRows1[0].sede,
            codigo_usuario:this.codigo_usuario,
            npedido:this.selectedRows1[0].numero,
            fecha:this.selectedRows1[0].fecha,
            sucursal:this.selectedRows1[0].codigo_sucursal,
            detalle:this.getField("detalle_autorizado").getValue(),
            venta_contado:this.selectedRows1[0].venta_contado,
            bodega:this.selectedRows1[0].bodega,
            sucursal_ingreso:this.sucursal_ingreso,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'autorizar', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successAutorizarPedido,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successAutorizarPedido(data){
        if (data.estado_p === 200 ){

            this.getField("detalle_autorizar").handleClose();
            this.pendientescartera();
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    consultarpedido(){
        let datos={ datos: {
            pedido:this.selectedRows1[0].numero,
            sucursal_origen:this.selectedRows1[0].sucursal_origen,
            nit:this.selectedRows1[0].nit,
            sede:this.selectedRows1[0].sede,
            sucursal_ingreso : this.sucursal_ingreso,
            sucursal : this.getField("sucursal").getValue(),
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'consultarpedido', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successconsultarpedido,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successconsultarpedido(data) {
        if (data.estado_p === 200) {
            this.salir = false;
            let datos = data.data.item_pedido;
            this.tasa_cambio=data.data.pedido[0].factor;    
            // Solo actualizamos this.datosAntiguos si el número de pedido ha cambiado
            if (this.numeropedido !== this.selectedRows1[0].numero) {
                // Clonación profunda para evitar referencias compartidas
                this.datosAntiguos = JSON.parse(JSON.stringify(datos));
            }
            
            // En este punto, this.datosAntiguos tiene el valor correcto según la condición anterior
            
            this.numeropedido = this.selectedRows1[0].numero;
            
            this.getField("modal_editar_pedido").handleClickOpen();
            this.getField("modal_editar_pedido").setLabel("Modificando el pedido Nro. " + this.selectedRows1[0].numero);
    
            let datosFicha = [];
            this.lista = data.data.encabezado;
            let data2 = {
                "nit": this.lista[0].nit,
                "sede": this.lista[0].sede,
                "nombre": this.lista[0].nombre,
                "telefono": this.lista[0].telefonos,
                "vendedor": this.lista[0].codigo_vendedor,
                "nombre_vendedor": this.lista[0].nvendedor,
                "vence": data.data.pedido[0].vence,
                "tasa": data.data.pedido[0].factor
            };
            datosFicha.push(data2);
            this.getField('lista_datos_general').setItemsFichas(datosFicha);
    
            this.getField('iva').setValue(data.data.totales[0].iva);
            this.getField('subtotal').setValue("".redondear(data.data.totales[0].subtotal,2));
            this.getField('valor_pedido').setValue("".redondear(data.data.totales[0].xprecio_total,2));
    
            this.getField('iva').setDisabled(true);
            this.getField('subtotal').setDisabled(true);
            this.getField('valor_pedido').setDisabled(true);
            
            if(data.data.mostrador === "S"){
                this.getField('orden').setValue(data.data.pedido[0].orden_compra);
                this.getField('fentrega').setValue(new Date().toISOString().split('T')[0]);
                this.getField('fvalidez').setValue(new Date().toISOString().split('T')[0]);
                this.getField('orden').setDisabled(true);
                this.getField('fentrega').setDisabled(true);
                this.getField('fvalidez').setDisabled(true);
            }else{
                this.getField('orden').setValue(data.data.pedido[0].orden_compra);
                this.getField('fentrega').setValue(data.data.pedido[0].fecha_entrega);
                this.getField('fvalidez').setValue(data.data.pedido[0].fecha_validez);
            }

    
            let configCell = new Map();
    
            // Definir configuración para columnas
            const columnConfig = {
                item: { width: 101 },
                codigo: { width: 160 },
                nombre: { width: 160 },
                cantidad: {
                    cellRenderer: (props) => props.data.cantidad,
                    cellStyle: { backgroundColor: "rgb(238,238,238)", textAlign: "right", borderRadius: "5px", color: 'rgb(0, 86, 201)' },
                    editable: true,
                    onCellValueChanged: this.cantidadopcionesChange,
                    sortable: true,
                    filter: false,
                    field: 'cantidad',
                    width: 130
                },
                iva: {
                    cellRenderer: (props) => "" + this.currencyFormatterGeneral(props.data.iva),
                    cellStyle: { textAlign: "right" },
                    width: 100
                },
                precio_sin_iva: {
                    cellRenderer: (props) => this.currencyFormatterGeneral4Decimales(props.data.precio_sin_iva),
                    cellStyle: { backgroundColor: "rgb(238,238,238)", textAlign: "right", borderRadius: "5px", color: 'rgb(0, 86, 201)' },
                    editable: true,
                    onCellValueChanged: this.preciosinivaopcionesChange,
                    sortable: true,
                    filter: false,
                    field: 'precio_sin_iva',
                    width: 130
                },
                valor_descuento: {
                    cellRenderer: (props) => "" + this.currencyFormatterGeneral(props.data.valor_descuento),
                    cellStyle: { textAlign: "right" },
                    width: 130
                },
                precio_mas_iva: {
                    cellRenderer: (props) => "" + this.currencyFormatterGeneral(props.data.precio_mas_iva),
                    cellStyle: { textAlign: "right" },
                    width: 130
                },
                valor_item: {
                    cellRenderer: (props) => "" + this.currencyFormatterGeneral(props.data.valor_item),
                    cellStyle: { textAlign: "right" },
                    width: 130
                }
            };
    
            // Calcular el ancho de las columnas basado en el nombre de las columnas
            Object.keys(columnConfig).forEach(key => {
                columnConfig[key].width = Math.max(150, key.length * 15);
            });
    
            // Asignar configuración a las columnas
            Object.keys(columnConfig).forEach(key => {
                configCell.set(key, columnConfig[key]);
            });
    
            // Asignar datos a la tabla
            this.gridOptionsComponentes11['rowData'] = data.data.data; // Clonación profunda para evitar referencias compartidas
    
            // Aplicar configuración a la tabla
            this.getField('rejilla15').initData(this.gridOptionsComponentes11, configCell);
    
            // Renderizar la tabla

            //cargartipo

            let opciones = [{'text':'Ninguno','value':'','campos_cambian':{}}];
            data.data.cargartipo.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.siglas;
                dataOp['text'] = item.siglas + " " + item.descripcion;
                dataOp['campos_cambian'] = { };
                opciones.push(dataOp);
            });
            this.getField('tipopedido').setOptions(opciones);

            data.data.cargartipo.forEach(item => {
                if(item.siglas===data.data.pedido[0].clase_pedido)
                    this.getField('tipopedido').setValue(data.data.pedido[0].clase_pedido);
            });
            

            this.validarCliente(this.lista[0].nit,this.lista[0].sede);
    
        } else {
            if (data.estado_p === 404) {
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje);
                this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            } else {
                let respuesta = Object.values(data.data.errores);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', respuesta);
                this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }
        }
    } 

    validarCliente(nit,sede) {
        let datos = { datos: {
            nit: nit,
            sede: sede,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'validarcliente', operacion_tipo: 'consultar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method: 'GET',
            body: datos,
            success: this.successValidarCliente,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false
        });
    }

    successValidarCliente(data){
        if (data.estado_p === 200 ){
            
        }else {
            if(data.data.mensaje_mostrar!==undefined){
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => { 
                    this.getField('confirmModalCustom').toggle(false); 
                    this.getField('modal_editar_pedido').handleClose();
                });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("Aceptar"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else{
                if(data.estado_p===404) {
                    this.mostrarMensajeNoHayDatos();
                }
                else {
                    let respuesta=Object.values(data.data.errores);
                    this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
                }
            }
        }
    }

    cantidadopcionesChange(props) {
        let seguir = this.getField('rejilla15').cellValid(props.oldValue, props.newValue, /^-?(\d{1,10})(\.\d{0,2})?$/,13);
        //const regex = /^([0-9]{1,11})(\.[0-9]{0,4})?$/;

         if (isNaN(props.data.cantidad) || seguir === false) {
            this.getField('confirmModalCustom').setTitleAndContent('Formato Incorrecto', `La columna cantidad no cumple con el formato deseado.`);
            this.getField('confirmModalCustom').setClickDialog(() => {
                this.getField('confirmModalCustom').toggle(false);
                this.consultarpedido();
            });
            this.getField("confirmModalCustom").setVisibleCancel(true);
            this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
            this.getField('confirmModalCustom').toggle(true);
        }else if(seguir){ 
            if (props.newValue <=0 ||  props.newValue > 999999999.99) {
                this.getField('confirmModalCustom').setTitleAndContent('Formato Incorrecto', `El valor debe estar entre las longitudes (0.01 , 999999999.99)`);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                    this.consultarpedido();
                });
                this.getField("confirmModalCustom").setVisibleCancel(true);
                this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
                this.getField('confirmModalCustom').toggle(true);
            } else {
                this.props = props.data;       
                this.valor_actual = props.newValue;
                let datos = { datos: {
                    cantidad: parseFloat(this.valor_actual),
                    codigo:props.data.codigo,
                    sucursal:this.selectedRows1[0].codigo_sucursal,
                    bodega:this.selectedRows1[0].bodega
                }};
                this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'validarcantidades', operacion_tipo: 'consultar' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successValidarCantidad,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
            }
            
        }
    }

    successValidarCantidad(data){

        if (data.estado_p === 200 ){
            if(data.data.autorizarUMD){
                this.va_a_autorizar=false;
                this.getField("modal_pedir_autorizacion").handleClickOpen();
                this.getField("modal_pedir_autorizacion").setLabel("Autorización de Unidad Mínima de Despacho (" + data.data.umd + ")");
                this.getField("articulo").setValue(this.props.codigo);
                this.getField("nombre_articulo").setValue(this.props.nombre);
                this.getField("cliente1").setValue(this.selectedRows1[0].nit);
                this.getField("sede1").setValue(this.selectedRows1[0].sede);
                this.getField("nombre_cliente").setValue(this.selectedRows1[0].nombre);
                this.modulo='FACTURA_UMD';
                this.tipo='cantidad';
                this.tasa_cambio=1;
                this.elvalor=0;
                this.precio_inicial=0;
            }else{
                this.SaldoCantidad();
            }
        }else {
            if(data.estado_p===404) {
                this.consultarpedido();
                let respuesta = Object.values(data.data.errores);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', respuesta);
                this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
                this.consultarpedido();
            }
        }
    }
    
    SaldoCantidad() {
        let datos = { datos: {
            codigo: this.props.codigo,
            nombre: this.props.nombre,
            cantidad: parseFloat(this.valor_actual),
            pedido:this.selectedRows1[0].numero
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'saldocantidad', operacion_tipo: 'consultar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method: 'GET',
            body: datos,
            success: this.successSaldoCantidad,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false
        });
    }

    successSaldoCantidad(data){
        if (data.estado_p === 200 ){
            this.cambiarCantidad();
        }else {
            if(data.estado_p===404) {
                let respuesta = Object.values(data.data.errores);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', respuesta);
                this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); this.cambiarCantidad();});
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("SI"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false); this.consultarpedido();});
                this.getField('confirmModalCustom').toggle(true);
            }
            else {
                this.consultarpedido();
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    cambiarCantidad(){
        let datos = { datos: {
            cantidad: parseFloat(this.valor_actual),
            precio:parseFloat(this.props.precio_mas_iva),
            codigo:this.props.codigo,
            pedido:this.selectedRows1[0].numero,
            sucursal:this.selectedRows1[0].codigo_sucursal,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificarcantidad', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method: 'PUT',
            body: datos,
            success: this.successCambiarCantidad,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    successCambiarCantidad(data){
        if (data.estado_p === 200 ){
            this.consultarpedido();
        }else {
            if(data.estado_p===404) {
                this.consultarpedido();
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    preciosinivaopcionesChange(props) {
        // Expresión regular para validar 13 dígitos enteros y 2 decimales
        const regex = /^([0-9]{1,11})(\.[0-9]{0,4})?$/;
    
        // Obtener el nuevo valor ingresado
        const nuevoValor = props.newValue;
    
        // Validar que el valor no sea negativo y cumpla con la expresión regular
        const esFormatoValido = regex.test(nuevoValor);
        const esValorNoNegativo = parseFloat(nuevoValor) >= 0;
    
        if (!esFormatoValido) {
            this.getField('confirmModalCustom').setTitleAndContent('Formato Incorrecto', 
                'El formato debe ser un número con hasta 11 dígitos antes del punto decimal y hasta 4 decimales.');
            this.getField('confirmModalCustom').setClickDialog(() => {
                this.getField('confirmModalCustom').toggle(false);
                this.consultarpedido();
            });
            this.getField("confirmModalCustom").setVisibleCancel(true);
            this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
            this.getField('confirmModalCustom').toggle(true);
        } else if (esFormatoValido && esValorNoNegativo) {
            this.autoriza_descuento=false;
            this.autoriza_costo=false;

            if (props.newValue <=0 ||  props.newValue > 9999999999.99) {
                this.getField('confirmModalCustom').setTitleAndContent('Formato Incorrecto', `El valor debe estar entre las longitudes (0.0001 , 9999999999.9999)`);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                    this.consultarpedido();
                });
                this.getField("confirmModalCustom").setVisibleCancel(true);
                this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.props_principales = props;
                this.modificarprecio();
            }
        }
    }

    modificarprecio(){
        let datos = { datos: {
            cantidad: parseFloat(this.props_principales.data.cantidad),
            precio: parseFloat(this.props_principales.data.precio_sin_iva),
            iva: parseFloat(this.props_principales.data.iva),
            descuento: parseFloat(this.props_principales.data.descuento),
            codigo: this.props_principales.data.codigo,
            pedido: this.selectedRows1[0].numero,
            sucursal: this.selectedRows1[0].codigo_sucursal,
            cliente: this.selectedRows1[0].nit,
            bodega: this.selectedRows1[0].bodega,
            sede: this.selectedRows1[0].sede,
        }};
        if(this.autoriza_descuento)
            datos.datos.autoriza_descuento=this.autoriza_descuento;
        if(this.autoriza_costo)
            datos.datos.autoriza_costo=this.autoriza_costo;
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificarprecio', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method: 'PUT',
            body: datos,
            success: this.successCambiarPrecioSinIva,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    successCambiarPrecioSinIva(data){
        if (data.estado_p === 200 ){
            if(data.data.autorizadesc!== undefined){
                this.autoriza_descuento=true;
                this.va_a_autorizar=false;
                this.getField("modal_pedir_autorizacion").handleClickOpen();
                this.getField("modal_pedir_autorizacion").setLabel("Autorización de descuentos. Precio mínimo permitido: "+ data.data.autorizadesc.precio_minimo);
                this.getField("articulo").setValue(this.props_principales.data.codigo);
                this.getField("nombre_articulo").setValue(this.props_principales.data.nombre);
                this.getField("cliente1").setValue(this.selectedRows1[0].nit);
                this.getField("sede1").setValue(this.selectedRows1[0].sede);
                this.getField("nombre_cliente").setValue(this.selectedRows1[0].nombre);
                this.modulo='FACTURA_DESCUENTOS';
                this.tipo='descuento';
                //this.tasa_cambio=this.props_principales.pedido.factor; //la seteo en el servicio de consultarpedido
                this.elvalor=data.data.autorizadesc.precio_minimo;
                this.precio_inicial=data.data.autorizadesc.precio_inicial;
    
            }else if(data.data.autorizacosto!==undefined){
                this.autoriza_costo=true;
                this.va_a_autorizar=false;
                this.getField("modal_pedir_autorizacion").handleClickOpen();
                this.getField("modal_pedir_autorizacion").setLabel("Precio por debajo del costo: COSTO PRODUCTO: "+ data.data.autorizacosto.costo);
                this.getField("articulo").setValue(this.props_principales.data.codigo);
                this.getField("nombre_articulo").setValue(this.props_principales.data.nombre);
                this.getField("cliente1").setValue(this.selectedRows1[0].nit);
                this.getField("sede1").setValue(this.selectedRows1[0].sede);
                this.getField("nombre_cliente").setValue(this.selectedRows1[0].nombre);
                this.modulo='FACTURACION';
                this.tipo='costo';
                //this.tasa_cambio=this.props_principales.pedido.factor;  //la seteo en el servicio de consultarpedido
                this.elvalor=data.data.autorizacosto.precio;
                this.precio_inicial=data.data.autorizacosto.precio_inicial;
                
            }else{
                this.consultarpedido();
            }
        }else {
            this.consultarpedido();
            if(data.estado_p===404) {
                //this.consultarpedido();
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    autorizarModulo(){

        let datos = { datos: {
            aleatorio: this.getField('numero_autorizacion').getValue(),
            articulo: this.getField('articulo').getValue(),
            cliente: this.getField('cliente1').getValue(),
            sede: this.getField('sede1').getValue(),
            modulo: this.modulo,
            tasa_cambio: this.tasa_cambio,
            tipo:this.tipo,
            elvalor:this.elvalor,
            precio_inicial:this.precio_inicial,
            sucursal_ingreso:this.sucursal_ingreso,
        }};
        if(this.autoriza_descuento)
            datos.datos.autoriza_descuento=this.autoriza_descuento;
        if(this.autoriza_costo)
            datos.datos.autoriza_costo=this.autoriza_costo;
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'pedirautorizacion', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method: 'PUT',
            body: datos,
            success: this.successAutorizarModulo,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    successAutorizarModulo(data){
        if (data.estado_p === 200 ){
            this.va_a_autorizar=true;
            if(this.tipo==='cantidad'){
                this.cambiarCantidad();
            }else{
                this.modificarprecio();
            }
            this.getField("modal_pedir_autorizacion").handleClose();
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }
    
    devolvercambiopedido() {
        let datos = { datos: {
            items: this.datosAntiguos,
            pedido:this.selectedRows1[0].numero,
            estado:this.selectedRows1[0].estado,
            sucursal:this.selectedRows1[0].codigo_sucursal,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'devolvercambio', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method: 'PUT',
            body: datos,
            success: this.successdevolvercambio,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    successdevolvercambio(data){
        if (data.estado_p === 200 ){
            //this.getField("modal_editar_pedido").handleClose();
            this.salir=true;
        }else {
            if(data.estado_p===404) {
                this.consultarpedido();
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    grabareditarpedido(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Atención','Oprima Si para confirmar la orden '+this.getField("orden").getValue()+', Oprima en No para modificarla.');
        this.getField('confirmModalCustom').setClickDialog(() => { 
                this.getField('confirmModalCustom').toggle(false);
                this.mostrarMensajeGuardando();
                let datos={ datos: {
                    npedido:this.selectedRows1[0].numero,
                    sucursal:this.selectedRows1[0].codigo_sucursal,
                    fentrega:this.getField("fentrega").getValue(),
                    fvalidez:this.getField("fvalidez").getValue(),
                    clase_pedido:this.getField("tipopedido").getValue(),
                    orden_compra:this.getField("orden").getValue(),
                    sucursal_ingreso:this.sucursal_ingreso,
                    bodega:this.bodega,//bodega_pick
                    nit:this.selectedRows1[0].nit,
                    sede:this.selectedRows1[0].sede,
                    estado:this.selectedRows1[0].estado,
                }};
                this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'editarpedido', operacion_tipo: 'modificar' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method:'PUT',
                    body: datos,
                    success: this.successgrabareditarpedido,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        });
        this.getField("confirmModalCustom").setButtonCancel('NO');
        this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("Si"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);

        
    }

    successgrabareditarpedido(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){

            this.salir = true;
            this.getField('confirmModalCustom').setTitleAndContent('Datos Grabados', 'Pedido No. '+this.selectedRows1[0].numero);
            this.getField('confirmModalCustom').setClickDialog(() => { 
                this.getField('confirmModalCustom').toggle(false);  
                this.getField("modal_editar_pedido").handleClose(); 

                this.abrirImprimir();
                this.getField('ch_excel').setVisible(false);
                this.getField('ch_pantalla').setVisible(false);
                this.getField('ch_pdf').setValueSwitch(true);
                this.getField('radio_correo').setDisabled(false);
                
                this.operacion_actual='pdf';
                this.nombre_archivo='pedidos';
                this.boton='editarpedido';
                

                this.npedido=this.selectedRows1[0].numero;
                this.estado_pedido_2=this.selectedRows1[0].estado;


                this.pendientescartera(); 
                

                
            });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    mostrarMensajeNoHayDatos(){
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    currencyFormatterGeneral(number)
    {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
          if ((decimal !== 0) && (decimal !== undefined)) {
            if(decimal.length>2){
              decimal=(Number(number).toFixed(2) + "").split(".")[1];
            }
          return (this.formatNumberSaldo(number) + "," + decimal);
          } else {
          return this.formatNumberSaldo(number); }
    }

    currencyFormatterGeneral3Decimales(number)
    {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
          if ((decimal !== 0) && (decimal !== undefined)) {
            if(decimal.length>4){
              decimal=(Number(number).toFixed(3) + "").split(".")[1];
            }
          return (this.formatNumberSaldo(number) + "," + decimal);
          } else {
          return this.formatNumberSaldo(number); }
    }

    currencyFormatterGeneral4Decimales(number)
    {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
          if ((decimal !== 0) && (decimal !== undefined)) {
            if(decimal.length>4){
              decimal=(Number(number).toFixed(4) + "").split(".")[1];
            }
          return (this.formatNumberSaldo(number) + "," + decimal);
          } else {
          return this.formatNumberSaldo(number); }
    }

    formatNumberSaldo(number)
    {
            return Number(number).toString().split('.')[0]
             .toString()
             .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }

    limpiarTablas() {
        // Ocultar todos los campos
        this.getField("editar_pedido").setVisible(false);
        this.getField("autorizar").setVisible(false);
        this.getField("items").setVisible(false);
        this.getField("cliente").setVisible(false);
        this.getField("detalle").setVisible(false);
        this.getField("direccion").setVisible(false);

        this.getField("llevar_picking").setVisible(false);
        this.getField("items1").setVisible(false);
        this.getField("pendiente").setVisible(false);
        this.getField("detalle1").setVisible(false);
        this.getField("seleccionar_registro").setVisible(false);
        this.getField("bt_autorizar_inventario").setVisible(false);
    
        // Ocultar las rejillas
        this.getField('rejilla').toggle(false);
        this.getField('rejilla2').toggle(false);
    }

    seleccionartodo() {
        let configCell = new Map();
    
        // Verifica si todos los registros están seleccionados
        const allSelected = this.gridOptionsComponentes2['rowData'].every(row => row['x'] === true);
    
        // Configura la función para alternar el valor de la celda
        this.toggleCellValueInRow = (rowNode, columnName, selectAll = false) => {
            const currentValue = rowNode[columnName];
            const newValue = selectAll ? true : (currentValue === true ? false : true); // Alterna entre true y false
    
            // Actualiza el valor de la columna en la fila
            rowNode[columnName] = newValue;
    
            // Actualiza la fila en la tabla
            this.gridOptionsComponentes2.api.applyTransaction({ update: [rowNode] });
    
            // Actualiza selectedRowsArray dependiendo del nuevo estado
            if (newValue === true && !this.selectedRowsArray.includes(rowNode)) {
                this.selectedRowsArray.push(rowNode);
            } else if (newValue === false) {
                // Si el valor se cambia a false, se elimina de selectedRowsArray
                this.selectedRowsArray = this.selectedRowsArray.filter(row => row !== rowNode);
            }
        };
    
        if (allSelected) {
            // Si todos los registros están seleccionados, desmarcarlos todos
            this.gridOptionsComponentes2['rowData'].forEach(row => {
                const columnName = 'x';
                this.toggleCellValueInRow(row, columnName, false);
            });
        } else {
            // Si no todos los registros están seleccionados, seleccionarlos todos
            this.gridOptionsComponentes2['rowData'].forEach(row => {
                const columnName = 'x';
                this.toggleCellValueInRow(row, columnName, true);
            });
        }
    
        // Asegura que selectedRowsArray tenga solo las filas con valor true en la columna 'x'
        this.selectedRowsArray = this.gridOptionsComponentes2['rowData'].filter(row => row['x'] === true);
    
        // Inicializa la tabla con los datos de selectedRowsArray
        this.gridOptionsComponentes2.api.setRowData(this.gridOptionsComponentes2['rowData']);
    
        // Inicializa la rejilla con la configuración
        this.getField('rejilla2').initData(this.gridOptionsComponentes2, configCell);
    
        // Llama a la función success_AutorizadosCartera para que vuelva a funcionar correctamente
        const data = { estado_p: 200, data: this.gridOptionsComponentes2['rowData'] };
        //this.success_AutorizadosCartera(data);

        this.funcionesTablaMultiCheck();

        // Inicializa la tabla con los datos
        this.gridOptionsComponentes2['rowData'] = data.data;
        // Inicializa la rejilla con la configuración
        this.getField('rejilla2').initData(this.gridOptionsComponentes2, configCell);
    }

    ///llevar a picking 
    llenartipopicking(){
        this.getField("modal_picking").handleClickOpen();
        this.getField("vendedor").setDisabled(true);
        this.getField("fecha_corte").setDisabled(true);
        this.getField("hora_corte").setDisabled(true);
        this.getField("turno").setDisabled(true);

        this.getField("hora_corte").setValue(new Date().getHours()+':'+new Date().getMinutes());

        let tipopicking = [];
        if (this.wms === 'S') {
            tipopicking = [
                {
                    "nombre": "PEDIDO VARIOS",
                    "valor": "V"
                }
            ]                    
        } else {
            tipopicking = [
                {
                    "nombre": "POR PEDIDO",
                    "valor": "P"
                },
                {
                    "nombre": "POR REFERENCIA",
                    "valor": "R"
                },
                {
                    "nombre": "POR GRUPO",
                    "valor": "G"
                },
                {
                    "nombre": "POR UBICACION",
                    "valor": "U"
                }
            ]
        }

        let opciones = [{'text':'Ninguno','value':'','campos_cambian':{}}];
        tipopicking.forEach(item => {
            let dataOp = {}
            dataOp['value'] = item.valor;
            dataOp['text'] = item.nombre;
            dataOp['campos_cambian'] = { };
            opciones.push(dataOp);
        });
        this.getField('tipo_picking').setOptions(opciones);
        //this.getField('modal_picking').handleClickOpen();
        
    }

    llevarApicking(){
        let errores=0;
        
        if(!this.getField('tipo_picking').valid())
            errores++;
        if(this.getField('tipo_picking').getValue()!=='P' && this.getField('tipo_picking').getValue()!=='V'){
            if(!this.getField('vendedor').valid())
                errores++;
            else{
                if(!this.getField('vendedor_nombre').valid())
                    errores++;
            }
            if(!this.getField('fecha_corte').valid())
                errores++;
            if(!this.getField('hora_corte').valid())
                errores++;
            if(!this.getField('turno').valid())
                errores++;
            else{
                if(!this.getField('nombre_turno').valid())
                    errores++;
            }
        }
        if(errores===0){
            this.vendedor=this.getField('vendedor').getValue();
            this.fecha_corte=this.getField('fecha_corte').getValue();
            this.hora_corte=this.getField('hora_corte').getValue();
            this.turno=this.getField('turno').getValue();

            this.tipo_picking=this.getField('tipo_picking').getValue();
            if(this.getField('tipo_picking').getValue()==='P'){
                this.getField('modal_picking').handleClose();

                this.pide_encargado=true;
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje','Desea conservar el conteo de este pedido?');
                this.getField('confirmModalCustom').setClickDialog(() => { 
                    this.conservar_conteo=true;
                    //pedir encargado
                    this.getField('modal_encargado').setLabel('Pedido No. ' + this.selectedRowsArray[0].numero + ' Fecha: ' + this.selectedRowsArray[0].fecha);
                    this.getField('modal_encargado').handleClickOpen();
                    this.getField('confirmModalCustom').toggle(false); 
                });
                this.getField("confirmModalCustom").setButtonCancel('NO');
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
                    this.getField('confirmModalCustom').toggle(false); 
                    this.conservar_conteo=false;
                    //pedir encargado
                    this.getField('modal_encargado').setLabel('Pedido No. ' + this.selectedRowsArray[0].numero + ' Fecha: ' + this.selectedRowsArray[0].fecha);
                    this.getField('modal_encargado').handleClickOpen();

                });
                this.getField("confirmModalCustom").setButtonConfirm("Si"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
                this.getField('confirmModalCustom').toggle(true);


            }else if(this.getField('tipo_picking').getValue()==='V'){ //varios
                // pide encargado mas no pregunta por conservar el conteo
                this.getField('modal_picking').handleClose();
                this.pide_encargado=true;
                this.conservar_conteo=false;
                this.getField('modal_encargado').setLabel('Seleccione el encargado para los pedidos');
                this.getField('modal_encargado').handleClickOpen();
            }else{
                this.pide_encargado=false;
                if(this.getField('tipo_picking').getValue()==='U'){ //PIDE TURNO
                    this.getField('modal_turnos').handleClickOpen();
                }else{
                    this.getField('modal_picking').handleClose();
                    this.mostrarMensajeGuardando();
                    let datos = { datos: {
                        tipo_picking:this.tipo_picking,
                        vendedor:this.vendedor,
                        fecha_corte:this.fecha_corte,
                        hora_corte:this.hora_corte,
                        turno:this.turno,
                        items: this.selectedRowsArray,
                        sucursal_ingreso:this.sucursal_ingreso,
                        sucursal:this.getField('sucursal').getValue(),
                        xestado:this.xestado,
                        bodegas:this.bodega,

                    }};

                    this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadoscartera', operacion: 'llevarpicking', operacion_tipo: 'crear' };
                    this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method:'POST',
                        body: datos,
                        success: this.successLlevarAPicking,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                    });
                }
            }
        }else{
            this.mostrarMensajeAdicional("Existe un campo vacío o mal configurado.")
        }

    }

    successLlevarAPicking(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {
            this.getField('modal_picking').handleClose();
            this.getField('confirmModalCustom').toggle(false);
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
            this.getField('confirmModalCustom').setClickDialog(() => {
                this.getField('confirmModalCustom').toggle(false);
                //refrescar datos-------------->
                //ver items picking -->
                this.nombre_archivo='presentacion';
                if(data.data.imprimir!==undefined && data.data.imprimir===true){
                    this.boton='picking';
                    this.abrirImprimir();
                    if(this.sacar_pedido){
                        this.sacarPedido(); //esto es para Repicking en apartado EN PICKING
                    }
                }else if(data.data.ver_items!==undefined){
                    this.titulo=data.data.titulo;
                    this.mostrarPicking(data);
                }
                this.consecutivo_picking=data.data.consecutivo_picking;
                this.selectedRowsArrayAux=this.selectedRowsArray;
                this.recargarInfo();

            });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm('OK'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            //this.getField("confirmModalCustom").setButtonCancel('NO');
            this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
            this.getField('confirmModalCustom').toggle(true);
        }else {
            this.getField('confirmModalCustom').toggle(false);
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos', 'error');
            }
            else {
              let respuesta=Object.values(data.data.errores);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    mostrarMensajeAdicional(mensaje){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleConfirm(false); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGuardando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }



    generarPdfTabla3(datosaux)
        {       
            let op='';
            let modelo='';
            if(this.boton==='trasladar'){
                op='consultatraslado'
                modelo='inve-consultatraslados';
            }else if(this.boton==='remisionar'){
                op='imprimiriremisionar'
                modelo='traz-trazcontados';
            }else if(this.boton==='factura'){
                op='imprimirfacturar'
                modelo='traz-trazcontados';
            }else if(this.boton==='editarpedido'){
                op='imprimirpedido'
                modelo='traz-trazpendientescartera';
            }else{
                op='imprimiritemspiking_pag'
                modelo='traz-trazautorizadoscartera';
            }
            this.mostrarMensajeGenerando();
            let url = this.constant.formConfiguration();
            let datos2=datosaux;

            const myJSON = JSON.stringify(datos2);

            let datos='{"datos":'+myJSON+',"generales":{"tipo_servicio":"'+modelo+'","operacion":"'+op+'","operacion_tipo":"consulta"}}';
            fetch(url,{
            method:'POST', 
            headers:new Headers({
                    "Authorization": 'Bearer '+localStorage.getItem('token'), 
                    "Content-Type":'application/json'},
                    ),
            "body":datos})
            .then(response => {
            this.getField('confirmModalCustom').toggle(false);
            if(response.status!==200){
            return '';
            }
            const reader = response.body.getReader();
            return new ReadableStream({
            start(controller) {
            return pump();
            function pump() {
                    return reader.read().then(({ done, value }) => {
                    if (done) {
                        controller.close();
                        return;}
                    controller.enqueue(value);
                    return pump();});}}})})
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if(blob.size>0){
                    blob.text().then(res=>{
                        if(this.isJson(res)){
                            this.successEnviarCorreo(JSON.parse(res));
                        }else{
                            const pdf = new File([blob], this.nombre_archivo+'.pdf', {
                                type:'application/pdf'});
                            window.open(URL.createObjectURL(pdf));
                        } 
                    });
                }else{
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.alertGeneral.toggle(true,err,'error');
            });
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    generarExcelTabla3(datosaux)
    {
            let op='';
            let modelo='';
            if(this.boton==='trasladar'){
                op='consultatraslado'
                modelo='inve-consultatraslados';
            }else if(this.boton==='remisionar'){
                op='imprimiriremisionar'
                modelo='traz-trazcontados';
            }else if(this.boton==='factura'){
                op='imprimirfacturar'
                modelo='traz-trazcontados';
            }else{
                op='imprimiritemspiking_pag'
                modelo='traz-trazautorizadoscartera';
            }
            this.mostrarMensajeGenerando();
            let url = this.constant.formConfiguration();
            let datos2=datosaux;

            const myJSON = JSON.stringify(datos2);
            let datos='{"datos":'+myJSON+',"generales":{"tipo_servicio":"'+modelo+'","operacion":"'+op+'","operacion_tipo":"consulta"}}';
            fetch(url,{
            method:'POST', 
            headers:new Headers({
                    "Authorization": 'Bearer '+localStorage.getItem('token'), 
                    "Content-Type":'application/json'}),
            "body":datos})
            .then(response => {
            this.getField('confirmModalCustom').toggle(false);
            if(response.status!==200){
                return '';
            }
            const reader = response.body.getReader();
            return new ReadableStream({
            start(controller) {
            return pump();
            function pump() {
                    return reader.read().then(({ done, value }) => {
                    if (done) {
                        controller.close();
                        return;}
                    controller.enqueue(value);
                    return pump();});}}})})
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if(blob.size>0){
                    blob.text().then(res=>{
                        if(this.isJson(res)){
                            this.successEnviarCorreo(JSON.parse(res));
                        }else{
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.style.display = 'none';
                            a.href = url;
                            // the filename you want
                            a.download = this.nombre_archivo+'.xlsx';
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                            alert('Se descargo el archivo!');
                        } 
                    });
                }else{
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.alertGeneral.toggle(true,err,'error');
            });
    }

    enviarCorreoTerceros(datosaux){
        this.mostrarMensajeGenerando();
        let op='';
        let modelo='';
        if(this.boton==='trasladar'){
            op='consultatraslado'
            modelo='inve-consultatraslados';
        }else if(this.boton==='remisionar'){
            op='imprimiriremisionar'
            modelo='traz-trazcontados';
        }else if(this.boton==='factura'){
            op='imprimirfacturar'
            modelo='traz-trazcontados';
        }else if(this.boton==='editarpedido'){
            op='imprimirpedido'
            modelo='traz-trazpendientescartera';
        }else{
            op='imprimiritemspiking_pag'
            modelo='traz-trazautorizadoscartera';
        }
        let datos={ 
            datos : datosaux
        };

        this.generalFormatPmv = { tipo_servicio: modelo, operacion: op, operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successEnviarCorreo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
    }

    successEnviarCorreo(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            this.mostrarMensajeEmailEnviado();
        }else if(data.estado_p ===404){
            this.mostrarMensajeNoHayDatos();
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    mostrarMensajeEmailEnviado(){
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    generarModalLista(datosaux){
        this.mostrarMensajeGenerando();
        let op='';
        let modelo='';
        if(this.boton==='trasladar'){
            op='consultatraslado'
            modelo='inve-consultatraslados';
        }else if(this.boton==='remisionar'){
            op='imprimiriremisionar'
            modelo='traz-trazcontados';
        }else if(this.boton==='factura'){
            op='imprimirfacturar'
            modelo='traz-trazcontados';
        }else{
            op='imprimiritemspiking'
            modelo='traz-trazautorizadoscartera';
        }
        let datos={ 
            datos : datosaux
        };
        if(this.boton==='trasladar'){
            this.generalFormatPmv = { tipo_servicio: modelo, operacion: op, operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.sucessTraerDatosTraslado,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }else if(this.boton==='remisionar'){
            this.generalFormatPmv = { tipo_servicio: modelo, operacion: op, operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.sucessTraerDatosRemision,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }else if(this.boton==='factura'){
            this.generalFormatPmv = { tipo_servicio: modelo, operacion: op, operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.sucessTraerDatosFactura,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }else{//picking
            this.getField("rejilla_items_result").setTipoServicioOperacion(modelo+'-'+op);
            this.getField("rejilla_items_result").sendRequest(this.sucessTraerDatos, datos); 
        }


    }

    sucessTraerDatosRemision(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){ 
            let datosFicha = [];
            this.lista=data.data.parametros;

            this.getField('modal_rejilla_remision').setLabel("REMISÓN No "+this.consecutivo)
            this.getField('modal_rejilla_remision').handleClickOpen();

            let data2 = 
            {
                "empresa": this.lista.empresa_xml,
                "nit_empresa": this.lista.nit_xml,
                "direccion_empresa":this.lista.direccion_xml,
                "telefono": this.lista.telefono_xml,
                "ciudad": this.lista.ciudad_xml,
                "remision_pendiente_por_facturar": this.lista.remision_pendiente_por_facturar,
                "fecha_remision": this.lista.fecha_remision,
                "vencimiento": this.lista.vencimiento,
                "orden_de_compra": this.lista.orden_de_compra,
                "vendido_a": this.lista.proveedor,
                "pedido_no": this.lista.pedido_no,
                "direccion": this.lista.direccion,
                "nit": this.lista.nit,
                "sede": this.lista.sede,
                "telefonos": this.lista.telefonos,
                "tasa_de_cambio":this.lista.tasa_de_cambio,
                "ciudad_de_entrega": this.lista.ciudad_de_entrega,
                "direccion_de_entrega": this.lista.direccion_de_entrega,
                //"observaciones": this.lista.observaciones,
            };



            datosFicha.push(data2);
            this.getField('lista_datos_remision').setItemsFichas(datosFicha);
            
            let configCell = new Map();
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('tarifa_iva', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.tarifa_iva) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('vr_unitario', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.vr_unitario) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('vr_total', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.vr_total) }, cellStyle: {textAlign:"right"},width: 110});

            this.gridOptionsRemision['rowData'] = [];
            this.gridOptionsRemision['rowData'] = data.data.items;

            this.getField('observaciones_remision').setValue(this.lista.observaciones);
            this.getField('subtotal_remision').setValue(this.lista.subtotal);
            this.getField('descuento_remision').setValue(this.lista.descuentos);
            this.getField('fletes_remision').setValue(this.lista.fletes);
            this.getField('iva_remision').setValue(this.lista.iva);
            this.getField('valor_total_remision').setValue(this.lista.valor_total);

            this.getField('rejilla_items_remision').initData(this.gridOptionsRemision,configCell);
        }else if(data.estado_p === 404){
            this.mostrarMensajeNoHayDatos();
        }
        else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        } 
    }

    sucessTraerDatosFactura(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){ 
            let datosFicha = [];
            this.lista=data.data.parametros;
            this.getField('modal_rejilla_factura').setLabel("Factura No "+this.consecutivo)
            this.getField('modal_rejilla_factura').handleClickOpen();

            let data2 = 
            {
                "razon_social": this.lista.razon_social,
                "tipo_contribuyentes": this.lista.tipo_contribuyentes,
                "razon_social_nit":this.lista.razon_social_nit,
                "nproveedor": this.lista.nproveedor,
                "factura_de_venta_no": this.lista.factura_no,
                "nit": this.lista.nit,
                "sede": this.lista.sede,
                "telefono": this.lista.telefono,
                "ciudad": this.lista.ciudad,
                "pais": this.lista.pais,
                "fecha_factura": this.lista.fecha_factura,
                "fecha_vencimiento": this.lista.fecha_vencimiento,
                "pedido": this.lista.pedido,
                "orden_de_compra": this.lista.orden_de_compra,
                "condiciones": this.lista.condiciones,
                "guia": this.lista.guia,
                "direccion":this.lista.direccion,
                "vendedor": this.lista.vendedor,
                "remisiones": this.lista.remisiones,
                "direccion_de_entrega": this.lista.direccion_de_entrega,
                "datos_de_despacho": this.lista.datos_de_despacho,
                "resolucion": this.lista.resolucion,
                "moneda": this.lista.moneda,
                "tasa_de_cambio": this.lista.tasa_de_cambio,
            };



            datosFicha.push(data2);
            this.getField('lista_datos_factura').setItemsFichas(datosFicha);
            
            let configCell = new Map();
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('iva', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.iva) }, cellStyle: {textAlign:"right"},width: 110, headerName: 'Iva%'});

            
            configCell.set('vr_unitario', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.vr_unitario) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('vr_total', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.vr_total) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('vr_descuento', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.vr_descuento) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('no', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.no) }, cellStyle: {textAlign:"right"},width: 110});


  
            this.gridOptionsRemision['rowData'] = [];
            this.gridOptionsRemision['rowData'] = data.data.items;
            this.getField('cufe').setValue(this.lista.scufe);
            this.getField('observaciones_factura').setValue(this.lista.observaciones);
            this.getField('subtotal_factura').setValue(this.lista.subtotal);
            this.getField('fletes_factura').setValue(this.lista.fletes);
            this.getField('seguro_factura').setValue(this.lista.seguro);
            this.getField('valor_neto_factura').setValue(this.lista.valor_neto);
            this.getField('iva_factura').setValue(this.lista.iva);
            this.getField('valor_total_factura2').setValue(this.lista.total);

            this.getField('rejilla_items_factura').initData(this.gridOptionsRemision,configCell);

        }else if(data.estado_p === 404){
            this.mostrarMensajeNoHayDatos();
        }
        else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        } 
    }

    sucessTraerDatosTraslado(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){ 
            let datosFicha = [];
            this.lista=data.data.datos_lista;
            let data2 = 
            {
                "empresa": this.lista.empresa,
                "razon_social": this.lista.razon_social,
                "nit":this.lista.nit,
                "direccion":this.lista.direccion,
                "telefono":this.lista.telefono,
                "sucursal": this.sucursal,
                "bodega_origen": this.lista.bodega_origen,
                "bodega_destino": this.lista.bodega_destino,
                "traslado_numero": this.lista.referencia,
                "fecha": this.lista.fecha,
                "detalle": this.lista.detalle
            };
            datosFicha.push(data2);
            this.getField('lista_datos_general2').setItemsFichas(datosFicha);
            
            let configCell = new Map();

            this.gridOptionsConsultarModal['rowData'] = [];
            this.gridOptionsConsultarModal['rowData'] = data.data.datos_items;
            this.getField('total_valor').setVisible(true);
            this.getField('total_valor').setValue(this.currencyFormatterGeneral(this.lista.valor_total));
            this.getField('peso_total').setValue(this.currencyFormatterGeneral(this.lista.peso_total));

            configCell.set('costo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.costo) }, cellStyle: {textAlign:"right"}});
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"}});
            configCell.set('iva', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.iva) }, cellStyle: {textAlign:"right"}});
            configCell.set('total_item', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.total_item) }, cellStyle: {textAlign:"right"}});
            
            this.getField('tabla_consultar').initData(this.gridOptionsConsultarModal,configCell);

            this.getField('modal_general').handleClickOpen();
        }else if(data.estado_p === 404){
            this.mostrarMensajeNoHayDatos();
        }
        else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        } 
    }

    sucessTraerDatos(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){ 
              let datosFicha = [];
              this.lista=data.data.lista;
              let data2 = 
                  {
                      "picking_no": this.lista.picking_no,
                      "de_pedido_no": this.lista.de_pedido_no,
                      "fecha_pedido":this.lista.fecha_pedido,
                      "sucursal_pedido": this.lista.sucursal_pedido,
                      "bodega": this.lista.bodega,
                      "cliente": this.lista.cliente,
                      "direccion": this.lista.direccion,
                      "telefono": this.lista.telefono,
                      "ciudad": this.lista.ciudad,
                      "vendedor": this.lista.vendedor,
                      "fecha_entrega": this.lista.fecha_entrega,
                      "hora_pedido": this.lista.hora_pedido,


                      "fecha_sistema": this.lista.fecha_sistema,
                      "encargado": this.lista.encargado,
                      "numero_pedido": this.lista.numero_pedido,
                      "detalle": this.lista.observaciones
                  };
            datosFicha.push(data2);
            this.getField('lista_datos').setItemsFichas(datosFicha);
    
            let configCell = new Map();
            this.gridOptionsResultPicking['rowData'] = [];
            this.gridOptionsResultPicking['rowData'] = data.data.items;

            //this.getField('total_cantidad').setValue(this.currencyFormatterGeneral(data.data.total_cantidad));
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('registro_no', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.registro_no) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('nombre', { maxWidth: 1000 });
            
            this.getField('rejilla_items_result').initData(this.gridOptionsResultPicking,configCell);
            this.getField('modal_result').setLabel('Picking No. '+this.lista.picking_no);
            this.getField('modal_result').handleClickOpen();
            this.getField('total_cantidad').setValue(this.lista.total_cantidad);
        }else if(data.estado_p === 404){
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            this.mostrarMensajeNoHayDatos();
        }
        else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        } 
    }

    mostrarPicking(data){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            consecutivo_picking:data.data.consecutivo_picking,
            tabla:data.data.tabla,
            sucursal_ingreso:this.sucursal_ingreso,
            bodegas:this.bodega //pobeda picking
        }};

        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadoscartera', operacion: 'veritemspiking', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successMostrarPicking,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }


    successMostrarPicking(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){ 

            let configCell = new Map();
            this.gridOptionsResultPicking['rowData'] = [];
            this.gridOptionsResultPicking['rowData'] = data.data.items;

            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('indice', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.indice) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('embalaje_pro', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.embalaje_pro) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('contenido', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.contenido) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('sede', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.sede) }, cellStyle: {textAlign:"right"},width: 110});
            //configCell.set('conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('seleccionar', {headerCheckboxSelection: false, headerCheckboxSelectionFilteredOnly: false,checkboxSelection: true, sortable: false, filter: false});
    
            this.gridOptionsResultPicking["suppressRowClickSelection"] = true;
            this.gridOptionsResultPicking["rowSelection"] = "multiple";
            this.gridOptionsResultPicking["enableRangeSelection"] = true;
            this.gridOptionsResultPicking["enableCellChangeFlash"] = true;

            this.getField('rejilla_items_picking').initData(this.gridOptionsResultPicking,configCell);
            this.getField('modal_ver_picking').setLabel(this.titulo);
            this.getField('modal_ver_picking').handleClickOpen();
        }else if(data.estado_p === 404){
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            this.mostrarMensajeNoHayDatos();
        }
        else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        } 
    }

    modificarOperario(){
        if(this.getField('operario').valid() && this.getField('sede_operario').valid() && this.getField('nombre_operario').valid()){
            this.mostrarMensajeGuardando();
            let datos = { datos: {
                operario:this.getField('operario').getValue(),
                items: this.arrayDataCheckBox,
            }};
            this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'modificaroperario', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successModificarOperario,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }
    }

    successModificarOperario(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {   
            this.getField('confirmModalCustom').toggle(false);
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Operario asignado con éxito.');
            this.getField('confirmModalCustom').setClickDialog(() => { 
                this.getField("modal_operario").handleClose();
                this.mostrarPicking();
            });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false); });
            this.getField("confirmModalCustom").setVisibleConfirm(true); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
            this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
            this.getField('confirmModalCustom').toggle(true);
        }else {
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos', 'error');
            }
            else {
              let respuesta=Object.values(data.data.errores);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    onSelectionChangedVerPicking(){
        //this.arrayDataCheckBox = this.gridOptionsComponentesPredefinidos.api.getSelectedRows();
        this.gridOptionsResultPicking.api.forEachNode(node => {
            if(node.selected)
                this.arrayDataCheckBox.push(this.gridOptionsResultPicking['rowData'][node.rowIndex]);
        });
    }

    llevarARePiking(){
        if(this.tipo_picking==='P'){
            this.pide_encargado=true;
            this.getField('confirmModalCustom').toggle(false);
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje','Desea conservar el conteo de este pedido?');
            this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); 
                this.conservar_conteo=true;
                //pedir encargado
                this.getField('modal_encargado').setLabel('Pedido No. ' + this.selectedRowsArray[0].numero + ' Fecha: ' + this.selectedRowsArray[0].fecha);
                this.getField('modal_encargado').handleClickOpen();
            });
            this.getField("confirmModalCustom").setVisibleCancel(false);
            this.getField("confirmModalCustom").setButtonCancel('NO');
            this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
                this.getField('confirmModalCustom').toggle(false); 
                this.conservar_conteo=false;
                //pedir encargado
                this.getField('modal_encargado').setLabel('Pedido No. ' + this.selectedRowsArray[0].numero + ' Fecha: ' + this.selectedRowsArray[0].fecha);
                this.getField('modal_encargado').handleClickOpen();

            });

            
            this.getField("confirmModalCustom").setVisibleConfirm(false); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
            this.getField("confirmModalCustom").setButtonConfirm("Si"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
            this.getField('confirmModalCustom').toggle(true);

        }else if(this.tipo_picking==='V'){ //varios
            // pide encargado mas no pregunta por conservar el conteo
            this.pide_encargado=true;
            this.conservar_conteo=false;
            this.getField('modal_encargado').setLabel('Seleccione el encargado para los pedido No '+this.selectedRowsArray[0].numero);
            this.getField('modal_encargado').handleClickOpen();
        }else{
            this.mostrarMensajeAdicional('Opción no configurada');
        }

    }

    traerDatosBodegas(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            items:this.row_asentados,
            xtipo:'transito',
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'datosbodegas', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerDatosBodegas,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }


    successTraerDatosBodegas(data){
        this.getField('confirmModalCustom').toggle(false);
        let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
        if (data.estado_p === 200)
        {

            data.data.bodegas.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.codigo_bodega;
                dataOp['text'] = item.codigo_bodega+'-'+item.nombre;
                dataOp['campos_cambian'] = {};
                opciones.push(dataOp);
            });
            
        }else 
        {
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            } else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
        this.getField('select_bodegas').setOptions(opciones);
        this.getField('select_bodegas').setError(false,'');
    }

    traerDatosFletes(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            select_bodegas:this.getField('select_bodegas').getValue(),
            items:this.row_asentados,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'datosflete', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerDatosFletes,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }


    successTraerDatosFletes(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200)
        {
            if(data.data.flete_editable){
                this.getField('flete').setDisabled(false);
            }else{
                this.getField('flete').setDisabled(true);
            }
            this.getField('flete').setValue('0');
        }else 
        {
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            } else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    trasladar(){
        if(this.getField('select_bodegas').valid() && this.getField('flete').valid() && this.getField('guia').valid()
        && this.getField('fecha_guia').valid() && this.getField('transportadora').valid() && this.getField('nombre_transportadora').valid())
        {
            this.mostrarMensajeGuardando();
            let datos={ datos: {
                xestado:this.xestado,
                sucursal_ingreso:this.sucursal_ingreso,
                select_bodegas:this.getField('select_bodegas').getValue(),
                guia:this.getField('guia').getValue(),
                flete:this.getField('flete').getValue(),
                fecha_guia:this.getField('fecha_guia').getValue(),
                transportadora:this.getField('transportadora').getValue(),
                items:this.row_asentados,
            }};
            if(this.prop_para_despachar==='S'){
                datos.datos.para_despachar=this.para_despachar;
                datos.datos.fecha_despacho=this.fecha_despacho;
            }
            
            this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'trasladar', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successTrasladar,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage:false,
            });
        }
    }

    successTrasladar(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {
            this.getField('confirmModalCustom').toggle(false);
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
            this.getField('confirmModalCustom').setClickDialog(() => {
                this.getField('confirmModalCustom').toggle(false);
                this.recargarInfo();

                //imprimir traslado
                this.nombre_archivo='traslado';
                this.boton='trasladar';

                this.fecha_trasladar=data.data.fecha;
                this.consecutivo_trasladar=data.data.consecutivo;
                this.codigo_sucursal_trasladar=data.data.lasucursal;
                this.getField('modal_bodegas').handleClose();
                this.abrirImprimir();
            });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm('Ok'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            //this.getField("confirmModalCustom").setButtonCancel('NO');
            this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
            this.getField('confirmModalCustom').toggle(true);

        }else {
            this.getField('confirmModalCustom').toggle(false);
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos', 'error');
            }
            else {
              let respuesta=Object.values(data.data.errores);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { 
            
        });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    //remisionar----------->

    remisionar(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            pedir_flete:this.pedir_flete,
            sucursal_ingreso:this.sucursal_ingreso,
            items:this.row_asentados,
            xestado:this.xestado
        }};

        if(this.tasa_de_cambio!==''){
            datos.datos.tasa_de_cambio=this.tasa_de_cambio;
            datos.datos.select_monedas=this.moneda;
        }
        if(this.nueva_orden!==''){
            datos.datos.nueva_orden=this.nueva_orden;
        }
        if(this.enviar_anexos)
            datos.datos.input_anexo='0';
        if(this.pedir_flete==='S')
            datos.datos.xfletes=this.xfletes;

        if(this.prop_para_despachar==='S'){
            datos.datos.para_despachar=this.para_despachar;
            datos.datos.fecha_despacho=this.fecha_despacho;
        }
        
        this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'remisionar', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successRemisionar,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false,
        });
    }

    successRemisionar(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {
            this.getField('confirmModalCustom').toggle(false);
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
            this.getField('confirmModalCustom').setClickDialog(() => {
                this.getField('confirmModalCustom').toggle(false);

                if(data.data.pedir_tasa!==undefined && data.data.pedir_tasa===true){
                    this.getField('modal_tasa_de_cambio').handleClickOpen();
                    this.getField('tasa_anterior').setVisible(false);
                    this.getField('tasa_de_cambio').setDisabled(true);
                    this.factor=data.data.factor;
                    this.tipo_moneda=data.data.tipo_moneda;
                    this.moneda_estandar_aux=this.moneda_estandar;
                    if (this.moneda_estandar_aux==="COP") {
                        //cliente = new TCRMTestClient();
                        this.trm='COP';
                    } else {
                        //indicador = new IndicadoresCostaRica();
                        // txTasaCambio.setText(indicador.obtenerTRM().replace(",", "."));
                        this.trmm='CRI';//costa rica
                    }
            
                    if (this.factor === 1) {
                        this.getField('tasa_de_cambio').setValue('1');
                        this.getField('select_monedas').setValue(this.moneda_estandar_aux);
                    }
                    if (this.factor > 1) {
                        this.getField('tasa_de_cambio').setValue(this.factor+'');
                        this.getField('select_monedas').setValue('');
                    }
            
                    if (this.tipo_moneda != null && this.tipo_moneda!=='') {
                        this.moneda_estandar_aux = this.tipo_moneda;
                        this.getField('select_monedas').setValue(this.moneda_estandar_aux);
                        if(this.moneda_estandar_aux==='USD')
                            this.getField('tasa_de_cambio').setDisabled(false);
                    }
                    this.getField('select_monedas').setDisabled(false);

                }else if(data.data.pedir_orden!==undefined && data.data.pedir_orden===true){
                    this.getField('modal_orden_de_compra').handleClickOpen();
                    this.getField('nueva_orden').setValue(data.data.ordenCompra);
                }else if(data.data.saldo_insuficiente!==undefined){
                    if(data.data.saldo_insuficiente.length>0){
                        this.getField('modal_rejilla').setLabel("Listado de ítems saldo insuficiente.")
                        this.getField('modal_rejilla').handleClickOpen();

                        this.gridOptionsItems['rowData'] = [];

                        let configCell = new Map();
                        
                 
                            configCell.set('flag', { cellRenderer:function(props){return props.data.flag},
                            cellStyle: function (props) {
                                if(props.data.flag.toString()==='*')
                                    return {backgroundColor: "rgb(255,0,0)" }
                                else{
                                    return {}
                                }
                        }});

                        configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"}});
                        configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"}});

                        this.gridOptionsItems['rowData'] = data.data.saldo_insuficiente;

                        
                        this.getField('rejilla_items').initData(this.gridOptionsItems,configCell);
                    }
                    this.preguntarDevolver(data.data.datos_adicionales,'**** Pedido NO Remisionado *****.');
                }else if(data.data.items_anexo!==undefined){
                    this.getField('modal_rejilla').setLabel("Los siguientes artículos no se encuentran en la lista de catalogos.");
                    this.getField('modal_rejilla').handleClickOpen();

                    this.gridOptionsItems['rowData'] = [];
                    let configCell = new Map();
                    this.gridOptionsItems['rowData'] = data.data.items_anexo;
                    this.getField('rejilla_items').initData(this.gridOptionsItems,configCell);
                    this.preguntarAnexos();
                }else{
                    if(data.data.imprimir!==undefined && data.data.imprimir===true){
                        this.nombre_archivo='remisiones';
                        this.boton='remisionar';
                        this.abrirImprimir();

                        this.articulo_anexo=data.data.articulo_anexo;
                        this.sucursal=data.data.sucursal_pedido;
                        this.fecha=data.data.fecha;
                        this.consecutivo=data.data.consecutivo;
                        this.codigo_facturacion=data.data.xelcodigofactura;

                        this.recargarInfo();
                    }
                }
            });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm('OK'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField("confirmModalCustom").setButtonCancel('NO');
            this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
            this.getField('confirmModalCustom').toggle(true);

        }else {
            this.getField('confirmModalCustom').toggle(false);
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos', 'error');
            }
            else {
              let respuesta=Object.values(data.data.errores);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    preguntarAnexos(){
        let mensaje='¿Está seguro de facturar?';
        if(this.boton_seleccionado==='remisionar')
            mensaje='¿Está seguro de remisionar?';
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => {
            this.enviar_anexos=true;
            if(this.boton_seleccionado==='facturar'){
                this.facturar();
            }else if(this.boton_seleccionado==='remisionar'){  
                this.remisionar();
            }else{
                this.trasladar();
            }
        });
        this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm('SI'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField("confirmModalCustom").setButtonCancel('NO');
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
        this.getField('confirmModalCustom').toggle(true);
    }

    preguntarDevolver(datos_adicionales,mensaje){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', '¿Desea regresar el pedido al estado autorizado?');
        this.getField('confirmModalCustom').setClickDialog(() => {
            this.devolverPedido(datos_adicionales);
        });
        this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm('SI'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField("confirmModalCustom").setButtonCancel('NO');
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
            this.getField('confirmModalCustom').toggle(false);
            this.getField('confirmModalCustom').toggle(false);
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
            this.getField('confirmModalCustom').setClickDialog(() => {
                this.getField('confirmModalCustom').toggle(false);
            });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm('ACEPTAR'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField("confirmModalCustom").setButtonCancel('NO');
            this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
                this.getField('confirmModalCustom').toggle(false);
            });
            this.getField('confirmModalCustom').toggle(true);
        });
        this.getField('confirmModalCustom').toggle(true);
    }

    devolverPedido(datos_adicionales){
          this.mostrarMensajeGuardando();
            let datos={ datos: {
              npedido:datos_adicionales.npedido,
              nit_aux:datos_adicionales.xcliente,
              sede_aux:datos_adicionales.xsede+'',
              sucursal:datos_adicionales.sucursal_pedido,
              xbodega:datos_adicionales.xbodega,
            }};
            this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'devolverpedido', operacion_tipo: 'modificar' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'PUT',
                    body: datos,
                    success: this.successDevolverPedido,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
            });
      }
  
    successDevolverPedido(data) {
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            this.getField('confirmModalCustom').toggle(false);
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Pedido devuelto con éxito.');
            this.getField('confirmModalCustom').setClickDialog(() => {
                this.recargarInfo();
            });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm('OK'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
            this.getField('confirmModalCustom').toggle(true);
        }else {
            if(data.estado_p===404) {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    ///// FALTA MIGRAR LLEVAR A PIKING QUEDO PENDIENTE TERMINAR TODAS LAS OPCIONES DEL SELECT TIPO PICKING EN AUTORIZADOS CARTERA, TODO PICKING Y CONTADOS
    /// Y VALIDAR TODO LO DE WMS DE SUMATEC

    /*traerTrmCop(){
        this.mostrarMensajeGenerando();
        const raw = "<soapenv:Envelope xmlns:soapenv=\"http://schemas.xmlsoap.org/soap/envelope/\"\r\nxmlns:act=\"http://action.trm.services.generic.action.superfinanciera.nexura.sc.com.co/\">\r\n <soapenv:Header/>\r\n <soapenv:Body>\r\n <act:queryTCRM>\r\n\r\n </act:queryTCRM>\r\n </soapenv:Body>\r\n</soapenv:Envelope>";

        var xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://www.superfinanciera.gov.co/SuperfinancieraWebServiceTRM/TCRMServicesWebService/TCRMServicesWebService?wsdl', true);
        xhr.setRequestHeader("Content-type", "text/xml");
        xhr.timeout = 2000; // time in milliseconds
        let valor='0';
        
        xhr.onload = (event) => {
            try {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(xhr.response, "text/xml");
                //let list=xmlDoc.childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes;

                //doc--> body-->ns2-->return-->element 4(value) y valor
                valor=xmlDoc.childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[4].textContent;
                this.getField('tasa_de_cambio').setValue(Number(valor));
            } catch (error) {
                this.getField('tasa_de_cambio').setValue('0');
            }
            this.getField('confirmModalCustom').toggle(false);
        };

        xhr.addEventListener("error", (event) => {
            this.getField('confirmModalCustom').toggle(false);
        })

        
        xhr.ontimeout = function (e) {
            this.getField('confirmModalCustom').toggle(false);
        };

        xhr.send(raw);
    }*/

    traerTrmCop(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'obtenertrm', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerTrm,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successTraerTrm(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200)
        {
            if(data.data.trm!==undefined)
                this.getField('tasa_de_cambio').setValue(Number(data.data.trm));
            else
                this.getField('tasa_de_cambio').setValue(0.0);
        }else 
        {
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            } else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }


    /*traerTrmCostaRica(){
        this.mostrarMensajeGenerando();

        let body={
            Indicador:this.indicador,
            Nombre:this.nombre,
            SubNiveles:this.subniveles,
            CorreoElectronico:this.correo_electronico,
            Token:this.token,
            FechaInicio:new Date(),
            FechaFinal:new Date(),
        }
        var xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://gee.bccr.fi.cr/Indicadores/Suscripciones/WS/wsindicadoreseconomicos.asmx/ObtenerIndicadoresEconomicosXML', true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.timeout = 2000; // time in milliseconds
        let valor='0';
        xhr.onload = (event) => {
            try {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(xhr.response, "text/xml");
                //let list=xmlDoc.childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes;

                //doc--> body-->ns2-->return-->element 4(value) y valor
                valor=xmlDoc.childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[4].textContent;
                this.getField('tasa_de_cambio').setValue(Number(valor));
            } catch (error) {
                this.getField('tasa_de_cambio').setValue('0');
            }
            this.getField('confirmModalCustom').toggle(false);
        }



        xhr.addEventListener("error", (event) => {
            this.getField('confirmModalCustom').toggle(false);
        });

        xhr.ontimeout = function (e) {
            // XMLHttpRequest timed out. Do something here.
         this.getField('confirmModalCustom').toggle(false);
        };

        xhr.send(body);
    }*/

    traerTrmCostaRica(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'obtenertrmcr', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerTrm,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }




    //facturar

    facturar(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            pedir_flete:this.pedir_flete_facturar,
            sucursal_ingreso:this.sucursal_ingreso,
            items:this.row_asentados,
            xestado:this.xestado,
            imprimir_descuento:this.imprimir_descuento,
        }};

        if(this.tasa_de_cambio!==''){
            datos.datos.tasa_de_cambio=this.tasa_de_cambio;
            datos.datos.select_monedas=this.moneda;
        }
        if(this.numero_de_recibo!==''){
            datos.datos.numero_de_recibo=this.numero_de_recibo;
        }
        if(this.numero_de_factura!==''){
            datos.datos.numero_de_factura=this.numero_de_factura;
        }
        if(this.observacion_factura!==''){
            datos.datos.observacion_factura=this.observacion_factura;
        }
        if(this.fecha_vencimiento_picking!==''){
            datos.datos.fecha_vencimiento_picking=this.fecha_vencimiento_picking;
        }

        if(this.enviar_anexos)
            datos.datos.input_anexo='0';
        if(this.pedir_flete_facturar==='S')
            datos.datos.xfletes=this.xfletes;

        if(this.prop_para_despachar==='S'){
            datos.datos.para_despachar=this.para_despachar;
            datos.datos.fecha_despacho=this.fecha_despacho;
        }

        
        this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'facturar', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successFacturar,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false,
        });
    }

    successFacturar(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {
            this.getField('confirmModalCustom').toggle(false);
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
            this.getField('confirmModalCustom').setClickDialog(() => {
                this.getField('confirmModalCustom').toggle(false);

                if(data.data.pedir_tasa!==undefined && data.data.pedir_tasa===true){
                    this.getField('modal_tasa_de_cambio').handleClickOpen();
                    this.getField('tasa_anterior').setVisible(false);
                    this.factor=data.data.factor;
                    this.tipo_moneda=data.data.tipo_moneda;
                    this.moneda_estandar_aux=this.moneda_estandar;
                    if (this.moneda_estandar_aux.toUpperCase()==="COP") {
                        //cliente = new TCRMTestClient();
                        this.trm='COP';
                    } else {
                        //indicador = new IndicadoresCostaRica();
                        // txTasaCambio.setText(indicador.obtenerTRM().replace(",", "."));
                        this.trmm='CRI';//costa rica
                    }
            
                    if (this.factor === 1) {
                        this.getField('tasa_de_cambio').setValue('1');
                        this.getField('select_monedas').setValue(this.moneda_estandar_aux);
                    }
                    if (this.factor > 1) {
                        this.getField('tasa_de_cambio').setValue(this.factor+'');
                        this.getField('select_monedas').setValue('');
                    }
            
                    if (this.tipo_moneda != null && this.tipo_moneda!=='') {
                        this.moneda_estandar_aux = this.tipo_moneda;
                        this.getField('select_monedas').setValue(this.moneda_estandar_aux);
                    }
                    this.getField('select_monedas').setDisabled(false);

                }else if(data.data.pedir_numero!==undefined && data.data.pedir_numero===true){
                    this.getField('modal_recibo').handleClickOpen();
                    this.getField('numero_de_recibo').setValue('000');
                }else if(data.data.pedir_factura!==undefined && data.data.pedir_factura===true){
                    this.getField('modal_factura').handleClickOpen();
                }else if(data.data.pedir_observaciones!==undefined && data.data.pedir_observaciones===true){
                    this.getField('modal_observaciones').handleClickOpen();
                    this.getField('observacion_factura').setValue(data.data.observaciones);
                }else if(data.data.pedir_fecha_vencimiento!==undefined && data.data.pedir_fecha_vencimiento===true){
                    this.getField('modal_fecha_vencimiento').handleClickOpen();
                    this.getField('fecha_vencimiento_picking').setValue(data.data.datos_adicionales.xvence.toString().replaceAll('/','-'))
                }else if(data.data.saldo_insuficiente!==undefined){
                    if(data.data.saldo_insuficiente.length>0){
                        this.getField('modal_rejilla').setLabel("Listado de ítems saldo insuficiente.")
                        this.getField('modal_rejilla').handleClickOpen();

                        this.gridOptionsItems['rowData'] = [];
                        let configCell = new Map();
                        
                 
                            configCell.set('flag', { cellRenderer:function(props){return props.data.flag},
                            cellStyle: function (props) {
                                if(props.data.flag.toString()==='*')
                                    return {backgroundColor: "rgb(255,0,0)" }
                                else{
                                    return {}
                                }
                            }});

                        //configCell.set('flag',{cellRenderer:function(props){return props.data.flag},cellStyle: {backgroundColor: "rgb(255,0,0)",borderRadius:"5px"}});

                        configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"}});
                        configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"}});

                        this.gridOptionsItems['rowData'] = data.data.saldo_insuficiente;
                        this.getField('rejilla_items').initData(this.gridOptionsItems,configCell);
                    }
                    this.preguntarDevolver(data.data.datos_adicionales,'**** Pedido NO Facturado *****.');
                }else if(data.data.items_anexo!==undefined){
                    this.getField('modal_rejilla').setLabel("Los siguientes artículos no se encuentran en la lista de catalogos");
                    this.getField('modal_rejilla').handleClickOpen();

                    this.gridOptionsItems['rowData'] = [];
                    let configCell = new Map();
                    this.gridOptionsItems['rowData'] = data.data.items_anexo;
                    this.getField('rejilla_items').initData(this.gridOptionsItems,configCell);
                    this.preguntarAnexos();
                }else{
                    if(data.data.imprimir!==undefined && data.data.imprimir===true){
                        this.nombre_archivo='factura';
                        this.boton='factura';
                        this.abrirImprimir();

                        this.articulo_anexo=data.data.articulo_anexo;
                        this.sucursal=data.data.sucursal_pedido;
                        this.fecha=data.data.fecha;
                        this.consecutivo=data.data.consecutivo;
                        this.codigo_facturacion=data.data.xelcodigofactura;
                        this.trm_final=data.data.trm;
                        this.npedido=data.data.pedido;
                        if(data.data.maneja_dolares!==undefined && data.data.maneja_dolares!=='N')
                            this.modal_exportacion=true;
                        else
                            this.modal_exportacion=false;
                        
                        if(data.data.maneja_puntos!==undefined && data.data.maneja_puntos==='S'){
                            this.traerInfoPuntos();

                        }else{
                            this.pedirPago();
                            if(this.modal_exportacion){
                                this.getField('modal_exportaciones').handleClickOpen();
                                this.getField('trm').setValue(this.trm_final);
                                //x1.setTrm(String.valueOf(laTasa));
                                //x1.setCodigoFacturacion(xelcodigofactura);
                                //x1.setFactura(xnumero);
                            }
                        }
                    }
                }
            });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm('OK'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField("confirmModalCustom").setButtonCancel('NO');
            this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
            this.getField('confirmModalCustom').toggle(true);

        }else {
            this.getField('confirmModalCustom').toggle(false);
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos', 'error');
            }
            else {
              let respuesta=Object.values(data.data.errores);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    preguntarImprimirDescuentos(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', '¿Confirma que desea mostrar descuento financiero?');
        this.getField('confirmModalCustom').setClickDialog(() => {
            this.getField('confirmModalCustom').toggle(false);
            this.imprimir_descuento='S';
            if(this.pedir_flete==='S'){
                this.getField('modal_fletes').handleClickOpen();
            }else{
                //pasa a preguntar por la fecha despacho
                if(this.prop_para_despachar==='S' && this.para_despachar_automatico==='N'){
                    this.fecha_despacho='';
                    this.para_despachar=false;
                    this.getField('ch_para_despachar').setValue("false");
                    this.getField('modal_para_despachar').handleClickOpen();
                }else{//automatico
                    this.fecha_despacho='';
                    this.para_despachar=false;
                    this.facturar();
                }
            }
        });
        this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm('SI'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField("confirmModalCustom").setButtonCancel('NO');
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ 
            this.imprimir_descuento='N';
            this.getField('confirmModalCustom').toggle(false);
            if(this.pedir_flete==='S'){
                this.getField('modal_fletes').handleClickOpen();
            }else{
                //pasa a preguntar por la fecha despacho
                if(this.prop_para_despachar==='S' && this.para_despachar_automatico==='N'){
                    this.fecha_despacho='';
                    this.para_despachar=false;
                    this.getField('ch_para_despachar').setValue("false");
                    this.getField('modal_para_despachar').handleClickOpen();
                }else{//automatico
                    this.fecha_despacho='';
                    this.para_despachar=false;
                    this.facturar();
                }
            }
        });
        this.getField('confirmModalCustom').toggle(true);
    }

    traerInfoPuntos(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            consecutivo:this.consecutivo,
            fecha:this.fecha,
            sucursal:this.sucursal,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'traerinfopuntos', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerInfoPuntos,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }


    successTraerInfoPuntos(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200)
        {
            if(data.data.mensaje_mostrar!==undefined && data.data.mensaje_mostrar!==''){
                //this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => { 
                    this.getField('confirmModalCustom').toggle(false); 
                    this.pedirPago(); //esto lo hago para que de tiempo de que el usuario lea el mensaje de puntos
                    if(this.modal_exportacion===true){
                        this.getField('modal_exportaciones').handleClickOpen();
                        this.getField('trm').setValue(this.trm_final);
                    }
                });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleConfirm(false); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
                this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.getField('modal_puntos').handleClickOpen();
                this.getField('nit_puntos').setValue(data.data.nit);
                this.getField('sede_puntos').setValue(data.data.sede);
                this.getField('nombre_puntos').setValue(data.data.nombre);
                this.getField('factura_puntos').setValue(data.data.num_factura);
                this.getField('valor_sin_iva_factura').setValue(data.data.valor_sin_iva);

                //aprovecho para traer la info del pago
                this.pedirPago();
                if(this.modal_exportacion===true){
                    this.getField('modal_exportaciones').handleClickOpen();
                    this.getField('trm').setValue(this.trm_final);
                }
            }
        }else 
        {
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            } else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
            this.pedirPago();
            if(this.modal_exportacion===true){
                this.getField('modal_exportaciones').handleClickOpen();
                this.getField('trm').setValue(this.trm_final);
            }
        }
    }

    guardarPuntos(nit,sede,nombre){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            consecutivo:this.consecutivo,
            fecha:this.fecha,
            sucursal:this.sucursal,
            nit_puntos:nit,
            sede_puntos:sede,
            nombre_puntos:nombre,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'guardarpuntos', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successGuardarPuntos,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successGuardarPuntos(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {   
            if(data.data.mensaje_mostrar!==undefined && data.data.mensaje_mostrar!==''){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            this.getField("modal_puntos").handleClose();
        }else {
            if(data.data.mensaje_mostrar!==undefined && data.data.mensaje_mostrar!==''){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos', 'error');
            }
            else {
              let respuesta=Object.values(data.data.errores);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    //modal pedir pago
    pedirPago(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            consecutivo:this.consecutivo,
            fecha:this.fecha,
            sucursal:this.sucursal,
            codigo_facturacion:this.codigo_facturacion,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'traerinfopago', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successpedirPago,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }


    successpedirPago(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200)
        {
            if(data.data.mensaje_mostrar!==undefined && data.data.mensaje_mostrar!==''){
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.recargarInfo();
                });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm('OK'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
                this.getField('confirmModalCustom').toggle(true);

            }else{
                if(data.data.pide_pago!==undefined && data.data.pide_pago===true){
                    this.getField('valor_total_factura').setValue(data.data.total_factura);
                    this.getField('valor_iva_factura').setValue(data.data.valor_iva);
                    this.pedido=data.data.pedido;
                    this.getField('modal_pedir_pago').handleClickOpen();
                }
                this.recargarInfo();
            }
        }else 
        {
            if (data.estado_p === 404) {
                this.mostrarMensajeNoHayDatos();
            } else {
                let respuesta = Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
            this.recargarInfo();
        }
    }

    guardarPago(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            npedido:this.pedido,
            sucursal_ingreso:this.sucursal_ingreso,
            consecutivo:this.consecutivo,
            fecha:this.fecha,
            sucursal:this.sucursal,
            valor_efectivo:this.getField('valor_efectivo').getValue(),
            valor_cheques:this.getField('valor_cheques').getValue(),
            valor_tarjeta_debito:this.getField('valor_tarjeta_debito').getValue(),
            valor_tarjeta_credito:this.getField('valor_tarjeta_credito').getValue(),
            valor_otros:this.getField('valor_otros').getValue(),
            vendedor_pago:this.getField('vendedor_pago').getValue(),
            valor_cambio1:this.getField('valor_cambio').getValue(),
            codigo_facturacion:this.codigo_facturacion,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'guardarpago', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successGuardarPago,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successGuardarPago(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {   
            if(data.data.mensaje_mostrar!==undefined && data.data.mensaje_mostrar!==''){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            this.getField("modal_pedir_pago").handleClose();
        }else {
            if(data.data.mensaje_mostrar!==undefined && data.data.mensaje_mostrar!==''){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }else{
                if(data.estado_p===404) {
                    this.alertGeneral.toggle(true, 'No hay datos', 'error');
                }
                else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
                }
            }
        }
    }

    calcularCambio() {

        this.getField('valor_efectivo').setError(false,'');
        this.getField('valor_cheques').setError(false,'');
        this.getField('valor_tarjeta_debito').setError(false,'');
        this.getField('valor_tarjeta_credito').setError(false,'');
        this.getField('valor_otros').setError(false,'');
        
        let valor_factura =this.getField('valor_total_factura').getValue();

        let efectivo  =this.getField('valor_efectivo').getValue();
        let cheques  =this.getField('valor_cheques').getValue();
        let tarjetad  =this.getField('valor_tarjeta_debito').getValue();
        let tarjetac  =this.getField('valor_tarjeta_credito').getValue();
        let otros  =this.getField('valor_otros').getValue();
        

        let total_pago = efectivo + cheques + tarjetad + tarjetac + otros;
        let cambio = total_pago - valor_factura;
        this.getField('valor_cambio').setValue(cambio);

    }

    guardarExportacion(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            codigo_facturacion:this.codigo_facturacion,
            sucursal_ingreso:this.sucursal_ingreso,
            consecutivo:this.consecutivo,
            trm:this.getField('trm').getValue(),
            termino:this.getField('termino').getValue(),
            puerto:this.getField('puerto').getValue(),
            terminop:this.getField('terminop').getValue(),
            bultos:this.getField('bultos').getValue(),
            flete_exp:this.getField('flete_exp').getValue(),
            seguro:this.getField('seguro').getValue(),
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazcontados', operacion: 'guardarexportacion', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successGuardarExportacion,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successGuardarExportacion(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {   
            if(data.data.mensaje_mostrar!==undefined && data.data.mensaje_mostrar!==''){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            this.getField('modal_exportaciones').handleClose();
        }else {
            if(data.data.mensaje_mostrar!==undefined && data.data.mensaje_mostrar!==''){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }else{
                if(data.estado_p===404) {
                    this.alertGeneral.toggle(true, 'No hay datos', 'error');
                }
                else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
                }
            }
        }
        this.getField("modal_pedir_pago").handleClose();
    }

    deshabilitarCorreo(){
        this.getField('email').setDisabled(true);
        this.getField('email').setValue('');
        this.getField('email').setError(false,'');
        this.getField('radio_correo').setDisabled(true);
        this.getField('radio_correo').setValue("N");
    }
    
    habilitarCorreo(){
        this.getField('email').setDisabled(false);
        this.getField('radio_correo').setDisabled(false);
        this.getField('radio_correo').setValue("N");
    }

    recargarInfo(){
        if(this.accion_panel==='ACARTERA')
            this.AutorizadosCartera();//se refrescan los datos
        else if( this.accion_panel==='AINVENTARIO')
            this.traerAutorizadosInventario();//se refrescan los datos
        else if(this.xestado==='03')
            this.traerAsentados();//se refrescan los datos
    }

    //apartado trabilidad reserva
    trazabiliaReserva(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            sucursal : this.getField("sucursal").getValue(),
            codigo_usuario:this.codigo_usuario,
            npedido:this.pedido_consulta
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazreserva', operacion: 'trazabilidadreserva', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.success_TrazabilidadReserva,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    success_TrazabilidadReserva(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField("modal_pedido_consulta").handleClose();
            this.getField('titulo').setValue('Pedido No. '+this.pedido_consulta);

            this.getField("ver_detalle").setVisible(true);

            let configCell = new Map();
            this.gridOptionsComponentesTrazReserva['rowData'] = data.data;
            this.gridOptionsComponentesTrazReserva['onSelectionChanged'] = ()=>{
                this.row_trazabilidadReserva = [];
                this.row_trazabilidadReserva = this.gridOptionsComponentesTrazReserva.api.getSelectedRows();
            };
            this.getField('rejilla9').initData(this.gridOptionsComponentesTrazReserva, configCell);
            this.habilitarBotonesAdicionales('');
        }else {
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    ver_detalle(row){

        let mensaje=' Fecha de reserva: ' + row.fecha_reserva + '  ' + row.hora_reserva + '. Detalle: ' +row.detalle;
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Detalle', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { 
            this.getField('confirmModalCustom').toggle(false); 
        });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleConfirm(false); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField("confirmModalCustom").setButtonConfirm("ACEPTAR"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    validarfechasNovedades() {
        this.getField('aceptar_novedades').setDisabled(false);
        let fecha_actual = new Date().toISOString().split('T')[0];
        let fecha_desde = new Date(this.getField("novedades_desde").getValue()).toISOString().split('T')[0];
        let fecha_hasta = new Date(this.getField("novedades_hasta").getValue()).toISOString().split('T')[0];

        this.getField("novedades_desde").setError(false, "");
        this.getField("novedades_hasta").setError(false, "");
        if (fecha_desde > fecha_actual) {
            this.getField("novedades_desde").setError(true, "No puede ser mayor a la fecha actual.");
            this.getField('aceptar_novedades').setDisabled(true);
            return false;
        }


        if (fecha_desde > fecha_hasta) {
            this.getField("novedades_hasta").setError(true, "No puede ser menor a la fecha desde.");
            this.getField('aceptar_novedades').setDisabled(true);
            return false;
        }
        this.getField('aceptar_novedades').setDisabled(false);
        return true;

    }

    ocultarNovedades(){
        this.getField('items_novedades').setVisible(false);
        this.getField('items_pedidos').setVisible(false);
        this.getField('rejilla10').toggle(false);
        this.getField('novedades_desde').setValue(this.fecha_hoy);
        this.getField('novedades_hasta').setValue(this.fecha_hoy);
    }

    mostrarNovedades(){
        this.getField('items_novedades').setVisible(true);
        this.getField('items_pedidos').setVisible(true);
        this.getField('rejilla10').toggle(false);
    }

    ocultarTrazabilidadReserva(){
        this.getField('ver_detalle').setVisible(false);
        this.getField('rejilla9').toggle(false);
    }

    mostrarTrazabilidadReserva(){
        this.getField('ver_detalle').setVisible(true);
        this.getField('rejilla9').toggle(false);
    }

    ocultarContados(){
        
        this.getField("bt_asentado_facturar").setVisible(false);
        this.getField("bt_asentado_remisionar").setVisible(false);
        this.getField("bt_asentado_trasladar").setVisible(false);
        this.getField("bt_asentado_recontar").setVisible(false);
        this.getField("bt_asentado_items").setVisible(false);
        this.getField("bt_asentado_pendiente").setVisible(false);
        this.getField("bt_asentado_detalle").setVisible(false);
            
        this.getField('rejilla7').toggle(false);
    }

    ocultarWmsContados(){
        
        this.getField("ver_pedido_wms").setVisible(false);
        this.getField('rejilla6').toggle(false);
    }

    ocultarWms02(){
        this.getField('rejilla5').toggle(false);
    }


    ocultarConsulta(){
        
        this.getField("ver_items").setVisible(false);
        this.getField('rejilla8').toggle(false);
    }

     //apartado novedades
     Traernovedades(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            sucursal : this.getField("sucursal").getValue(),
            radio_novedades:this.getField('radio_novedades').getValue(),
        }};
        if(this.getField('radio_novedades').getValue()==='T'){
            datos.datos.novedades_desde=this.getField('novedades_desde').getValue();
            datos.datos.novedades_hasta=this.getField('novedades_hasta').getValue();
        }
        this.generalFormatPmv = { tipo_servicio: 'traz-traznovedades', operacion: 'novedades', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraernovedades,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successTraernovedades(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField('modal_novedades_fechas').handleClose();
            this.mostrarNovedades();
            
            let configCell = new Map();
            this.gridOptionsComponentesNovedades['rowData'] = data.data;
            this.gridOptionsComponentesNovedades['onSelectionChanged'] = ()=>{
                this.row_novedades = [];
                this.row_novedades = this.gridOptionsComponentesNovedades.api.getSelectedRows();
            };

            configCell.set('sede', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.sede) }, cellStyle: {textAlign:"right"},width: 110});

            this.getField('rejilla10').initData(this.gridOptionsComponentesNovedades, configCell);
            this.habilitarBotonesAdicionales('');
        }else {
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    ItemsNovedades(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            npedido : this.row_novedades[0].pedido+'',
            consecutivo_picking : this.row_novedades[0].picking+'',
            xbodega : this.row_novedades[0].bodega+'',
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-traznovedades', operacion: 'itemsnovedades', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successItemsNovedades,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    ItemsNovedadesPedido(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            npedido : this.row_novedades[0].pedido+'',
            sucursal : this.row_novedades[0].codigo_sucursal+'',
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-traznovedades', operacion: 'itemspedido', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successItemsNovedades,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successItemsNovedades(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            if(this.tipo_items==='novedad')
                this.getField('modal_rejilla').setLabel("Items Novedades - Pedido No. " +this.row_novedades[0].pedido);
            else
                this.getField('modal_rejilla').setLabel("Items Pedido No. " +this.row_novedades[0].pedido);
            this.getField('modal_rejilla').handleClickOpen();
            
            
            let configCell = new Map();
            this.gridOptionsItems['rowData'] = data.data;

            configCell.set('cantidad_contada', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad_contada) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});

            this.getField('rejilla_items').initData(this.gridOptionsItems, configCell);
        }else {
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }


    //PANEL WMS CONTADOS

    wmsContados(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazwmscontados', operacion: 'wmscontados', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successWMSContados,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successWMSContados(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField("ver_pedido_wms").setVisible(true);
                
            let configCell = new Map();

            // Configura el evento de selección de filas
            this.gridOptionsWmsContados['onSelectionChanged'] = () => {
                this.row_wms_contados= [];
                this.row_wms_contados = this.gridOptionsWmsContados.api.getSelectedRows();
            };
            
            // Inicializa la tabla con los datos
            this.gridOptionsWmsContados['rowData'] = data.data;
            
            // Inicializa la rejilla con la configuración
            this.getField('rejilla6').initData(this.gridOptionsWmsContados, configCell);
        
        }else {
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    consultarContadosWMS(){ //conteo
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            npedido: this.row_wms_contados.numero_pedido,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazwmscontados', operacion: 'mostrarconteo', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successConsultarContadosWMS,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successConsultarContadosWMS(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField('modal_conteo_wms').handleClickOpen();
            
            let configCell = new Map();
            this.gridOptionsWmsConteo['rowData'] = data.data;
            this.getField('rejilla_conteo_wms').initData(this.gridOptionsWmsConteo, configCell);
        }else {
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    actualizarConteo(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            npedido: this.row_wms_contados.numero_pedido,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazwmscontados', operacion: 'actualizarconteo', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successActualizarConteo,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successActualizarConteo(data){
        if (data.estado_p === 200 ){
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
        }else {
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    consultarPedidosWms02(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            sucursal:this.getField('sucursal').getValue(),
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazwms02', operacion: 'pedidowms02', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successConsultarPedidosWms02,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successConsultarPedidosWms02(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
                
            let configCell = new Map();

            
            this.gridOptionsWms02['rowData'] = data.data;
            this.getField('rejilla5').initData(this.gridOptionsWms02, configCell);
        
        }else {
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    //apartado en picking

    traerPendientes(){
        //this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            sucursal:this.getField('sucursal').getValue(),
            xbodega: this.bodega ,
        }};
        this.getField("rejilla_pendientes").setTipoServicioOperacion('traz-trazenpicking-traerpendientes');
        this.getField("rejilla_pendientes").sendRequest(this.successTraerPendientes, datos);
    }

    successTraerPendientes(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField("modal_elegir_bodega").handleClose();
            this.getField('modal_pendientes').handleClickOpen();
            let configCell = new Map();

            
            this.gridOptionsPendientes['rowData'] = data.data.items;
            this.gridOptionsPendientes['onSelectionChanged'] = ()=>{
                this.row_pendientes = [];
                this.row_pendientes = this.gridOptionsPendientes.api.getSelectedRows();
            };
        
            const keys = Object.keys(data.data.items[0]);
            keys.forEach(key => {            
                configCell.set(key, { cellRenderer:(props) => { 
                    let fragment = document.createDocumentFragment();
                    if (key!=='factor' || key!=='sede' || key !=='items' || key !=='cantidad') {
                        let div = document.createElement("input");
                        div.setAttribute("id", `div_${props.data.id}`);
                        div.setAttribute("value",props.data[key]);
                        div.setAttribute("type","div");
                        fragment.appendChild(div);
                        return this.createElementJaivana(fragment);
                    }else {
                        let div = document.createElement("input");
                        div.setAttribute("id", `div_${props.data[key]}`);
                        div.setAttribute("value",this.currencyFormatterGeneral(props.data[key]));
                        div.setAttribute("type","div");
                        fragment.appendChild(div);
                        return this.createElementJaivana(fragment);
                    }
                 },
                cellStyle: function (props) {
                    let alineacion='left'
                    if(key==='factor' || key==='sede' || key==='items' || key==='cantidad' || key==='numero' || key==='pedido'){
                        alineacion='right';
                    }
                    if(props.data.factor.toString()!=='1')
                        return { textAlign: alineacion, color: "rgb(2, 2, 2)", height: '100%',cursor: 'default', border: 'none',backgroundColor: "rgb(0,143,57)" }
                    else{
                        return {textAlign: alineacion}
                    }
                        
                },maxWidth:1980 , suppressSizeToFit: true});
            });

            

            /*configCell.set('factor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.factor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('sede', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.sede) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('items', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.items) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('detalle', {maxWidth: 1980 });*/


            this.getField('rejilla_pendientes').initData(this.gridOptionsPendientes, configCell);
            if(data.data.codigo_sucursal!==undefined && data.data.codigo_sucursal.length>0){
                this.getField('sucursal').setValue(data.data.codigo_sucursal);
            }

            if((data.data.wms_nuevo!==undefined && data.data.wms_nuevo !=='S') || this.TRAZNOVEDAD===false){
                this.getField('bt_novedad').setDisabled(true);
            }else{
                this.getField('bt_novedad').setDisabled(false);
            }
        
        }else {
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    verPicking(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            sucursal:this.getField('sucursal').getValue(),
            xestado:this.xestado,
            consecutivo_picking:this.row_pendientes[0].numero+'',
            xbodega: this.bodega ,
        }};

        this.getField("rejilla4").setTipoServicioOperacion('traz-trazenpicking-verpicking');
        this.getField("rejilla4").sendRequest(this.successVerPicking, datos);
    }

    successVerPicking(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField('modal_pendientes').handleClose();
                
            this.mostrarEnPicking();
            let configCell = new Map();

            
            this.gridOptionsEnPicking['rowData'] = data.data.items;
            this.gridOptionsEnPicking['onSelectionChanged'] = ()=>{
                this.row_en_picking = [];
                this.row_en_picking = this.gridOptionsEnPicking.api.getSelectedRows();
            };

            configCell.set('factor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.factor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('sede', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.sede) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('items', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.items) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('detalle', {maxWidth: 1980 });
            configCell.set('direccion_entrega', {maxWidth: 1980 });
            configCell.set('nombre', {maxWidth: 1980 });
            configCell.set('numero', {cellRenderer:(props) => {return ""+props.data.numero }, cellStyle: {textAlign:"right"}});
            configCell.set('num_picking', {cellRenderer:(props) => {return ""+props.data.num_picking }, cellStyle: {textAlign:"right"}});

            this.getField('rejilla4').initData(this.gridOptionsEnPicking, configCell);

            
            if(data.data.titulo!==undefined){
                this.getField('titulo').setValue(data.data.titulo);
            }
            this.tipo_picking=data.data.tipo_picking;
            this.numero_picking=data.data.numero_picking;

            this.habilitarBotonesAdicionales(data.data.bodega_wms);
        }else {
            this.ocultarEnPicking();
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    ItemsEnPicking(){
        let datos={ datos: {
            sucursal:this.row_en_picking[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            pedido:this.row_en_picking[0].numero+'',
            factor:this.row_en_picking[0].factor,
            boton:this.xestado,//"02"
        }};
        this.getField("rejilla11").setTipoServicioOperacion('traz-trazpendientescartera-items');
        this.getField("rejilla11").sendRequest(this.successItemsEnPicking, datos);
    }

    successItemsEnPicking(data){
        if (data.estado_p === 200 ){ 

            this.getField("modal_ver_items").handleClickOpen();
            let configCell = new Map();
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('precio', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.precio) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: {textAlign:"right"}});
            configCell.set('valor_conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor_conteo) }, cellStyle: {textAlign:"right"}});
            configCell.set('cant_pedida', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_pedida) }, cellStyle: {textAlign:"right"}});
            configCell.set('detalle', {maxWidth: 1980 });

            this.gridOptionsComponentes3['onSelectionChanged'] = ()=>{
                this.selectedRows = [];
                this.selectedRows = this.gridOptionsComponentes3.api.getSelectedRows();
            };
            this.gridOptionsComponentes3['rowData'] = data.data;
            this.getField('rejilla11').initData(this.gridOptionsComponentes3, configCell);
            this.getField("modificar_detalle").setVisible(true);
            this.modificadetalle="DIENPICKING";
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    modificardetalleitemsEnPicking(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            detalle:this.getField("texto_detalle").getValue(),
            fdespacho:this.getField("fdespacho").getValue(),
            sucursal:this.row_en_picking[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            codigo:this.selectedRows[0].codigo,
            bodega:this.selectedRows[0].bodega,
            npedido:this.row_en_picking[0].numero+'',
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificadetalleitem', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successModificardetalleitemsEnPicking,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successModificardetalleitemsEnPicking(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){

            this.getField("modal_detalle").handleClose();
            this.ItemsEnPicking();
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    prepararReimprimir(){
        this.getField('modal_picking').handleClose();
        this.mostrarMensajeGuardando();
        let datos = { datos: {
            tipo_picking:this.tipo_picking,
            items: this.row_en_picking,
            sucursal_ingreso:this.sucursal_ingreso,
            sucursal:this.getField('sucursal').getValue(),
            xestado:this.xestado,
            xbodega:this.bodega,
            consecutivo_picking:this.numero_picking,

        }};
        if(this.pide_encargado){
            datos.datos.encargado=this.encargado;
            datos.datos.sede_encargado=this.sede_encargado;
            datos.datos.nombre_encargado=this.nombre_encargado;
        }

        this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'prepararreimprimir', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successPrepararEnPicking,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successPrepararEnPicking(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {
            //refrescar datos-------------->
            //ver items picking -->
            this.nombre_archivo='presentacion';
            if(data.data.imprimir!==undefined && data.data.imprimir===true){
                this.boton='en_picking';
                if(this.tipo_picking==='P' || this.tipo_picking==='V')
                    this.abrirImprimir();
                else{
                    //no imprime
                }
            }
        }else {
            this.getField('confirmModalCustom').toggle(false);
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos', 'error');
            }
            else {
              let respuesta=Object.values(data.data.errores);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    enviarNovedad(){
        if(this.getField('select_novedades').valid()){
            this.mostrarMensajeGuardando();
            let datos = { datos: {
                sucursal_ingreso: this.sucursal_ingreso,
                npedido: this.row_en_picking[0].numero+'',
                xbodega: this.row_en_picking[0].bodega,
                sucursal: this.row_en_picking[0].codigo_sucursal,
                consecutivo_picking: this.numero_picking,
                select_novedades: this.getField('select_novedades').getValue()+'',
            }};
            this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'enviarnovedad', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successEnviarNovedad,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }
    }

    successEnviarNovedad(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {   
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos', 'error');
            }
            else {
              let respuesta=Object.values(data.data.errores);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
        this.getField('modal_tipos_novedades').handleClose();
    }

    sacarPedido(){
        this.getField('modal_picking').handleClose();
        this.mostrarMensajeGuardando();
        let datos = { datos: {
            sucursal_ingreso: this.sucursal_ingreso,
            npedido: this.row_en_picking[0].numero+'',
            xbodega: this.row_en_picking[0].bodega,
            sucursal: this.row_en_picking[0].codigo_sucursal,
            consecutivo_picking: this.numero_picking,
            fecha: this.row_en_picking[0].fecha,

        }};

        this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'sacarpedido', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successSacarPedido,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });

    }

    successSacarPedido(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {   
            //lo comente porque aunque vayaa  cerrarpicking no realiza nada
            /*if(data.data.cerrar_picking!==undefined){
                this.preguntar=data.data.cerrar_picking;
                this.cerrarPicking();
            }*/
            this.mostrarMensajeAdicional("Proceso realizado con éxito.");
            this.getField('confirmModalCustom').toggle(false);
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Proceso realizado con éxito.');
            this.getField('confirmModalCustom').setClickDialog(() => { 
                this.getField('confirmModalCustom').toggle(false); 
                //refrescar con el picking nuevo
                this.verPicking();
            });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false); });
            this.getField("confirmModalCustom").setVisibleConfirm(false); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
            this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
            this.getField('confirmModalCustom').toggle(true);

           
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos', 'error');
            }
            else {
              let respuesta=Object.values(data.data.errores);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    cerrarPicking(){
        //this.getField('modal_picking').handleClose();
        this.mostrarMensajeGuardando();
        let datos = { datos: {
            sucursal_ingreso: this.sucursal_ingreso,
            xbodega: this.bodega,//es lo mismo que BODEGA_PICK, ya que enla tabla principal solo traen pedido con esta bodega
            consecutivo_picking: this.numero_picking,
            cerrar_pedido:true,
            xestado:this.xestado,
        }};

        this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'cerrarpicking', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successCerrarPicking,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });

    }

    successCerrarPicking(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {   
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            this.ocultarEnPicking();
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            //this.verPicking();
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos', 'error');
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    cerrarUno(){
        this.mostrarMensajeGuardando();

        let datos = { datos: {
            sucursal_ingreso: this.sucursal_ingreso,
            xbodega: this.row_en_picking[0].bodega,//es lo mismo que BODEGA_PICK, ya que enla tabla principal solo traen pedido con esta bodega
            consecutivo_picking: this.numero_picking,
            cerrar_pedido:true,
            xestado:this.xestado,
            estado_pedido:this.row_en_picking[0].estado,
            npedido:this.row_en_picking[0].numero+'',
            sucursal:this.row_en_picking[0].codigo_sucursal,
            fecha:this.row_en_picking[0].fecha,
            nit_aux:this.row_en_picking[0].nit,
            sede_aux:this.row_en_picking[0].sede+'',
        }};

        this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'cerraruno', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successCerrarUno,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });

    }

    successCerrarUno(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 )
        {   
            if(data.data.mensaje_mostrar!==undefined){
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false);
                    this.verPicking();
                });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleConfirm(false); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
                this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.verPicking();
            }

        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos', 'error');
            }
            else {
              let respuesta=Object.values(data.data.errores);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    validarRangos(){
        this.getField('desde_item').setError(false,'');
        this.getField('hasta_item').setError(false,'');
        this.getField('aceptar_rangos').setDisabled(false);
        if(this.getField('desde_item').getValue().toString()!=='' || this.getField('hasta_item').getValue().toString()!==''){
            let regex = new RegExp("^[0-9]+$");

            if (!regex.test(this.getField('hasta_item').getValue()))
                this.getField("desde_item").setError(true,"* El valor no cumple con el formato deseado");
            if (!regex.test(this.getField('hasta_item').getValue()))
                this.getField("hasta_item").setError(true,"* El valor no cumple con el formato deseado");

            if (regex.test(this.getField('desde_item').getValue())) {
                if (Number(this.getField('desde_item').getValue())>=0) {
                    if (Number(this.getField('desde_item').getValue())<=9999) {
                        //continua
                    }else{
                        this.getField("desde_item").setError(true,"* El valor máximo permitido es: 9999");
                        return false;
                    }
                }else{
                    this.getField("desde_item").setError(true,"* El valor mínimo permitido es: 0");
                    return false;
                }
            
            }else{
                this.getField("desde_item").setError(true,"* El valor no cumple con el formato deseado");
                return false;
            }

            if (regex.test(this.getField('hasta_item').getValue())) {
                if (Number(this.getField('hasta_item').getValue())>=0) {
                    if (Number(this.getField('hasta_item').getValue())<=9999) {
                        //continua
                    }else{
                        this.getField("hasta_item").setError(true,"* El valor máximo permitido es: 9999");
                        return false;
                    }
                }else{
                    this.getField("hasta_item").setError(true,"* El valor mínimo permitido es: 0");
                    return false;
                }
            
            }else{
                this.getField("hasta_item").setError(true,"* El valor no cumple con el formato deseado");
                return false;
            }

            if(this.getField('desde_item').getValue() > this.getField('hasta_item').getValue()){
                this.getField("hasta_item").setError(true,"El valor desde debe ser menor o igual que el valor hasta.");
                this.getField('aceptar_rangos').setDisabled(true);
                return false;
            }
            else if(this.getField('hasta_item').getValue() < this.getField('desde_item').getValue()){
                this.getField("hasta_item").setError(true,"El valor desde debe ser menor o igual que el valor hasta.");
                this.getField('aceptar_rangos').setDisabled(true);
                return false;
            }
        }
        return true;
    }

    validarPedidoRangos(){
        this.getField('pedido_rangos').setError(false,'');
        this.getField('aceptar_rangos').setDisabled(false);
        if(this.getField('pedido_rangos').getValue().toString()!==''){
            let regex = new RegExp("^[0-9]+(\u002C[0-9]+)*$");

            if (!regex.test(this.getField('pedido_rangos').getValue()))
                this.getField("pedido_rangos").setError(true,"* El valor no cumple con el formato deseado");

            if (regex.test(this.getField('pedido_rangos').getValue())) {
                if (this.getField('pedido_rangos').getValue().length>=0) {
                    if (this.getField('pedido_rangos').getValue().length<=250) {
                        //continua
                    }else{
                        this.getField("pedido_rangos").setError(true,"* El valor debe estar entre las longitudes (0,250)");
                        return false;
                    }
                }else{
                    this.getField("pedido_rangos").setError(true,"* El valor debe estar entre las longitudes (0,250)");
                    return false;
                }
            
            }else{
                this.getField("pedido_rangos").setError(true,"* El valor no cumple con el formato deseado");
                return false;
            }
        }
        return true;
    }


    asentarCantidades(){
        //this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            pedido_rangos:this.getField('pedido_rangos').getValue(),
            desde_item:this.getField('desde_item').getValue(),
            hasta_item:this.getField('hasta_item').getValue(),
            consecutivo_picking:this.numero_picking,
            xbodega: this.bodega,
        }};

        if(this.getField('desde_item').getValue().toString()==='' && this.getField('hasta_item').getValue().toString()===''){
            datos.datos.desde_item=0;
            datos.datos.hasta_item=9999;
        }

        this.getField("rejilla_digitar").setTipoServicioOperacion('traz-trazenpicking-digitar');
        this.getField("rejilla_digitar").sendRequest(this.successAsentarCantidadess, datos);
    }

    asentarCantidadesPag(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            pedido_rangos:this.getField('pedido_rangos').getValue(),
            desde_item:this.getField('desde_item').getValue(),
            hasta_item:this.getField('hasta_item').getValue(),
            consecutivo_picking:this.numero_picking,
            xbodega: this.bodega,
            sql_filter:'OFFSET 0 LIMIT 15',
        }};

        if(this.getField('desde_item').getValue().toString()==='' && this.getField('hasta_item').getValue().toString()===''){
            datos.datos.desde_item=0;
            datos.datos.hasta_item=9999;
        }
        
        this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'digitar_pag', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successAsentarCantidadess,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: true
        });
    }

    

    successAsentarCantidadess(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            //this.getField('modal_digitar_items').setLabel(data.data.titulo);
            if(data.data.existe_tabla===false)
                this.getField('modificar_detalle_digitar').setVisible(true);
            this.getField("modal_digitar_items").setLabel(data.data.titulo);
            this.getField("modal_digitar_items").handleClickOpen();
            
            let configCell = new Map();
            configCell.set('cant_pedida', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_pedida) }, cellStyle: {textAlign:"right"}});
            configCell.set('conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: {textAlign:"right"}});
            configCell.set('saldo_bodega', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo_bodega) }, cellStyle: {textAlign:"right"}});

            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"}});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"}});
            configCell.set('disponible', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.disponible) }, cellStyle: {textAlign:"right"}});
            configCell.set('cant_compras', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_compras) }, cellStyle: {textAlign:"right"}});
            configCell.set('cant_pedidos', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_pedidos) }, cellStyle: {textAlign:"right"}});
            configCell.set('indice', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.indice) }, cellStyle: {textAlign:"right"}});
            configCell.set('detalle', {maxWidth: 1980 });
            configCell.set('nombre', {maxWidth: 1980 });
            configCell.set('numero', {cellRenderer:(props) => {return ""+props.data.numero }, cellStyle: {textAlign:"right"}});

            
            this.gridOptionsItemsDigitar['onSelectionChanged'] = ()=>{
                this.row_items_digitar = [];
                this.row_items_digitar = this.gridOptionsItemsDigitar.api.getSelectedRows();
            };
            this.gridOptionsItemsDigitar['rowData'] = data.data.items;
            this.getField('rejilla_digitar').initData(this.gridOptionsItemsDigitar, configCell);
            this.modificadetalle = "DIDIGITAR"
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    
    modificarDetalleDigitar(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            detalle:this.getField("texto_detalle").getValue(),
            fdespacho:this.getField("fdespacho").getValue(),
            sucursal:this.row_items_digitar[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            codigo:this.row_items_digitar[0].codigo,
            bodega:this.row_items_digitar[0].bodega,
            npedido:this.row_items_digitar[0].numero
        }};

        this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'modificadetalleitemdigitar', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successModificarDetalleDigitar,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: true
        });
    }

    successModificarDetalleDigitar(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField("modal_detalle").handleClose();
            //this.asentarCantidades();//para que refresque la tabla anterior
            this.asentarCantidadesPag();
        }else {
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    modificarCantidadConteo(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            items: this.row_items_digitar,
            consecutivo_picking:this.numero_picking,
            xbodega: this.row_items_digitar[0].bodega,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'modificarcantidadconteo', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successModificarCantidadConteo,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false,
        });
    }

    successModificarCantidadConteo(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            if(data.data.pedir_cantidad){
                this.getField("modal_modificar_cantidad").setLabel('Pedido No. '+this.row_items_digitar[0].numero);
                this.getField("modal_modificar_cantidad").handleClickOpen();

                this.getField('titulo_label').setValue("Ingrese el conteo de " + this.row_items_digitar[0].codigo + "-" + this.row_items_digitar[0].nombre+ ".")
                this.getField("nueva_cantidad").setValue(this.row_items_digitar[0].conteo);
            }else if(data.data.pedir_cantidad_combos){
                this.traerItemsCombos();
            }else{
                if(data.data.mensaje_mostrar){
                    this.getField('confirmModalCustom').toggle(false);
                    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                    this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false);
                        this.getField('confirmModalCustom').toggle(false);
                        this.getField('modal_modificar_cantidad').handleClose();
                        this.getField('modal_modificar_cantidad_combos').handleClose();
                        //this.asentarCantidades();//para que refresque la tabla anterior
                        this.asentarCantidadesPag();
                    });
                    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false); });
                    this.getField("confirmModalCustom").setVisibleConfirm(false); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
                    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
                    this.getField('confirmModalCustom').toggle(true);
                }else{
                    this.alertGeneral.toggle(true, 'Cantidad modificada con éxito.', 'success');
                    this.getField('modal_modificar_cantidad').handleClose();
                    this.getField('modal_modificar_cantidad_combos').handleClose();
                    //this.asentarCantidades();//para que refresque la tabla anterior
                    this.asentarCantidadesPag();
                }
            }
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            else{
                if(data.estado_p===404) {
                    this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
                }
                else {
                    let respuesta=Object.values(data.data.errores);
                    this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
                }
            }
        }
    }

    traerItemsCombos(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            items: this.row_items_digitar,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'itemscombos', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerItemsCombos,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: true
        });
    }

    successTraerItemsCombos(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField('modal_modificar_cantidad_combos').handleClickOpen();

            this.getField('codigo_combo').setValue(this.row_items_digitar[0].codigo);
            this.getField('nombre_combo').setValue(this.row_items_digitar[0].nombre);
            this.getField('nueva_cantidad_combos').setValue(this.row_items_digitar[0].conteo);

            let configCell = new Map();
            configCell.set('cantidad_por_unidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad_por_unidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('cantidad_contada', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad_contada) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('costo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.costo) }, cellStyle: {textAlign:"right"},width: 110});

            this.gridOptionsModCantidadCombos['rowData'] = data.data;
            this.getField('rejilla_combos').initData(this.gridOptionsModCantidadCombos, configCell);
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    modificarBodega(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            items: this.row_items_digitar,
            consecutivo_picking:this.numero_picking,
            bodegas: this.bodega_aux,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazenpicking', operacion: 'modificarbodega', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successmodificarBodega,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: true
        });
    }

    successmodificarBodega(data){
        if (data.estado_p === 200 ){
            this.getField("modal_elegir_bodega").handleClose();
            //this.asentarCantidades();//para que refresque la tabla anterior
            this.asentarCantidadesPag();
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    ocultarEnPicking(){
        this.getField('rejilla4').toggle(false);
        this.getField('bt_digitar').setVisible(false);
        this.getField('bt_cerrar').setVisible(false);
        this.getField('bt_repicking').setVisible(false);
        this.getField('bt_cerrar_uno').setVisible(false);
        this.getField('bt_reimprimir').setVisible(false);
        this.getField('bt_items').setVisible(false);
        this.getField('bt_novedad').setVisible(false);
    }

    mostrarEnPicking(){
        this.getField('bt_digitar').setVisible(true);
        this.getField('bt_cerrar').setVisible(true);
        this.getField('bt_repicking').setVisible(true);
        this.getField('bt_cerrar_uno').setVisible(true);
        this.getField('bt_reimprimir').setVisible(true);
        this.getField('bt_items').setVisible(true);
        this.getField('bt_novedad').setVisible(true);
    }


    //apartado AUTORIZADOS INVENTARIO

    traerAutorizadosInventario(){
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso : this.sucursal_ingreso,
            sucursal:this.getField('sucursal').getValue(),
            xbodega: this.bodega ,
            xestado: this.xestado ,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadosinventario', operacion: 'noautorizados', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerAutorizadosInventario,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successTraerAutorizadosInventario(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField("modal_elegir_bodega").handleClose();
            this.mostrarAutorizadosInventario();
            let configCell = new Map();

            data.data.items.forEach(item => {            
                // Obtener las claves del objeto `item`
                const keys = Object.keys(item);
            
                // Iterar sobre cada clave del objeto `item`
                keys.forEach(key => {            
                    configCell.set(key, {
                        Width: 120
                    });
                });
            });

            this.arrayseleccion = data.data.items;

            // Array para almacenar los registros seleccionados
            this.row_autorizados_inventario = [];
            
            // Configura la función para alternar el valor de la celda y gestionar el array
            this.toggleCellValueInRow = (rowNode, columnName) => {
                const currentValue = rowNode.data[columnName];
                const newValue = currentValue === true ? false : true; // Alterna entre true y false
            
                // Actualiza el valor de la columna en la fila
                rowNode.setDataValue(columnName, newValue);
            
                // Actualiza la fila en la tabla
                this.gridOptionsAutorizadosInventario.api.applyTransaction({ update: [rowNode.data] });
            
                // Maneja el array de filas seleccionadas
                if (newValue === false) {
                    // Elimina la fila del array si el valor se convierte en false
                    this.selectedRowsArray = this.selectedRowsArray.filter(row => row.numero !== rowNode.data.numero);
                } else if (!this.selectedRowsArray.some(row => row.numero === rowNode.data.numero)) {
                    // Añade la fila al array si el valor es true y no está ya en el array
                    this.selectedRowsArray.push(rowNode.data);
                }
            };
            
            // Configura el evento de selección de filas
            this.gridOptionsAutorizadosInventario['onSelectionChanged'] = () => {
                this.selectedRows2= [];
                // Actualiza selectedRows2 con las filas actualmente seleccionadas
                this.selectedRows2 = this.gridOptionsAutorizadosInventario.api.getSelectedRows();
                
                // Actualiza el array de registros seleccionados basado en la selección actual
                this.selectedRowsArray = [];
                this.selectedRows2.forEach(row => {
                    const isSelected = row['x'] === true;
                    if (isSelected) {
                        // Añade la fila al array si está seleccionada y no está ya en el array
                        if (!this.selectedRowsArray.some(selected => selected.numero === row.numero)) {
                            this.selectedRowsArray.push(row);
                        }
                    }
                });
            };
            
            // Configura el evento de clic en cualquier celda
            this.gridOptionsAutorizadosInventario['onCellClicked'] = (event) => {
                const columnName = 'x'; // Reemplaza 'x' con el ID de la columna que deseas actualizar
            
                // Obtiene el nodo de fila correspondiente
                const rowNode = event.node;
            
                // Alterna el valor en la columna específica de la fila clicada
                this.toggleCellValueInRow(rowNode, columnName);

                // Actualiza selectedRowsArray si se ha cambiado el valor de la celda
                this.selectedRows2 = this.gridOptionsAutorizadosInventario.api.getSelectedRows();
                this.selectedRowsArray = this.selectedRows2.filter(row => row[columnName] === true);
            };
            
            // Inicializa la tabla con los datos
            this.gridOptionsAutorizadosInventario['rowData'] = data.data.items;


            configCell.set('factor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.factor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('sede', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.sede) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('items', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.items) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});

            this.getField('rejilla3').initData(this.gridOptionsAutorizadosInventario, configCell);
            if(data.data.codigo_sucursal!==undefined && data.data.codigo_sucursal.length>0){
                this.getField('sucursal').setValue(data.data.codigo_sucursal);
            }

            if (this.wms_nuevo==='S' && data.data!==undefined && data.data.bodega_wms==='S') {
                this.getField('llevar_picking').setVisible(true);
                if (this.autorizados_inventario) {
                    this.getField('bt_autorizar_inventario').setVisible(false);
                    this.getField('bt_retornar_reserva').setVisible(true);
                    this.getField('bt_consultar_reserva').setVisible(true);
                    if (this.picking_reserva==='S') 
                        this.getField('llevar_picking').setVisible(false);
                } else {
                    this.getField('llevar_picking').setVisible(false);
                    this.getField('bt_autorizar_inventario').setVisible(true);
                    this.getField('bt_retornar_reserva').setVisible(false);
                    this.getField('bt_consultar_reserva').setVisible(false);
                }
            }
            this.habilitarBotonesAdicionales(data.data.bodega_wms);
        }else {
            this.ocultarAutorizadosInventario();
             this.getField('rejilla3').toggle(false)
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            }
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    mostrarAutorizadosInventario(){
        this.getField('bt_llevar_picking').setVisible(true);
        this.getField('bt_items_inventario').setVisible(true);
        this.getField('bt_pendiente_inventario').setVisible(true);
        this.getField('bt_detalle_inventario').setVisible(true);
    }

    ocultarAutorizadosInventario(){
        this.getField('rejilla3').toggle(false);
        this.getField('bt_llevar_picking').setVisible(false);
        this.getField('bt_items_inventario').setVisible(false);
        this.getField('bt_pendiente_inventario').setVisible(false);
        this.getField('bt_detalle_inventario').setVisible(false);
        this.getField('bt_retornar_reserva').setVisible(false);
        this.getField('bt_consultar_reserva').setVisible(false);
    }

    modificarDetalleAutorizadosInventario(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            detalle:this.getField("texto_detalle").getValue(),
            fdespacho:this.getField("fdespacho").getValue(),
            sucursal:this.selectedRows2[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            estado:this.selectedRows2[0].estado,
            npedido:this.selectedRows2[0].numero
        }};

        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificadetalle', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successModificarDetalleAutorizadosInventario,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: true
        });
    }

    successModificarDetalleAutorizadosInventario(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField("modal_detalle").handleClose();
            this.traerAutorizadosInventario();//para que refresque la tabla anterior
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    pendienteAutorizadosInventario(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            bodega:this.selectedRows2[0].bodega,
            pedido:this.selectedRows2[0].numero,
            sucursal:this.selectedRows2[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            sede:this.selectedRows2[0].sede,
            nit:this.selectedRows2[0].nit,
            detalle:this.selectedRows2[0].detalle,
            fecha:this.selectedRows2[0].fecha,
            estado:this.xestado,
            estado_pedido:this.selectedRows2[0].estado,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadoscartera', operacion: 'devolverpendiente', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successPendienteAutorizadosInventario,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successPendienteAutorizadosInventario(data){
        if (data.estado_p === 200 ){
            if(data.data.mensaje!==undefined){
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje);
                this.getField('confirmModalCustom').setClickDialog(() => { 
                    this.getField('confirmModalCustom').toggle(false);
                    this.traerAutorizadosInventario();
                 });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.traerAutorizadosInventario();
            }
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    ItemsAutorizadosInventario(){
        let datos={ datos: {
            sucursal:this.selectedRows2[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            pedido:this.selectedRows2[0].numero,
            factor:this.selectedRows2[0].factor,
            boton:"03"
        }};
        this.getField("rejilla11").setTipoServicioOperacion('traz-trazpendientescartera-items');
        this.getField("rejilla11").sendRequest(this.successItemsAutorizadosInventario, datos);

    }

    successItemsAutorizadosInventario(data){
        if (data.estado_p === 200 ){ 

            this.getField('modal_ver_items').setLabel("Pedido No. "+this.selectedRows2[0].numero + " Cliente: " + this.selectedRows2[0].nit + " Sede " + this.selectedRows2[0].sede + " " + this.selectedRows2[0].nombre + " Valor: $"+this.currencyFormatterGeneral(this.selectedRows2[0].valor))
            this.getField("modal_ver_items").handleClickOpen();
            let configCell = new Map();
            configCell.set('cantidad', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('precio', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.precio) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.conteo) }, cellStyle: {textAlign:"right"}});
            configCell.set('valor_conteo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral4Decimales(props.data.valor_conteo) }, cellStyle: {textAlign:"right"}});
            configCell.set('cant_pedida', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_pedida) }, cellStyle: {textAlign:"right"}});
            configCell.set('detalle', {maxWidth: 1980 });
            
            this.gridOptionsComponentes3['onSelectionChanged'] = ()=>{
                this.row_items = [];
                this.selectedRows = this.gridOptionsComponentes3.api.getSelectedRows();
            };
            this.gridOptionsComponentes3['rowData'] = data.data;
            this.getField('rejilla11').initData(this.gridOptionsComponentes3, configCell);
            this.getField("modificar_detalle").setVisible(true);
            this.modificadetalle="DIAINVENTARIO";
        
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    modificarDetalleAutorizadosInventarioItems(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            detalle:this.getField("texto_detalle").getValue(),
            fdespacho:this.getField("fdespacho").getValue(),
            sucursal:this.selectedRows2[0].codigo_sucursal,
            codigo_usuario:this.codigo_usuario,
            codigo:this.selectedRows[0].codigo,
            bodega:this.selectedRows[0].bodega,
            npedido:this.selectedRows2[0].numero+'',
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazpendientescartera', operacion: 'modificadetalleitem', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successModificarDetalleAutorizadosInventarioItems,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successModificarDetalleAutorizadosInventarioItems(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField("modal_detalle").handleClose();
            this.ItemsAutorizadosInventario();
        }else {
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    habilitarBotonesAdicionales(bodega_wms){
        if(this.TRAUTO===true)
            this.getField('autorizar').setVisible(true);
        else if(this.TRCERRARP===true){
            if (this.wms_nuevo==='S' && bodega_wms==='S')
                this.getField('bt_cerrar').setVisible(true);
        }else if(this.TRASLADAR===true)
            this.getField('bt_asentado_trasladar').setVisible(true);
        
    }

    autorizarInventario(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            detalle_autorizado:this.getField("detalle_autorizado").getValue(),
            sucursal_ingreso:this.sucursal_ingreso,
            items:this.selectedRows2,
        }};

        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadoscartera', operacion: 'autorizarinventario', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successAutorizarInventario,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: true
        });
    }

    successAutorizarInventario(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            this.getField('detalle_autorizar').handleClose();
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.recargarInfo();
                });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm('OK'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.recargarInfo();
            }
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    retornarReserva(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            items:this.selectedRows2,
        }};

        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadosinventario', operacion: 'retornarreserva', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successRetornarReservao,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: true
        });
    }

    successRetornarReservao(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.recargarInfo();
                });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm('OK'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.recargarInfo();
            }
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    traerItemsReserva(){
        this.row_items_reservados=[];
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            items:this.selectedRows2,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadosinventario', operacion: 'consultarreserva', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerItemsReserva,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successTraerItemsReserva(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){ 
            this.getField("modal_consultar_reserva").setLabel('Pedido No. ' + this.selectedRows2[0].numero);
            this.getField("modal_consultar_reserva").handleClickOpen();
            let configCell = new Map();

            configCell.set('cantidad_reservada', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad_reservada) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('cantidad_pedida', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantidad_pedida) }, cellStyle: {textAlign:"right"},width: 110});

            this.gridOptionsItemsReservados['onSelectionChanged'] = ()=>{
                this.row_items_reservados = this.gridOptionsItemsReservados.api.getSelectedRows();
            };
            this.gridOptionsItemsReservados['rowData'] = data.data;
            this.getField('rejilla_items_reservados').initData(this.gridOptionsItemsReservados, configCell);
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    retornarItem(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            items:this.row_items_reservados,
            npedido:this.selectedRows2[0].numero,
            sucursal:this.selectedRows2[0].codigo_sucursal,
        }};

        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadosinventario', operacion: 'retornaritem', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successRetornarItem,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: true
        });
    }

    successRetornarItem(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.traerItemsReserva();
                });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm('OK'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.traerItemsReserva();
            }
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    verPedidoReservado(){
        this.row_pedido_reservado=[];
        this.mostrarMensajeGenerando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            xbodega:this.row_items_reservados[0].codigo_bodega,
            npedido:this.selectedRows2[0].numero,
            codigo_articulo:this.row_items_reservados[0].codigo_real,
        }};
        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadosinventario', operacion: 'traerpedidoreservados', operacion_tipo: 'consulta' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerPedidoReservado,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: false
        });
    }

    successVerPedidoReservado(data){
        if (data.estado_p === 200 ){ 
            this.getField("modal_items_pedidos_reservados").setLabel("PEDIDOS CON EL ÍTEM: " + this.row_items_reservados[0].codigo_real + " - " +  this.row_items_reservados[0].nombre + " EN LA BODEGA: " +  this.row_items_reservados[0].codigo_bodega);
            this.getField("modal_items_pedidos_reservados").handleClickOpen();
            let configCell = new Map();

            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('cant_pedido', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_pedido) }, cellStyle: {textAlign:"right"},width: 110});
            configCell.set('reservado', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.reservado) }, cellStyle: {textAlign:"right"},width: 110});

            this.gridOptionsPedidosItemsReservados['onSelectionChanged'] = ()=>{
                this.row_pedido_reservado = this.gridOptionsPedidosItemsReservados.api.getSelectedRows();
            };
            this.gridOptionsPedidosItemsReservados['rowData'] = data.data;
            this.getField('rejilla_pedidos_items_reservados').initData(this.gridOptionsPedidosItemsReservados, configCell);
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.mostrarMensajeNoHayDatos();
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    retornarReservaPedido(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            items:this.row_items_reservados,
            codigo_articulo:this.row_items_reservados[0].codigo_real,
            xbodega:this.row_items_reservados[0].codigo_bodega,
        }};

        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadosinventario', operacion: 'retornaritempedido', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successRetornarReservaPedido,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: true
        });
    }

    successRetornarReservaPedido(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.verPedidoReservado();
                });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm('OK'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.verPedidoReservado();
            }
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    reasignar(){
        this.mostrarMensajeGuardando();
        let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            items:this.row_items_reservados,
            codigo_articulo:this.row_items_reservados[0].codigo_real,
            npedido:this.selectedRows2[0].numero, //pedido destino
            xbodega: this.row_items_reservados[0].codigo_bodega,
        }};

        this.generalFormatPmv = { tipo_servicio: 'traz-trazautorizadosinventario', operacion: 'reasignar', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successReasignar,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage: true
        });
    }

    successReasignar(data){
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200 ){
            if(data.data.mensaje_mostrar!==undefined){
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').toggle(false);
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', data.data.mensaje_mostrar);
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.verPedidoReservado();
                });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm('OK'); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField("confirmModalCustom").setClickCancelDialog (()=>{ this.getField('confirmModalCustom').toggle(false);});
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.verPedidoReservado();
            }
        }else {
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje_mostrar);
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            }
            else {
                let respuesta=Object.values(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    validarfechasEditarPedido() {
        let fecha_actual = new Date().toISOString().split('T')[0];
        let fecha_entrega = new Date(this.getField("fentrega").getValue()).toISOString().split('T')[0];
        let fecha_validez = new Date(this.getField("fvalidez").getValue()).toISOString().split('T')[0];

        this.getField("fentrega").setError(false, "");
        this.getField("fvalidez").setError(false, "");
        let fallo=false;
        if (fecha_entrega < fecha_actual) {
            this.getField("fentrega").setError(true, "Fecha entrega debe ser mayor a la fecha actual.");
            fallo =true;
        }

        if (fecha_validez < fecha_actual) {
            this.getField("fvalidez").setError(true, "Fecha validez debe ser mayor a la fecha actual.");
            fallo =true;
        }
        if(!fallo){
            if (fecha_validez > fecha_entrega) {
                this.getField("fvalidez").setError(true, "Fecha validez debe ser menor o igual a la fecha de entrega.");
                fallo =true;
            }
        }
        return !fallo;

    }

    onSelectionEditarPedido(){

    }


}
FormJaivana.addController("traz-trazpendientescartera", CustomTrazabilidad);
export default CustomTrazabilidad;    